import { Component, OnInit, OnDestroy, DoCheck } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule, UntypedFormControl } from '@angular/forms';
import { ActivatedRoute, Router, RouterLink, RouterModule } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatSelectModule } from '@angular/material/select';
import { MatOptionModule } from '@angular/material/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { NgxPaginationModule } from 'ngx-pagination';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { SortPipe } from '../_helpers/sort.pipe';
import { LazyLoadImgDirective } from '../_helpers/lazy-load-img.directive';
import { HelpsectionComponent } from '../helpsection/helpsection.component';
import { SuppliertabComponent } from '../suppliertab/suppliertab.component';
import { PagerService } from '../_service/pager-service';
import { Subject } from 'rxjs';
import { appConfig, online, baseUrl, dev, intLan, intUrl, localUrl, opeUrl, shareLan, pdf, pdf1, guidecompanyLink, opewafUrl,opeNewwafUrl } from '../app.config';
import { takeUntil, debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { CommonService } from '../_service/common.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { SupplierService } from '../_service/supplier.service';
import { purchasingApiService } from '../_service/purchasing.service';
import { SitesService } from '../_service/sites.service';
import { CountryService } from '../_service/country.service';
import { AddressService } from '../_service/address.service';
import { K2Service } from '../_service/K2.service';
import { ArcaService } from '../_service/arca.service';
import { ContactsService } from '../_service/contacts.service';
import { DocumentsService } from '../_service/documents.service';
import { BrowserTitleService } from '../_service/browser-title.service';

const TWO = 2;
const FIVE = 5;
const SIX = 6;
const SEVEN = 7;
const NINE = 9;
const TEN = 10;
const TWENTY = 20;
const THIRTY = 30;
const THIRTY_FIVE = 35;
const ONE_HUNDRED_TWENTY = 120;
const ONE_HUNDRED_SEVEN = 107;
const ONE_HUNDRED_SEVENTY = 170;
const TWO_HUNDRED_NINETY = 290;
const DEBOUNCE_MS = 400;
const THREE_HUNDRED_MS = 300;
const FIVE_HUNDRED_FIFTY = 550;
const ONE_SECOND_MS = 1000;
const FIFTEEN_HUNDRED_MS = 1500;
const TWO_THOUSAND_MS = 2000;
const TWENTY_FIVE_HUNDRED_MS = 2500;
const THREE_THOUSAND_MS = 3000;
const EIGHT_THOUSAND_MS = 8000;
const SECONDS_PER_HOUR = 3600;
const HOURS_PER_DAY = 24;

@Component({
    selector: 'app-supplier-group-details',
    templateUrl: './supplier-group-details.component.html',
    styleUrls: ['./supplier-group-details.component.css'],
    standalone: true,
    imports: [
        CommonModule, FormsModule, ReactiveFormsModule, RouterLink, RouterModule,
        MatIconModule, MatFormFieldModule, MatInputModule, MatAutocompleteModule,
        MatSelectModule, MatOptionModule, MatTooltipModule, MatProgressSpinnerModule,
        MatProgressBarModule, MatSnackBarModule, NgxPaginationModule, NgSelectModule,
        NgbModule, NgxMatSelectSearchModule, SortPipe, LazyLoadImgDirective,
        HelpsectionComponent, SuppliertabComponent
    ]
})
export class SupplierGroupDetailsComponent implements OnInit, OnDestroy, DoCheck {
  private ngUnsubscribe = new Subject();
  onInitLoad = false;
  onfirstTimeload = true;
  onInitLoadCompany = false;
  onfirstTimeloadCompany = true;
  modalVisible = false;
  title = 'Renault Digital frontend';
  myControl = new UntypedFormControl();
  loading: boolean = false;
  loading1: boolean = true;
  loading2: boolean = false;
  prospectpanel: boolean = false;
  commodityCodeFlag: boolean = false;
  fsaCodeFlag: boolean = false;
  panelCodeFlag: boolean = false;
  commodityTypeFlag: boolean = false;
  panelCCode = [];
  panelCDataList = '';
  commodityTypes = '';
  fsaCCode = [];
  fsaCDataList = '';
  groupPwosPanel = [];
  groupPwosFamily = [];
  commodityCodearr: any = {};
  commodityCodeDetailsByRow: any = [];
  commodityCodeDetails = [];
  userGuideUrl = guidecompanyLink;
  Config: any;
  groupId: any;
  Http_URL: string;
  Info: any;
  closeBtn;
  saveDatas: any = "Save";
  removeDatas: any = "Remove";
  archiveDatas: any = "Archive";
  groupName: any = 'Updating...';
  groupAllianceIdentifier: any = 'Updating...';
  groupTypeCode: any = 'Updating...';
  groupModificationStatus: any = 'Updating...';
  groupNameModelExistsval: any = '';
  groupStatusModelExistsval: any = '';
  groupingStatusModelExistsval: any = '';
  groupNameModelvalerror: boolean = false;
  groupStatusModelvalerror: boolean = false;
  groupingStatusModelvalerror: boolean = false;
  commodityCodeModelval: any = '';
  commodityCodeModelvalLabel: any = '';
  groupIdentifierModelval: any = '';
  groupIdentifierValModelval: any = '';
  commodityCodeModelvalerror: boolean = false;
  groupIdentifierModelvalerror: boolean = false;
  groupIdentifierValModelvalerror: boolean = false;
  moveProspectValModelvalerror: boolean = false;
  showGroupContactsBlock: boolean = false;
  commodityCodeScopeRowid: any = '';
  commodityCodeScopeArchiveRowid: any = '';
  public groupAlias: any = [];
  public companyIdentifiers: any = [];
  public businessEntyties: any = [];
  public commodityCodes: any = [];
  public companyCodes: any = [];
  public companyCodeids: any = [];
  public commodityCodeids: any = [];
  public groupNameModelval: any = '';
  public groupStatusModelval: any = '';
  public groupingStatusModelval: any = '';
  public groupingStatusExistsModelval: any = '';
  public groupingStatusIdModelval: any = '';
  public groupPanelRemoveIdModelval: any = '';
  public groupProspectMoveIdModelval: any = '';
  public moveGroupProspectModelval: any = '';
  public groupProspect: any = [];
  public groupPanel: any = [];

  public groupProspect1: any = [];
  public groupPanel1: any = [];

  public groupPwos: any = [];
  public companyGroupSection: any = [];
  public companyGroupSectionIDS: any = [];

  public groupIdentifierKeys: any = [];
  public groupIdentifierKeyname: any = [];
  public contactGroupSection: any = [];
  public contactEmailGroupSection: any = [];
  public contactTelephoneGroupSection: any = [];
  public contactcellphoneGroupSection: any = [];

  public companygroupsecstatus: any = [];
  public companygroupsecmaintaxidenti: any = [];
  public companygroupsecmaxpage: number = 0;
  public alcorCodesOnCpyIds: any = [];

  GroupIdRole: any = [];
  GroupIdRoleDetails: any = [];
  GroupContacts: any = [];
  GroupContactsLoading: boolean = true;
  ContactsFlag: boolean = false;
  personRowId: any = [];
  PersonDetails: any = [];
  changedRoleId: any;
  cellPhoneEdit = false;
  fixedPhoneEdit = false;
  public Editcontact_rowId = "";
  public grpModelIpn: any = "";

  personIpn: any = [];
  editGrpConFname = '';
  editGrpConLname = '';
  editGrpConCellphone = '';
  editGrpConPhone = '';

  EditAliasObj: any = [];
  EditAliasModel = "";
  EditGrpAlliasValueError: boolean = false;

  companyCodeModelval: any = '';
  companyCodeModelvalLabel: any = '';
  companyCodeModelvalerror: boolean = false;
  companyCodeScopeRowid: any = '';
  companyCodeScopeArchiveRowid: any = '';
  EditGrpAlliasCharacterLimitError = false;
  remvoeContactModelval: any = '';
  GroupIdentiLoading: boolean = true;
  addAliasCharacterError = false;
  PersonRoleSelectOp: any = [];
  GrpConField = ['GrpConFname', 'GrpConLname', 'GrpConRole', 'GrpConEmail'];
  GrpConFname = "";
  GrpConLname = "";
  GrpConRole = "";
  public grpConRoleexists = false;
  public grpRolechanged: boolean = false;
  PersonRowId = "";
  NewPersonRowId = "";
  delPersonId = "";
  updPersonId = "";
  AllPersonIdArr: any = "";
  Editrow_id_grpContactcs = "";
  upd_usersRow_id = "";
  public disableEmail: boolean = false;
  public grp_ShowNext: boolean = true;
  public grp_ShowSave: boolean = false;
  public grp_modelLabelName: boolean = false;
  public grp_modelIpn: boolean = false;
  public grp_modelFname: boolean = false;
  public grp_modelLname: boolean = false;
  public grp_modelCellphone: boolean = false;
  public grp_modelPhone: boolean = false;
  public grp_modelRole: boolean = false;
  public GrpConRoleSelected: any;
  GrpConEmailexistsError: boolean = false;
  public grpModelName: any = "";

  public GrpConEmailExists: any = '';
  public isReadOnly: boolean = false;
  public aliasTypesArchive: any = '';
  openData: boolean = true;
  openRole: boolean = false;
  pager: any = {};
  pagedItems: any[];
  paged: number = 1;
  pagedTotalItem: number = 0;
  tempvar: any = '';
  public commoditycodeloaded: boolean = false;
  public commoditycodeloadedcheck: boolean = true;
  pagerPanel: any = {};
  pagerPanelCurrentPage: number = 1;
  pagedItemsPanel: any[];
  pagedPanel: number = 1;
  pagedPanelTotalItem: number = 0;

  public roleVariableHide = false;
  public commodityCodesSearch: any = [];
  public commodityCodeidsSearch: any = [];
  public companyIdForSite: any = [];
  userQuestionUpdate3 = new Subject<string>();
  public showThisModal = 'default';
  public groupAliasInnerText = '';
  public modalButtonText = 'OK';
  public maxGrpLength = '60';
  public groupPanelProspectExists: any = [];

  public sortedQualifiers = {
    "P14": "P14",
    "P18": "P18",
    "P11": "P11",
    "P05": "P05",
    "P13": "P13",
    "P19": "P19",
    "P07": "P07",
    "P09": "P09",
    "P06": "P06",
    "P08": "P08",
    "P100": "assets/sites/icons/P101.png"
  };

  public helper = {
    multisort: function (arr, columns, order_by) {
      let x;
      if (typeof columns == 'undefined') {
        columns = []
        for (x = 0; x < arr[0].length; x++) {
          columns.push(x);
        }
      }
      if (typeof order_by == 'undefined') {
        order_by = []
        for (x = 0; x < arr[0].length; x++) {
          order_by.push('ASC');
        }
      }
      function multisort_recursive(a, b, columns, order_by, index) {
        let direction = order_by[index] == 'DESC' ? 1 : 0;
        let is_numeric = !isNaN(+a[columns[index]] - +b[columns[index]]);
        let x = is_numeric ? +a[columns[index]] : a[columns[index]].toLowerCase();
        let y = is_numeric ? +b[columns[index]] : b[columns[index]].toLowerCase();
        if (x < y) {
          return direction == 0 ? -1 : 1;
        }
        if (x == y) {
          return columns.length - 1 > index ? multisort_recursive(a, b, columns, order_by, index + 1) : 0;
        }
        return direction == 0 ? 1 : -1;
      }
      return arr.sort(function (a, b) {
        return multisort_recursive(a, b, columns, order_by, 0);
      });
    }
  };

  public colors = [
    { status: "DELETED", color: "#CB4B32" },
    { status: "PENDING_VALIDATION", color: "#B7783C" },
    { status: "DRAFT", color: "yellow" },
    { status: "VALIDATED", color: "#5CBA63" },
    { status: "Approved", color: "#5CBA63" },
    { status: "ARCHIVED", color: "#CB4B32" },
    { status: "Archived", color: "#CB4B32" },
    { status: "Registered", color: "#66D8D0" },
    { status: "Prospect", color: "#4B9BF5" },
    { status: "Identified", color: "#D8C4A0" },
    { status: "Updating...", color: "white" },
    { status: "WAITING FOR APPROVAL", color: "#B7783C" },
  ];
  public colors1 = [
    { status: "DELETED", color: "#CB4B32" },
    { status: "PENDING_VALIDATION", color: "#B7783C" },
    { status: "DRAFT", color: "yellow" },
    { status: "VALIDATED", color: "#5CBA63" },
    { status: "ARCHIVED", color: "#CB4B32" },
    { status: "Updating...", color: "white" },
    { status: "DISABLED", color: "white" },
    { status: "ENABLED", color: "white" },
    { status: "ACTIVE", color: "#5CBA63" },
    { status: "BLOCKED", color: "#FFBD69" },
    { status: "", color: "white" },
    { status: "WAITING FOR APPROVAL", color: "#B7783C" },
  ];
  public colors2 = [
    { status: "DELETED", color: "#CB4B32" },
    { status: "PENDING_VALIDATION", color: "#B7783C" },
    { status: "Need more info", color: "#1e284b" },
    { status: "DRAFT", color: "yellow" },
    { status: "Approved", color: "#5CBA63" },
    { status: "Archived", color: "#CB4B32" },
    { status: "Updating...", color: "white" },
    { status: "Blocked", color: "#CB4B32" },
    { status: "Refused", color: "#CB4B32" },
    { status: "Active", color: "#5CBA63" },
    { status: "Registered", color: "#66D8D0" },
    { status: "Prospect", color: "#4B9BF5" },
    { status: "Identified", color: "#D8C4A0" },
    { status: "", color: "white" },
    { status: "Waiting for Approval", color: "#B7783C" },
    { status: "Created", color: "#D8C4A0" },
    { status: "Pending", color: "#FFBD69" },
    { status: "Inactive", color: "#FFBD69"}
  ];

  public envHide: any = "";

  public GrpConRoleError: any;
  public GrpConFnameError: any;
  public GrpConLnameError: any;
  public GrpConIpn: any;
  public GrpConIpnError: any;
  public GrpConEmail: any;
  public GrpConEmailError: any;
  public GrpConCellphone: any;
  public GrpConCellphoneError: any;
  public GrpConCellphoneError2: any;
  public GrpConPhone: any;
  public GrpConPhoneError: any;
  public GrpConPhoneError2: any;

  public customLoadingTemplatecompany: any;
  showBoxDownForAllSec: boolean = true;

  public cpyRepGrpId = '';
  public cpyRepGrpData = [];
  public showEmptyRow = false;
  public selectedCpyRep = '';
  public groupCategoryTypeCode = false;
  public groupTypeCodeModel = '';
  public groupTypeCodeData: any = [];
  public groupTypeCodeDataAll: any = [];
  public groupIdentifierKeyRowId: any = [];
  public companySectionShortNameArr = [];
  public showBuyerProfile: any = true;
  public prodHide = true;
  public siteIdsOnCompanyHQ: any = [];
  public siteCityAndCountryHQ: any = [];
  public hideInQuaNProd = false;
  public showForConsult = false;
  showForSupplier: boolean;
  superUserShow: boolean;
  public groupNameModelvalRegExerror = false;
  disableAddGroupAliasBtn: boolean;
  disableEditGrpAliasBtn: boolean;
  disableEditGrpName: boolean;
  disableEditGrpCategory: boolean;
  disableEditGrpStatusBtn: boolean;
  companyStatusRowid: any;
  companyRowId: any;
  public IdenKeywithId: any = [];
  public CIdentifierTypes: any = [];
  CountryNameKeyId: any = [];
  CaptCountry = [];
  countrySelList = [];
  tempVarCounList: any;
  CityNameKeyId: any = [];
  SiteRowID: string;
  varIsMergingSite = '2';
  public newCategoryAssignment = '6';
  public newCategoryName = 'SUPPLIER SITE'
  siteCityModel: string;
  siteCountryModel: string;
  CaptCity: any = [];
  selectedCountry: string;
  public qualifierChangetoPending = ['P11', 'P05', 'P06', 'P19', 'P07', 'P09', 'P08'];
  public arrBasedOnVal = [];
  public cpyAlcorToRaft = [];
  public disableCheckGrpRep = false;
  showCheckGrpWarningMsg: string;
  selectedCustomCountry = '';
  public showFilterStatus = false;
  public compRowId: any = [];
  public companyStatus: any = [];
  public companyData: any;
  public statusOrder = ["Identified", "Prospect", "Inactive", "Approved", "Archived"];
  public FiltercheckStatus = ["Identified_status", "Prospect_status", "Inactive_status", "Approved_status", "Archived_status"];
  public Prospect_status: boolean = false; public Identified_status: boolean = false; public Registered_status: boolean = false;
  public Approved_status: boolean = false; public Archived_status: boolean = false;
  tempCompanySection: any = [];
  paginationForStatus: boolean = false;
  filteredCompanies: any = [];

  SiteRowID2: any = [];
  beRowID: any = [];
  SitesFlag: boolean = false;
  SitesInfo: any = [];
  companyExist: boolean = true;
  SiteDe_BvdID_Stat: any = [];
  Site_City_Country: any = [];
  showAddSiteBtn = false;
  hQBvdIdHolder: any;
  siteIdentifierForRaft: any = [];
  SiteDispLoading: boolean = true;
  public Site_hrefTo_Cid: any = [];
  public siteBusinessEntityHQ: any = [];
  public siteBusinessEntityExist = true;
  public siteRowIdFilter: any = [];
  public siteStatus: any = [];
  site_qualifiers: any = [];
  public siteQualiferMainEntranceData: any = [];
  accessPointIdOnAddress: any = [];
  acpAddressDetOnRows: any = [];
  siteRaftCodeValOnRowId: any = [];
  sitesaerCodeValOnRowId: any = [];
  paging: any = {};
  siteGroupsecMaxpage: number = 0;
  tempSiteSection: any = [];
  pagedTotalItems: number = 0;
  public noHqExists = '';
  public colorStatus = { "archived": "#CB4B32", "active": "#5CBA63", "draft": "#5CBA63", "validated": "#5CBA63", 'pending_validation': '#FFBD69', 'pending': '#FFBD69', 'greenfield': '#FFBD69', 'brownfield': '#FFBD69', "destroyed": "#CB4B32", "built": "#5CBA63", "waiting for approval": "#B7783C", "created": "#D8C4A0", "identified": "#D8C4A0" }
  public qualifierColors = {
    "P05": "#2E2ECA",
    "P06": "#244F35",
    "P07": "#978B7F",
    "P08": "#632717",
    "P09": "#4613A5",
    "P11": "#CB4B32",
    "P13": "#66D8D0",
    "P14": "#5CBA63",
    "P18": "#000000",
    "P19": "#B7783C",
    "B2b": "#000000"
  }
  public qualifierTypesText = {
    P05: "Manufacturing",
    P06: "Invoicing",
    P07: "Picking",
    P08: "Customer",
    P09: "Quality Return",
    P11: "Ordering",
    P13: "Grouping",
    P14: "Main Entrance",
    P18: "Headquarters",
    P19: "Supply Chain EDI",
    B2b: "B2B Partner"
  };
  public roleIsManager: boolean = false;
  public FiltercheckStatusForSites = ["Active_status", "Pending_status", "Created_status", "Archived_status"];
  public showFilterStatusForSites = false;
  public CmpConIpn: any = "";
  public statusOrderForSites = ["Active", "Pending", "Created", "Archived"];
  filteredSites: any = [];
  paginationForSiteStatus: boolean = false;
  public sitebvidid: any = '';
  public tempBvdId = '';
  showArchivedBvdId: boolean = false;
  public editBvdIdValueModel = '';
  public editBvdIdModalError = false;
  disableSaveBvdBtn = false;
  public bvdidloading: boolean = false;
  public bvdIdStatusText = '';
  public noSiteAssn = false;
  public disableInPortfolioSwitch = false;
  inPortfolioLoading: boolean = true;
  bvdInPortfolioSet: any;
  public countValue: any = '';
  businessIdForBvd: any;
  companyFiltered: boolean = false;
  siteFiltered: boolean = false;
  RoleByService: any;
  supplierDefaultFilterReseted: boolean = false;
  siteAssociated: boolean = false;

  showBoxDowncompany: boolean = false;
  showBoxDownGroup: boolean = false;
  showBoxDownworkflow: boolean;
  showBoxDownSite: boolean;
  workFlowVisibility: boolean;
  workFlowDetails: any = [];
  pageHeight: number = 0;
  Uid: any;
  public siteRowIdFilterWorkFlow: any = [];
  public FiltercheckStatusWorkFlow = ["Inprogress_status", "Needmoreinfo_status", "Approvedd_status", "Refused_status"];
  public statusFilteredWorkFlow: boolean = false;
  public Approvedd_status: boolean = false; public Refused_status: boolean = false; public Inprogress_status: boolean = false;
  public Needmoreinfo_status: boolean = false;
  tempWorkflow: any = [];
  public workflowStatus: any = [];
  public showFilterStatusWorkFlow = false;
  filteredWorkFlow: any = [];
  public colorForWorkflow = { "In progress": "#FFBD69", "Need more info": "#1e284b", "Approved": "#5CBA63", "Refused": "#CB4B32" }
  public statusOrderWorkFlow = ["In progress", "Need more info", "Approved", "Refused"];
  wkfRejNotesModel: any = '';
  wkfInfoNotesModel: any = '';
  wkfValNotesModel: any = '';
  public rejectWorkflowNotesError: boolean = false;
  workflowFolioFromK2Isa: any = '';
  workflowReqIdFromK2Isa: any = '';
  workflowValidationLoading: boolean = false;
  statuses: any = [];
  statusesForSites: any = [];
  requestForNotesHistory: any = [];
  bvdidNumber: any;
  specificCpyLink: string = '';
  public mailBodyContent: string = `<p>Hello,</p><p>You have been designed by an Alliance Renault-Nissan buyer to complete several information that will allow you to begin business with the Renault Group.For that please access the following page ${this.specificCpyLink} and update the missing data listed on the top of the page. For any help please contact <u>isa@renault.com</u></p><p>Regards,</p><p>Alliance Supplier Admin</p>`;
  getch: any[];
  MailNameModel: string;
  differenceinDays: string;
  pdfLink: string;
  validatingWorkflow: boolean = false;
  dateDisplay: any;
  commonService: any;
  sitec2bCodeValOnRowId: any = [];
  history: any;
  key: string = 'name';
  reverse: boolean = false;
  histPager: any = {};
  siteLatamCodeValOnRowId: any = [];
  GrpConEmailFormatError: boolean;
  endDateisPresent: boolean;
  endDateistrue: boolean;
  companyLength = 0;
  pagedTotalItemsSite = 0;

  constructor(public apiService: CommonService, route: ActivatedRoute, private pagerService: PagerService, private router: Router, private http: HttpClient, private supplierService: SupplierService, private purchasingService: purchasingApiService, private sitesService: SitesService, private countryService: CountryService, private addressService: AddressService, private k2Service: K2Service, private arcaService: ArcaService, private contactsService: ContactsService, private documentService: DocumentsService, private browserTitleService: BrowserTitleService) {
    this.Config = appConfig;
    this.groupId = route.snapshot.params['row_id'];
    this.userQuestionUpdate3
      .pipe(debounceTime(DEBOUNCE_MS), distinctUntilChanged())
      .subscribe((value) => {
        if (this.commoditycodeloadedcheck == true) {
          this.getCommodityCodes(value);
        } else {
          this.commoditycodeloadedcheck = true;
        }
      });
  }


  ngOnInit() {
    this.RoleByService = this.apiService.splitAndRolesAssign();
    this.Http_URL = this.apiService.getDocument();
    this.getGroupProspectPanelByRowid(this.pagerPanelCurrentPage);
    this.getDetailsByRowid();
    this.getGroupAliasByRowid();

  }

  ngDoCheck() {

    this.getRoles();

    if (this.onInitLoadCompany && this.companyGroupSection.length == 0) {

      this.showDropdownStatus('close')
      this.onInitLoadCompany = false;
    }

  }

  getRoles() {
    var RoleByService = this.apiService.splitAndRolesAssign();
    this.checkAllProfilesAndEnv(RoleByService);

  }

  navigateToHome() {
    if(!this.showForSupplier){
    let pendingCompany = null;
    if (this.companyGroupSection && this.companyGroupSection.length > 0) {
      for (let company of this.companyGroupSection) {
        if (this.companygroupsecstatus[company.companyAllianceIdentifier] && 
            this.companygroupsecstatus[company.companyAllianceIdentifier].toLowerCase() === 'pending') {
          pendingCompany = company;
          break;
        }
      }
    }
    if (pendingCompany) {
      this.router.navigate(['/company-details', pendingCompany.companyId]);
    } }
    else{
      this.router.navigate(['/supplier-group']);
    }
  }

  checkAllProfilesAndEnv(RoleByService) {
    let c = RoleByService
    if (c['userAccess'] != undefined && !c['userAccess'].includes('Deined')) {
      if (c['buyer'] == 'yes') {
        this.showBuyerProfile = false;
      } else {
        this.showBuyerProfile = true;
      }
      if (c['env'] == 'qua' || c['env'] == 're7' || c['env'] == 'ope') {
        this.envHide = false;
      } else {
        this.envHide = true;
      }
      if (c['role'] == 'admin' || c['role'].includes('admin')) {
        this.roleVariableHide = true;
      } else {
        this.roleVariableHide = false;
      }
      if (c['superAdmin'] == 'yes') {
        this.superUserShow = true;
      } else {
        this.superUserShow = false;
      }
      if (c['role'] == 'consult' || c['role'].includes('consult')) {
        this.showForConsult = false;
      } else {
        this.showForConsult = true;
      }
      if (c['env'] == 'ope') {
        this.prodHide = true;
      } else {
        this.prodHide = false;
      }
      if (c['env'] == 'qua' || c['env'] == 'ope') {
        this.hideInQuaNProd = true;
      }
      if (c['role'] == 'supplier') {
        this.showForSupplier = false;
        this.pdfLink = pdf
      } else {
        this.showForSupplier = true;
        this.pdfLink = pdf1
      }
    }
  }

  resetAddCCFields() {
    this.commodityCodeModelval = ''; this.commodityCodeModelvalLabel = '';
  }

  getColor(status) {
    let flag = 1;
    for (let i = 0; i < this.colors.length; i++) {
      if (this.colors[i].status == status) {
        flag = TWO
        return this.colors.filter(item => item.status == status)[0].color;
      }
    }
    if (flag == 1) {
      return "#FFBD69";
    }
  }

  getColor1(status) {
    let flag = 1;
    for (let i = 0; i < this.colors1.length; i++) {
      if (this.colors1[i].status == status) {
        flag = TWO
        return this.colors1.filter(item => item.status == status)[0].color;
      }
    }
    if (flag == 1) {
      return "#FFBD69";
    }
  }

  getColor2(status) {
    let flag = 1;
    for (let i = 0; i < this.colors2.length; i++) {

      if (this.colors2[i].status == status) {
        flag = TWO
        return this.colors2.filter(item => item.status == status)[0].color;
      }
    }
    if (flag == 1) {
      return "#FFBD69";
    }
  }

  updateGroupName() {
    if (this.groupNameModelval != '' && this.groupNameModelval != undefined && this.groupNameModelvalRegExerror == false) {
      this.saveDatas = "Save...";
      this.disableEditGrpName = true;
      this.groupNameModelvalerror = false;
      const datas = { name: this.groupNameModelval };
      this.supplierService.UpdateGroups(`${this.Config.ApiSupplierUrl}groups/${this.groupId}`, datas).subscribe((_data: any) => {
        this.groupName = this.groupNameModelval;
        this.browserTitleService.setGroupName(this.groupNameModelval);
        this.groupNameModelval = this.groupNameModelval;
        this.groupNameModelExistsval = this.groupNameModelval;
        window.document.getElementById("closeBtn").click();
        this.saveDatas = "Save";
      });
    } else {
      if (this.groupNameModelvalRegExerror == true) {

      } else {
        this.groupNameModelvalerror = true;
      }
    }
  }

  updateGroupStatus() {
    if (this.groupStatusModelval != '' && this.groupStatusModelval != undefined) {
      this.saveDatas = "Save...";
      this.disableEditGrpStatusBtn = true;
      this.groupStatusModelvalerror = false;
      if (this.groupStatusModelval == 'ARCHIVED') {
        let allCpyArchived = true;
        if (this.companyGroupSection.length > 0) {
          console.info(this.cpyRepGrpId);
          this.companyGroupSection.forEach(element => {
            if ((element.apoStatus.toLowerCase() == 'archived' || this.companygroupsecstatus[element.companyAllianceIdentifier].toLowerCase() == 'archived' || element.apoStatus.toLowerCase() == 'blocked' || this.companygroupsecstatus[element.companyAllianceIdentifier].toLowerCase() == 'blocked' || element.apoStatus.toLowerCase() == 'inactive' || this.companygroupsecstatus[element.companyAllianceIdentifier].toLowerCase() == 'inactive')) {

            } else {
              allCpyArchived = false;
            }
          });
        }
        if (allCpyArchived) {
          this.proceedToChangeStatus();
        } else {
          this.saveDatas = 'Save';
          this.disableEditGrpStatusBtn = false;
          window.document.getElementById("closeGSBtn")?.click();
          setTimeout(() => {
            document.getElementById('btnForWarningArchiveGrp')?.click();
          }, THREE_HUNDRED_MS);
        }
      } else {
        this.proceedToChangeStatus();
      }
    } else {
      this.groupStatusModelvalerror = true;
    }
  }

  proceedToChangeStatus() {
    let datas;
    if (this.groupStatusModelval == 'ARCHIVED') {
      datas = { modificationStatus: this.groupStatusModelval, endDate: this.apiService.getTodayDate() };
    }
    else {
      datas = { modificationStatus: this.groupStatusModelval, endDate: '' };
    }
    this.supplierService.UpdateGroups(`${this.Config.ApiSupplierUrl}groups/${this.groupId}`, datas).subscribe((_data: any) => {
      this.groupModificationStatus = this.groupStatusModelval;
      this.groupStatusModelval = this.groupStatusModelval;
      if (this.groupStatusModelval == 'ARCHIVED') this.groupStatusModelExistsval = 'VALIDATED';
      if (this.groupStatusModelval == 'VALIDATED') this.groupStatusModelExistsval = 'ARCHIVED';
      window.document.getElementById("closeGSBtn").click();
      this.saveDatas = "Save";
    });
  }


  updateGroupingStatus() {

  }

  setidentifierNameModel() {
    if (typeof this.commodityCodeidsSearch[this.commodityCodeModelvalLabel] != 'undefined') {
      this.commodityCodeModelval = this.commodityCodeidsSearch[this.commodityCodeModelvalLabel];
      this.commodityCodeModelvalerror = false;
      this.commoditycodeloadedcheck = false;
    } else {
      this.commodityCodeModelval = '';
      this.commodityCodeModelvalerror = true;
      this.commoditycodeloadedcheck = true;
    }
  }

  updateCommodityCode() {
    if (typeof this.commodityCodeidsSearch[this.commodityCodeModelvalLabel] != 'undefined' && this.commodityCodeModelval != '' && this.commodityCodeModelval != undefined) {
      this.saveDatas = "Save...";
      this.commodityCodeModelvalerror = false;
      this.supplierService.getApprovalScopes(`${this.Config.ApiSupplierUrl}approval-scopes?code=prospect`).subscribe((data: any) => {
        this.commodityCodeScopeRowid = data['approval-scopes'][0]['row_id'];
        if (this.commodityCodeScopeRowid != '') {
          const datas = { groupPwo: `SupPurchasingWorkingOrganizationService:${this.commodityCodeModelval}`, groupId: this.groupId, scopeId: this.commodityCodeScopeRowid, type: 'GROUP', approvalModificationStatus: 'VALIDATED', validityStartDate: this.apiService.getTodayDate() };
          this.supplierService.CreateGroupApprovals(`${this.Config.ApiSupplierUrl}group-approvals`, datas).subscribe((_data: any) => {
            this.getGroupProspectPanelByRowid(this.pagerPanelCurrentPage);
            window.document.getElementById("closeCCBtn").click();
            this.saveDatas = "Save";
          });
        } else {
          this.commodityCodeModelvalerror = true;
        }
      });
    } else {
      this.commodityCodeModelvalerror = true;
    }
  }

  removeGroupPanle() {
    if (this.groupPanelRemoveIdModelval != '' && this.groupPanelRemoveIdModelval != undefined) {
      this.archiveDatas = "Archive...";
      this.supplierService.getApprovalScopes(`${this.Config.ApiSupplierUrl}approval-scopes?code=archived`).subscribe((data: any) => {
        this.commodityCodeScopeArchiveRowid = data['approval-scopes'][0]['row_id'];
        if (this.commodityCodeScopeArchiveRowid != '') {
          const datas = { scopeId: this.commodityCodeScopeArchiveRowid, scopeCode: "Archived", validityEndDate: this.apiService.getTodayDate() };
          this.supplierService.UpdateGroupApprovals(`${this.Config.ApiSupplierUrl}group-approvals/${this.groupPanelRemoveIdModelval}`, datas).subscribe((_data: any) => {
            this.groupPanel = [];
            this.getGroupProspectPanelByRowid(this.pagerPanelCurrentPage);
            window.document.getElementById("closeGPRBtn").click();
            this.archiveDatas = "Archive";
          });
        }
      }, error => {
        console.info('data_error', error);
      });

    }
  }

  moveCCbyAdmin() {
    if (this.groupProspectMoveIdModelval != '' && this.groupProspectMoveIdModelval != undefined) {
      this.saveDatas = "Save...";
      this.supplierService.getApprovalScopes(`${this.Config.ApiSupplierUrl}approval-scopes?code=${this.moveGroupProspectModelval.toLowerCase()}`).subscribe((data: any) => {
        this.commodityCodeScopeArchiveRowid = data['approval-scopes'][0]['row_id'];
        if (this.commodityCodeScopeArchiveRowid != '') {
          const datas = { scopeId: this.commodityCodeScopeArchiveRowid, scopeCode: this.moveGroupProspectModelval };
          if (this.moveGroupProspectModelval == 'Archived') {
            const datas = { scopeId: this.commodityCodeScopeArchiveRowid, scopeCode: this.moveGroupProspectModelval, validityEndDate: this.apiService.getTodayDate() };
          }
          this.supplierService.UpdateGroupApprovals(`${this.Config.ApiSupplierUrl}group-approvals/${this.groupProspectMoveIdModelval}`, datas).subscribe((_data: any) => {
            this.prospectpanel = false;
            this.groupPanel = [];
            this.groupProspect = [];
            this.getGroupProspectPanelByRowid(this.pagerPanelCurrentPage);
            window.document.getElementById("closeMPBtn").click();
            this.saveDatas = "Save";
          });
        }
      }, error => {
        console.info('data_error', error);
      });
    }
  }

  checkIfGroupAliasExist() {
    var url = window.location.href.split('/supplier-group-details')[0];
    if (this.groupIdentifierModelval != '' && this.groupIdentifierModelval != undefined && this.groupIdentifierValModelval != '' && this.groupIdentifierValModelval != undefined) {
      this.disableAddGroupAliasBtn = true;
      this.supplierService.getGroupIdentifiers(`${this.Config.ApiSupplierUrl}group-identifiers?value=${this.groupIdentifierValModelval}&_page=1`).subscribe(data0 => {
        if (data0['pageCount'] == 0) {
          this.saveGroupAlias();
        }
        else {
          let rowId = data0['group-identifiers'][0]['row_id'];
          let groupIdtemp = data0['group-identifiers'][0]['groupId'];
          if (data0['group-identifiers'][0]['groupId'] == this.groupId) {
            if (data0['group-identifiers'][0]['endDate'] == '') {
              this.showThisModal = 'samegroup';
              this.groupAliasInnerText = 'The Identifier is already associated to the Group!!!';
              this.modalButtonText = 'Cancel';
            }
            else if (data0['group-identifiers'][0]['endDate'] != '') {
              const const1 = { "endDate": "" }
              this.supplierService.updateGroupIdentifiers(`${this.Config.ApiSupplierUrl}group-identifiers/${rowId}`, const1).subscribe(_data => { this.getGroupAliasByRowid(); });
              this.showThisModal = 'samegroup';
              this.modalButtonText = 'OK';
              this.groupAliasInnerText = 'The Identifier has been <span class="label-orange font-weight-bold"> Unarchived </span>!!!';
            }
          } else {
            if (data0['group-identifiers'][0]['groupId'] != this.groupId) {
              this.supplierService.getGroups(`${this.Config.ApiSupplierUrl}groups/${groupIdtemp}`).subscribe(data1 => {
                if (data0['group-identifiers'][0]['endDate'] == '') {
                  this.showThisModal = 'samegroup';
                  this.modalButtonText = 'Cancel';
                  this.groupAliasInnerText = `<img src="assets/images/warning.png" class="img-btn mr-2" alt=""> <span class="font-weight-bold">The Identifier is already associated to the Group :  <a class="label-orange" href="${url}/supplier-group-details/${groupIdtemp}" target="_blank">${data1['name']}</span>`;
                }
                else if (data0['group-identifiers'][0]['endDate'] != '') {
                  const const2 = { "endDate": "", "groupId": this.groupId }
                  this.supplierService.updateGroupIdentifiers(`${this.Config.ApiSupplierUrl}group-identifiers/${rowId}`, const2).subscribe(_data2 => {
                    this.showThisModal = 'samegroup';
                    this.modalButtonText = 'OK';
                    this.groupAliasInnerText = `<img src="assets/images/warning.png" class="img-btn mr-2" alt=""> <span class="font-weight-bold">The Identifier was associated to the Group :  <a class="label-orange" href="${url}/supplier-group-details/${groupIdtemp}" target="_blank">${data1['name']}</span>`;
                    this.getGroupAliasByRowid();
                  });
                }
              });
            }
          }
        }
      });
    } else {
      if (this.groupIdentifierModelval == '' && this.groupIdentifierValModelval == '') {
        this.groupIdentifierModelvalerror = true;
        this.groupIdentifierValModelvalerror = true;
      } else if (this.groupIdentifierModelval != '' && this.groupIdentifierValModelval == '') {
        this.groupIdentifierModelvalerror = false;
        this.groupIdentifierValModelvalerror = true;
      } else if (this.groupIdentifierModelval == '' && this.groupIdentifierValModelval != '') {
        this.groupIdentifierModelvalerror = true;
        this.groupIdentifierValModelvalerror = false;
      }
    }
  }

  saveGroupAlias() {
    this.showThisModal = 'default';
    if (this.groupIdentifierModelval != '' && this.groupIdentifierModelval != undefined && this.groupIdentifierValModelval != '' && this.groupIdentifierValModelval != undefined) {
      if (this.groupIdentifierModelval == this.groupIdentifierKeyRowId['mdm group'] && this.groupIdentifierValModelval.length > SIX) {
        this.addAliasCharacterError = true;
      }
      else {
        this.saveDatas = "Saving...";
        this.groupIdentifierModelvalerror = false;
        this.groupIdentifierValModelvalerror = false;

        const datas = { groupId: this.groupId, groupIdentifierKeyId: this.groupIdentifierModelval, value: this.groupIdentifierValModelval, groupIdentifierKeyName: this.groupIdentifierKeyname[this.groupIdentifierModelval], startDate: this.apiService.getTodayDate() };

        this.supplierService.CreateGroupIdentifiers(`${this.Config.ApiSupplierUrl}group-identifiers`, datas).subscribe((_data: any) => {
          this.getGroupAliasByRowid();
          window.document.getElementById("closeGABtn").click();
          this.saveDatas = "Save";
        });
      }
    } else {
      if (this.groupIdentifierModelval == '' && this.groupIdentifierValModelval == '') {
        this.groupIdentifierModelvalerror = true;
        this.groupIdentifierValModelvalerror = true;
      } else if (this.groupIdentifierModelval != '' && this.groupIdentifierValModelval == '') {
        this.groupIdentifierModelvalerror = false;
        this.groupIdentifierValModelvalerror = true;
      } else if (this.groupIdentifierModelval == '' && this.groupIdentifierValModelval != '') {
        this.groupIdentifierModelvalerror = true;
        this.groupIdentifierValModelvalerror = false;
      }
    }

  }

  checkvalidateField() {
    if (this.groupNameModelval == '') {
      this.groupNameModelvalerror = true;
    } else {
      this.groupNameModelvalerror = false;
    }
  }

  checkvalidateGroupIdentiValField() {
    if (this.groupIdentifierValModelval == '') {
      this.groupIdentifierValModelvalerror = true;
    } else {
      this.groupIdentifierValModelvalerror = false;
    }
  }

  checkvalidateGroupIdentiTypeField() {
    if (this.groupIdentifierModelval == '') {
      this.groupIdentifierModelvalerror = true;
    } else {
      this.groupIdentifierModelvalerror = false;
      this.addAliasCharacterError = false;
      if (this.groupIdentifierModelval == this.groupIdentifierKeyRowId['mdm group']) {
        document.getElementById('groupIdentifierValueUp').setAttribute('maxLength', '6');
      }
      else {
        document.getElementById('groupIdentifierValueUp').removeAttribute('maxLength')
      }
    }
  }

  checkCCvalidateField() {
    if (this.commodityCodeModelval == '') {
      this.commodityCodeModelvalerror = true;
    } else {
      this.commodityCodeModelvalerror = false;
    }
  }


  resetSelectedFields() {
    this.groupNameModelval = '';
    this.groupNameModelvalerror = true;
    this.groupNameModelvalRegExerror = false;
  }

  resetSelectedCCFields() {
    this.commodityCodeModelval = '';
    this.commodityCodeModelvalLabel = ''
    this.commodityCodeModelvalerror = true;
  }

  resetSelectedIdentifierValFields() {
    this.groupIdentifierValModelval = '';
    this.groupIdentifierValModelvalerror = true;
  }

  updateGroupExistsName() {
    this.saveDatas = 'Save';
    this.groupNameModelval = this.groupNameModelExistsval;
    this.groupNameModelvalerror = false;
    this.groupNameModelvalRegExerror = false;
    this.disableEditGrpName = false;
  }

  updateGroupExistsStatus() {
    this.saveDatas = 'Save';
    this.groupStatusModelval = this.groupStatusModelExistsval;
    this.groupStatusModelvalerror = false;
    this.disableEditGrpStatusBtn = false;
  }

  updateGrouPanelRemoveExists(rowId: any) {
    console.info("mmmmmmm====>", rowId);
    this.archiveDatas = 'Archive';
    this.groupPanelRemoveIdModelval = rowId;
  }

  moveGroupProspectExists(rowId: any) {
    this.saveDatas = 'Save';
    this.groupProspectMoveIdModelval = rowId;
    this.moveGroupProspectModelval = 'In Panel';
  }

  checkGSvalidateField() {
    if (this.groupStatusModelval == '') {
      this.groupStatusModelvalerror = true;
    } else {
      this.groupStatusModelvalerror = false;
    }
  }

  checkMPvalidateField() {
    if (this.moveGroupProspectModelval == '') {
      this.moveProspectValModelvalerror = true;
    } else {
      this.moveProspectValModelvalerror = false;
    }
  }

  checkGISvalidateField() {
    if (this.groupingStatusModelval == '') {
      this.groupingStatusModelvalerror = true;
    } else {
      this.groupingStatusModelval = this.groupingStatusModelval;
      this.groupingStatusModelvalerror = false;
    }
  }

  getCommodityCodes(codes: any) {
    if (this.tempvar != codes && codes.length > 1) {
      this.commoditycodeloaded = true;
      this.commoditycodeloadedcheck = false;
      this.commodityCodesSearch = [];
      this.commodityCodeidsSearch = [];
      this.tempvar = codes;
      var cod = codes.split(' - ');
      this.purchasingService.getcommodityPerimeters(`${this.Config.ApiPurchasingUrl}commodity-perimeters?typeCode=Commodity Code&typeScope=BOP&code=*${encodeURI(cod['0'].toLowerCase())}*&_page=1`).pipe(takeUntil(this.ngUnsubscribe)).subscribe((data: any) => {
        if (data && data != null) {
          var j = 0;
          for (let i = 0; i < data['commodity-perimeters'].length; i++) {
            if (this.groupPanelProspectExists != undefined && this.groupPanelProspectExists[data['commodity-perimeters'][i]['rowId']] == undefined) {
              this.groupPwos[`pwos/${data['commodity-perimeters'][i]['rowId']}`] = data['commodity-perimeters'][i];
              this.commodityCodesSearch[j] = data['commodity-perimeters'][i];
              this.commodityCodesSearch[j]['code_label'] = this.trimSpaces(`${data['commodity-perimeters'][i]['code']} - ${data['commodity-perimeters'][i]['label']}`);
              this.commodityCodeidsSearch[this.trimSpaces(`${data['commodity-perimeters'][i]['code']} - ${data['commodity-perimeters'][i]['label']}`)] = data['commodity-perimeters'][i]['rowId'];
              j++;
            }
          }
          this.commoditycodeloadedcheck = false;
        }
        this.commoditycodeloaded = false;
      }, error => {
        console.info('data_error', error);
      });
    }
    return "ok";
  }

  updateCCExistsName() {
    this.saveDatas = 'Save';
    this.commodityCodeModelval = '';
    this.commodityCodeModelvalLabel = ''
    this.commodityCodeModelvalerror = false;
    this.commodityCodesSearch = [];
    this.commodityCodeidsSearch = [];
  }

  updateGroupAliasExistsName() {
    this.saveDatas = 'Save';
    this.showThisModal = 'default'
    this.groupIdentifierModelval = '';
    this.groupIdentifierModelvalerror = false;
    this.groupIdentifierValModelval = '';
    this.groupIdentifierValModelvalerror = false;
    this.addAliasCharacterError = false;
    this.disableAddGroupAliasBtn = false;
  }

  getDetailsByRowid() {
    this.supplierService.getGroups(`${this.Config.ApiSupplierUrl}groups/${this.groupId}`).pipe(takeUntil(this.ngUnsubscribe)).subscribe((data: any) => {
      if (data && data != null) {
        this.groupName = data['name'];
        this.browserTitleService.setGroupName(this.groupName);
        this.groupNameModelval = data['name'];
        this.groupNameModelExistsval = data['name'];
        this.groupAllianceIdentifier = data['allianceIdentifier'];
        this.groupTypeCode = data['groupTypeCode'];
        if (data['representingCompanyId'] == '') {
          this.showEmptyRow = true;
        } else {
          this.showEmptyRow = false;
        }
        this.cpyRepGrpId = data['representingCompanyId'];
        this.groupModificationStatus = data['modificationStatus'];
        this.groupStatusModelval = data['modificationStatus'];
        this.dateDisplay = data['modificationStatus'] == 'ARCHIVED' ? data['endDate'] : data['startDate']
        if (data['modificationStatus'] == 'ARCHIVED') this.groupStatusModelExistsval = 'VALIDATED';
        if (data['modificationStatus'] == 'VALIDATED') this.groupStatusModelExistsval = 'ARCHIVED';
      } else {
        this.groupName = '';
        this.groupAllianceIdentifier = '';
        this.groupTypeCode = '';
        this.groupModificationStatus = '';
        this.groupNameModelval = '';
        this.groupStatusModelval = '';
      }
      this.groupRoles();
      this.getCompanyGroupSection(1);
      setTimeout(() => {
        this.loadBvdIdCpy();
        this.getSiteDetails(1);
      }, THREE_THOUSAND_MS);
    }, error => {
      this.getDetailsByRowid();
      console.info('data_error', error);
    });
  }

  getGroupAliasByRowid(page = 1, subscribeData = []) {
    this.groupAlias = [];
    this.supplierService.getGroupIdentifiers(`${this.Config.ApiSupplierUrl}group-identifiers?groupId=${this.groupId}&_page=${page}`).pipe(takeUntil(this.ngUnsubscribe)).subscribe((data: any) => {
      if (data['group-identifiers'] && data['group-identifiers'] != null) {
        data['group-identifiers'].forEach(ele => {
          if (this.showForSupplier == false) {
            if (ele.groupIdentifierKeyName != 'BVD') {
              subscribeData.push(ele);
            }
          } else {
            subscribeData.push(ele);
          }
        });
        if (data['maxPage'] > 1 && data['maxPage'] != page) {
          this.getGroupAliasByRowid(page + 1, subscribeData);
        } else if (data['maxPage'] == page) {
          let j = 0;
          for (let i = 0; i < subscribeData.length; i++) {
            if (!subscribeData[i]['endDate']) {
              this.groupAlias[j] = subscribeData[i];
              if (subscribeData[i]['groupIdentifierKeyName'] == 'MDM GROUP') {
                if (this.groupAlias[j]['disableEdit'] == undefined) {
                  this.groupAlias[j]['disableEdit'] = []
                }
                this.groupAlias[j]['disableEdit'] = false;
              } else {
                if (this.groupAlias[j]['disableEdit'] == undefined) {
                  this.groupAlias[j]['disableEdit'] = []
                }
                this.groupAlias[j]['disableEdit'] = true;
              }
              j++;
            }
          }
          console.info("this.groupAlias[i]===>", this.groupAlias);
        }
      }
      if (data['maxPage'] == page) {
        this.getGroupIdentifierKeys();
      }
    });
  }


  getGroupIdentifierKeys(page = 1, subscribeData = []) {
    this.groupIdentifierKeys = [];
    this.supplierService.getGroupIdentifierKeys(`${this.Config.ApiSupplierUrl}group-identifier-keys?_page=${page}`).pipe(takeUntil(this.ngUnsubscribe)).subscribe((data: any) => {
      if (data['group-identifier-keys'] && data['group-identifier-keys'] != null) {
        data["group-identifier-keys"].forEach(e => {
          subscribeData.push(e);
        });
        if (data['maxPage'] > 1 && data['maxPage'] != page) {
          this.getGroupIdentifierKeys(page + 1, subscribeData);
        } else if (data['maxPage'] == page) {
          for (let i = 0; i < (subscribeData.length); i++) {
            if (subscribeData[i]['name'].toLowerCase() != 'mdm group') {
              this.groupIdentifierKeys[i] = subscribeData[i];
            }
            this.groupIdentifierKeyname[subscribeData[i]['row_id']] = subscribeData[i]['name'];
            this.groupIdentifierKeyRowId[subscribeData[i]['name'].toLowerCase()] = subscribeData[i]['row_id'];
          }
        }
      }
    }, error => {
      console.info('data_error', error);
    });
  }

  updateCommidityExistsCodes(rowId: any, typeID: any) {
    this.commodityCodeDetailsByRow = [];
    if (typeof this.commodityCodeDetails[rowId] != 'undefined') {
      this.commodityCodeDetailsByRow = this.commodityCodeDetails[rowId];
    }
    this.fsaCodeFlag = false;
    this.panelCodeFlag = false;
    this.commodityTypeFlag = false;
    this.getFSAPANELCode(rowId, 0);
    this.getCommodityType(typeID);
  }

  getFSAPANELCode(row_id, _indexj) {
    this.panelCCode = [];
    this.panelCDataList = '';
    this.fsaCCode = [];
    this.fsaCDataList = '';
    this.apiService.get(`${this.Config.ApiPurchasingUrl}pwo-hierarchies?childId=${row_id}`).subscribe((data: any) => {
      this.fsaCodeFlag = true;
      this.panelCodeFlag = true;
      var panelCDataListIds = '';
      if (data && data != null) {
        let k = 0;
        let l = 0;
        for (let i = 0; i < data['pwo-hierarchies'].length; i++) {
          this.panelCCode[k] = data['pwo-hierarchies'][i];
          this.fsaCCode[l] = data['pwo-hierarchies'][i];
          if (data['pwo-hierarchies'][i]['parentId'] != undefined) {
            panelCDataListIds += `${data['pwo-hierarchies'][i]['parentId']},`;
          }
          k++;
          l++;
        }
        if (panelCDataListIds != '') {
          this.getPwosPanelIds(panelCDataListIds);
          this.getPwosStrategicFamily(panelCDataListIds);
        }
      }
    }, error => {
      console.info('data_error', error);
    });
  }

  getPwosStrategicFamily(panelCDataListIds, page = 1, subscribeData = []) {
    this.purchasingService.getcommodityPerimeters(`${this.Config.ApiPurchasingUrl}commodity-perimeters?typeCode=strategic family&rowId=in(${panelCDataListIds.slice(0, -1)})`).subscribe((data: any) => {
      if (data && data != null) {
        data['commodity-perimeters'].forEach(e => {
          subscribeData.push(e);
        });
        if (data['maxPage'] > 1 && data['maxPage'] != page) {
          this.getPwosStrategicFamily(panelCDataListIds, page + 1, subscribeData);
        } else if (data['maxPage'] == page) {
          for (let i = 0; i < subscribeData.length; i++) {
            this.fsaCDataList += `${subscribeData[i]['code']}, `;
          }
        }
      }
    });
  }

  getPwosPanelIds(panelCDataListIds, page = 1, subscribeData = []) {
    this.purchasingService.getcommodityPerimeters(`${this.Config.ApiPurchasingUrl}commodity-perimeters?typeCode=panel&rowId=in(${panelCDataListIds.slice(0, -1)})&_page=${page}`).subscribe((data: any) => {
      if (data && data != null) {
        data['commodity-perimeters'].forEach(e => {
          subscribeData.push(e);
        });
        if (data['maxPage'] > 1 && data['maxPage'] != page) {
          this.getPwosPanelIds(panelCDataListIds, page + 1, subscribeData);
        } else if (data['maxPage'] == page) {
          for (let i = 0; i < subscribeData.length; i++) {
            this.panelCDataList += `${subscribeData[i]['code']}, `;
          }
        }
      }
    });
  }

  getCommodityType(typeID) {
    this.commodityTypes = '';
    this.apiService.get(`${this.Config.ApiPurchasingUrl}pwo-types/${typeID}`).subscribe((data: any) => {
      this.commodityTypeFlag = true;
      if (data && data != null) {
        this.commodityTypes = data.scope;
      }
    }, error => {
      console.info('data_error', error);
    });
  }

  trimSpaces(stringsVal: any) {
    var s = stringsVal.trim();
    s = s.replace(/[ ]{2,}/gi, " ");
    s = s.replace(/\n /, "\n");
    return s;
  }

  getGroupProspectPanelByRowid(curr_page) {
    this.groupProspect = [];
    this.groupPanel = [];
    this.groupPwos = [];
    this.pagerPanelCurrentPage = curr_page;
    this.commodityCodeDetails = [];
    this.groupPanelProspectExists = [];
    var prospectPwosId = '';
    this.getGroupApprovalsProspect();
    this.getGroupApprovalsInPanel();
  }

  getGroupApprovalsProspect(page = 1, subscribeData = []) {
    var prospectPwosId = '';
    this.supplierService.getGroupApprovals(`${this.Config.ApiSupplierUrl}group-approvals?scopeCode=Prospect&groupId=${this.groupId}&_page=${page}`).pipe(takeUntil(this.ngUnsubscribe)).subscribe((data: any) => {
      if (data["group-approvals"] && data["group-approvals"] != null) {
        data["group-approvals"].forEach(e => {
          subscribeData.push(e);
        });
        if (data['maxPage'] > 1 && data['maxPage'] != page) {
          this.getGroupApprovalsProspect(page + 1, subscribeData);
        } else if (data['maxPage'] == page) {
          let j = 0;
          this.prospectpanel = true;
          for (let i = 0; i < subscribeData.length; i++) {
            if (subscribeData[i]['groupPwo']) {
              var prospectTypeid = subscribeData[i]['groupPwo'].href.split('/');
              prospectPwosId += `${prospectTypeid[1]},`;
              this.groupProspect1[prospectTypeid[1]] = subscribeData[i]['row_id'];
            }
          }
          if (prospectPwosId != '') {
            this.getPwosTypeCommodityCode(prospectPwosId);
          } else {
            this.groupProspect = [];
          }
        }
      }
    });
  }

  getPwosTypeCommodityCode(prospectPwosId, page = 1, subscribeData = []) {
    this.purchasingService.getcommodityPerimeters(`${this.Config.ApiPurchasingUrl}commodity-perimeters?typeCode=Commodity Code&rowId=in(${prospectPwosId.slice(0, -1)})&_page=${page}`).subscribe((data: any) => {
      if (data && data != null) {
        if (data['commodity-perimeters']) {
          data['commodity-perimeters'].forEach(e => {
            subscribeData.push(e);
          });
        }
        if (data['maxPage'] > 1 && data['maxPage'] != page) {
          this.getPwosTypeCommodityCode(prospectPwosId, page + 1, subscribeData);
        } else if (data['maxPage'] == page) {
          let j = 0;
          for (let i = 0; i < subscribeData.length; i++) {
            this.groupProspect[j] = subscribeData[i];
            this.groupPanelProspectExists[this.groupProspect[j]['rowId']] = this.groupProspect[j]['rowId'];
            if (typeof this.commodityCodeDetails[this.groupProspect[j]['row_id']] == 'undefined') {
              this.commodityCodeDetails[this.groupProspect[j]['row_id']] = [];
            }
            this.commodityCodeDetails[this.groupProspect[j]['row_id']] = this.groupProspect[j];
            this.groupProspect[j]['row_gp_id'] = this.groupProspect1[subscribeData[i]['rowId']];
            j++;
          }
          this.groupProspect = this.helper.multisort(this.groupProspect, ['code'], ['ASC']);
        }
      }
    });
  }

  getGroupApprovalsInPanel(page = 1, subscribeData = []) {
    var panelPwosId = '';
    this.supplierService.getGroupApprovals(`${this.Config.ApiSupplierUrl}group-approvals?scopeCode=In panel&groupId=${this.groupId}&_page=${page}`).pipe(takeUntil(this.ngUnsubscribe)).subscribe((data: any) => {
      if (data["group-approvals"] && data["group-approvals"] != null) {
        data["group-approvals"].forEach(e => {
          subscribeData.push(e);
        });
        if (data['maxPage'] > 1 && data['maxPage'] != page) {
          this.getGroupApprovalsInPanel(page + 1, subscribeData);
        } else if (data['maxPage'] == page) {
          this.prospectpanel = true;
          for (let i = 0; i < subscribeData.length; i++) {
            let panelTypeid = subscribeData[i]['groupPwo'].href.split('/');
            panelPwosId += `${panelTypeid[1]},`;
            this.groupPanel1[panelTypeid[1]] = subscribeData[i]['row_id'];
          }
          if (panelPwosId != '') {
            this.getPwosTypesCommodity2(panelPwosId);
          } else {
            this.groupPanel = [];
          }
        }
      } else {
        this.groupPanel = [];
      }
      this.prospectpanel = true;
    });
  }

  getPwosTypesCommodity2(panelPwosId, page = 1, subscribeData = []) {
    this.purchasingService.getcommodityPerimeters(`${this.Config.ApiPurchasingUrl}commodity-perimeters?typeCode=Commodity Code&rowId=in(${panelPwosId.slice(0, -1)})&_page=${page}`).subscribe((dataPanel: any) => {
      if (dataPanel && dataPanel != null) {
        dataPanel['commodity-perimeters'].forEach(e => {
          subscribeData.push(e);
        });
        if (dataPanel['maxPage'] > 1 && dataPanel['maxPage'] != page) {
          this.getGroupApprovalsInPanel(page + 1, subscribeData);
        } else if (dataPanel['maxPage'] == page) {
          let k = 0;
          for (let i = 0; i < subscribeData.length; i++) {
            this.groupPanel[k] = subscribeData[i];
            this.groupPanelProspectExists[this.groupPanel[k]['rowId']] = this.groupPanel[k]['rowId'];
            if (typeof this.commodityCodeDetails[this.groupPanel[k]['rowId']] == 'undefined') {
              this.commodityCodeDetails[this.groupPanel[k]['rowId']] = [];
            }
            this.commodityCodeDetails[this.groupPanel[k]['rowId']] = this.groupPanel[k];
            this.groupPanel[k]['row_gp_id'] = this.groupPanel1[subscribeData[i]['rowId']];
            k++;
          }
          this.groupPanel = this.helper.multisort(this.groupPanel, ['code'], ['ASC']);
        }
      }
    });
  }

  getprospectDetails(hyperlink, _row_id) {
    this.apiService.get(this.Config.ApiPurchasingUrl + hyperlink).pipe(takeUntil(this.ngUnsubscribe)).subscribe((data: any) => {
      if (data && data != null) {
        this.groupProspect.push(data);
      }
    }, error => {
      console.info('data_error', error);
    });
  }

  getPanelDetails(hyperlink, _row_id) {
    this.apiService.get(this.Config.ApiPurchasingUrl + hyperlink).pipe(takeUntil(this.ngUnsubscribe)).subscribe((data: any) => {
      if (data && data != null) {
        this.groupPanel.push(data);
      }
    }, error => {
      console.info('data_error', error);
    });
  }

  getCompanyGroupSection(page, curr_page = 1, subscribeData = [], count = 0) {
    this.loading1 = true;
    this.companygroupsecmaxpage = 0;
    let companyAllianceIdentifierIds = '';
    let companyids = '';
    this.supplierService.getGroupAssignments(`${this.Config.ApiSupplierUrl}group-assignments?_page=${curr_page}&groupId=${this.groupId}`).subscribe((data: any) => {
      if (curr_page === 1) {
        this.pagedTotalItem = data['count'];
      }
      this.companygroupsecmaxpage = data['maxPage'];
      if (data['group-assignments'].length > 0 && data != null) {
        for (let i = 0; i < data["group-assignments"].length; i++) {
          if (data["group-assignments"][i]['companyId'] == this.cpyRepGrpId) {
            subscribeData.unshift(data["group-assignments"][i]);
            subscribeData[0]['showInput'] = false;
            subscribeData[0]['isGrpRep'] = true;
            subscribeData[0]['hideRow'] = false;
            subscribeData[0]['toggleRow'] = false;
            subscribeData[0]['filterTrue'] = true;
            this.noSiteAssn = true;
          } else {
            subscribeData.push(data["group-assignments"][i]);
            subscribeData[count]['showInput'] = true;
            subscribeData[count]['isGrpRep'] = false;
            subscribeData[count]['filterTrue'] = true;
            if (data["group-assignments"][i]['apoStatus'].toLowerCase() != 'active') {
              subscribeData[count]['hideRow'] = true;
              subscribeData[count]['toggleRow'] = true;
            } else {
              subscribeData[count]['hideRow'] = false;
              subscribeData[count]['toggleRow'] = false;
            }
          }
          count += 1;
          if (this.companyGroupSectionIDS.indexOf(data["group-assignments"][i]['companyId']) == -1) {
            this.companyGroupSectionIDS.push(data["group-assignments"][i]['companyId']);
          }
          if (data["group-assignments"][i]['apoStatus'] != 'ARCHIVED' && data["group-assignments"][i]['apoStatus'] != 'INACTIVE') {
            if (this.companyIdForSite.indexOf(data["group-assignments"][i]['companyId']) == -1) {
              this.companyIdForSite.push(data["group-assignments"][i]['companyId']);
            }
          }
          companyAllianceIdentifierIds += `'${data["group-assignments"][i]['companyAllianceIdentifier']}',`;
          companyids += `'${data["group-assignments"][i]['companyId']}',`;
        }
        if (companyAllianceIdentifierIds != '') {
          this.getCompanyAllianceIdens(companyAllianceIdentifierIds);
        }
        if (companyids != '') {
          this.getCompanyBusinessEntities(companyids);
          this.getCpyAlcorCodes(companyids);
        }
      } else {
        this.loading1 = false;
      }
      if (data['maxPage'] > 1 && data['maxPage'] != curr_page) {
        this.getCompanyGroupSection(page, curr_page + 1, subscribeData, count);
      } else if (data['maxPage'] == curr_page) {
        this.companyGroupSection = [];
        subscribeData.forEach(element => {
          if (element.groupTypeCode.toLowerCase() == 'apo') {
            element.groupTypeCode = 'RGP'
          }
        });
        this.tempCompanySection = subscribeData;
        const visibleCompanies = subscribeData.filter(c => c.hideRow === false);
        this.pager = this.pagerService.getPager(visibleCompanies.length, page, TWENTY);
        this.companyGroupSection = visibleCompanies.slice(this.pager.startIndex, this.pager.endIndex + 1);
      }

      if (this.RoleByService['role'] == 'supplier' && this.companyGroupSection.length > 0 && this.supplierDefaultFilterReseted == false) {
        setTimeout(() => {
          this.filterStatus();

          if (this.onfirstTimeloadCompany) {
            this.onInitLoadCompany = true;
            this.onfirstTimeloadCompany = false
          }
          console.info("called..company..");

        }, ONE_SECOND_MS);

      }

    }, error => {
      console.info('data_error', error);
    });
  }

  getCompanyBusinessEntities(companyids, page = 1, subscribeData = []) {
    this.supplierService.getBusinessEntities(`${this.Config.ApiSupplierUrl}business-entities?companyId=in(${companyids.slice(0, -1)})&isHQ=Y&_page=${page}`).pipe(takeUntil(this.ngUnsubscribe)).subscribe((data2: any) => {

      if (data2['business-entities'].length > 0) {
        data2['business-entities'].forEach(ele => {
          subscribeData.push(ele);
        });
        if (data2['maxPage'] > 1 && data2['maxPage'] != page) {
          this.getCompanyBusinessEntities(companyids, page + 1, subscribeData);
        } else if (data2['maxPage'] == page) {
          let tempArr = [];
          let tempArr2 = [];
          var dispbvdRow = '';
          for (let i = 0; i < data2['business-entities'].length; i++) {
            tempArr.push(data2['business-entities'][i]['row_id']);
            if (tempArr2[data2['business-entities'][i]['row_id']] == undefined) {
              tempArr2[data2['business-entities'][i]['row_id']] = []
            }
            tempArr2[data2['business-entities'][i]['row_id']] = data2['business-entities'][i]['companyId'];
            if (data2['business-entities'][i]['companyId'] == this.cpyRepGrpId) {
              dispbvdRow = data2['business-entities'][i]['row_id'];
              this.businessIdForBvd = data2['business-entities'][i]['row_id'];
            }
          }
          if (tempArr.length > 0) {
            this.getBvdIdValues(tempArr, tempArr2, dispbvdRow);
          } else {
            this.loading1 = false;
          }
        }
      } else {
        this.loading1 = false;
      }
    });
  }

  getBvdIdValues(tempArr, tempArr2, dispbvdRow, page = 1) {
    let archiveBvdId = '';
    let archiveBvdIdval = '';
    let notArchived;
    this.supplierService.getBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers?businessEntityIdentifierTypeName=BVD ID&businessEntityId=in(${tempArr})&_page=${page}`).subscribe(data3 => {
        if (data3 != null && data3['business-entity-identifiers'].length > 0) {
          data3["business-entity-identifiers"].forEach(ele => {
            if (ele.endDate == '') {
              this.companygroupsecmaintaxidenti[tempArr2[ele.businessEntityId]] = ele.value;
            }
            if (ele.businessEntityId == dispbvdRow && ele.endDate == '') {
              this.sitebvidid = '';
              this.sitebvidid = ele.value;
              this.showArchivedBvdId = false;
              this.tempBvdId = ele.row_id;
              notArchived = true;
            } else if (ele.businessEntityId == dispbvdRow) {
              archiveBvdId = ele.row_id;
              archiveBvdIdval = ele.value;
              notArchived = false;
              this.showArchivedBvdId = true;
            }
          });
          if (notArchived == false) {
            this.sitebvidid = '';
            this.showArchivedBvdId = true;
            this.tempBvdId = archiveBvdId;
            this.sitebvidid = archiveBvdIdval;
          }

          if (data3['maxPage'] > 1 && data3['maxPage'] != page) {
            this.getBvdIdValues(tempArr, tempArr2, dispbvdRow, page + 1);
          }
        }
        if (data3['maxPage'] == page) {
          this.getSiteCityCountryOfHQ(tempArr);
          this.loading1 = false;
          this.getInPortfolioDetails();
        }
      });
  }

  getCompanyAllianceIdens(companyAllianceIdentifierIds, page = 1) {
    this.supplierService.getCompanies(`${this.Config.ApiSupplierUrl}companies?allianceIdentifier=in(${companyAllianceIdentifierIds.slice(0, -1)})&_page=${page}`).pipe(takeUntil(this.ngUnsubscribe)).subscribe((data1: any) => {
      data1["companies"].forEach(e => {
        this.companygroupsecstatus[e.allianceIdentifier] = e.companyStatusCode;
        this.compRowId.push(e.rowId);
        e['filterTrue'] = true;
        if (this.companyStatus[e.rowId] == undefined) {
          this.companyStatus[e.rowId] = [];
        }
        if (this.companyStatus[e.rowId]) {
          this.companyStatus[e.rowId] = [e.companyStatusCode]
        }
      });
      if (data1['maxPage'] > 1 && data1['maxPage'] != page) {
        this.getCompanyAllianceIdens(companyAllianceIdentifierIds, page + 1);
      }
      if (data1['maxPage'] == page) {
        this.getShortNameForCpy();
      }
    });
  }

  getContactEmailGroupSection() {
    this.contactsService.getPersonAddresses(`${this.Config.ApinewContactsUrl}personAddresses`).pipe(takeUntil(this.ngUnsubscribe)).subscribe((data: any) => {
      if (data["personAddresses"] && data["personAddresses"] != null) {
        let j = 0;
        for (let i = 0; i < data["personAddresses"].length; i++) {
          if ((data["personAddresses"][i]['addressType'] == 'EMAIL')) {
            this.contactEmailGroupSection[data["personAddresses"][i]['personRowId']] = (data["personAddresses"][i]);
          }
          if (data["personAddresses"][i]['addressType'] == 'TELEPHONE' && data["personAddresses"][i]['summary'].slice(-1) == 'P') {
            this.contactcellphoneGroupSection[data["personAddresses"][i]['personRowId']] = (data["personAddresses"][i]);
          }
          if (data["personAddresses"][i]['addressType'] == 'TELEPHONE' && data["personAddresses"][i]['summary'].slice(-1) == 'F') {
            this.contactTelephoneGroupSection[data["personAddresses"][i]['personRowId']] = (data["personAddresses"][i]);
          }
        }
      }
    }, error => {
      this.getContactEmailGroupSection();
      console.info('data_error', error);
    });
  }



  PersonAddresses(page = 1, subscribeData = []) {
    this.contactsService.getPersonAddresses(`${this.Config.ApinewContactsUrl}personAddresses?personRowId=in(${this.AllPersonIdArr})&_page=${page}`).subscribe((data: any) => {
      if (data['personAddresses'].length > 0) {
        data['personAddresses'].forEach(element => {
          subscribeData.push(element);
        });
        if (data['maxPage'] == undefined) {
          subscribeData.forEach(element => {
            if (this.AllPersonIdArr.includes(element.personRowId) == 1) {
              if (element.addressType.toLowerCase() == "email") {
                this.PersonDetails[`${element.personRowId}_email`] = element.summary;
                this.PersonDetails[`${element.personRowId}_addIDEmail`] = element.addressId;
              }
              if (element.addressType.toLowerCase() == "telephone") {
                var addsplit = element.summary.split("*");
                if (addsplit.length > 1) {
                  if (addsplit[1].trim() != undefined && (addsplit[1].trim()).toLowerCase() == "p") {
                    this.PersonDetails[`${element.personRowId}_p`] = addsplit[0];
                    this.PersonDetails[`${element.personRowId}_addIDp`] = element.addressId;
                  }
                  if (addsplit[1].trim() != undefined && (addsplit[1].trim()).toLowerCase() == "f") {
                    this.PersonDetails[`${element.personRowId}_f`] = addsplit[0];
                    this.PersonDetails[`${element.personRowId}_addIDf`] = element.addressId;
                  }
                }
              }
            }
          });

        }
        else {
          if (data['maxPage'] > 1 && data['maxPage'] != page) {
            this.PersonAddresses(page + 1, subscribeData);
          } else if (data['maxPage'] == page) {
            subscribeData.forEach(element => {
              if (this.AllPersonIdArr.includes(element.personRowId) == 1) {
                if (element.addressType.toLowerCase() == "email") {
                  this.PersonDetails[`${element.personRowId}_email`] = element.summary;
                  this.PersonDetails[`${element.personRowId}_addIDEmail`] = element.addressId;
                }
                if (element.addressType.toLowerCase() == "telephone") {
                  var addsplit = element.summary.split("*");
                  if (addsplit.length > 1) {
                    if (addsplit[1].trim() != undefined && (addsplit[1].trim()).toLowerCase() == "p") {
                      this.PersonDetails[`${element.personRowId}_p`] = addsplit[0];
                      this.PersonDetails[`${element.personRowId}_addIDp`] = element.addressId;
                    }
                    if (addsplit[1].trim() != undefined && (addsplit[1].trim()).toLowerCase() == "f") {
                      this.PersonDetails[`${element.personRowId}_f`] = addsplit[0];
                      this.PersonDetails[`${element.personRowId}_addIDf`] = element.addressId;
                    }
                  }
                }
              }
            });
            this.getPersonsIpns(this.AllPersonIdArr);
          }
        }
      }
    });
    this.ContactsFlag = true;
  }

  getPersonsIpns(AllPersonIdArr) {
    if (AllPersonIdArr.length > 0) {
      this.contactsService.getUsers(`${this.Config.ApinewContactsUrl}users?personRowId=in(${AllPersonIdArr})`).subscribe(data => {
        if (data['users'].length > 0) {
          data['users'].forEach(e => {
            if (data['users'][0]['loginId'] && data['users'][0].endDate == '') {
              this.endDateisPresent = true;
            } else {
              this.endDateisPresent = false;
            }
            this.personIpn[e.personRowId] = e;
          });
        }
      });
    }
  }

  groupRoles(page = 1, loopCRole = "yes") {
    this.contactsService.getSuppliergroupRoles(`${this.Config.ApinewContactsUrl}supplierGroupRoles?supplierGroup=CtcSupplierGroupService:${this.groupId}&personRoleStatus=VALIDATED&_page=${page}`).subscribe((data: any) => {
      if (loopCRole == "yes") {
        this.GroupIdRole = [];
        this.GroupContacts = [];
        this.AllPersonIdArr = [];
        this.GroupIdRoleDetails = [];
      }
      data['supplierGroupRoles'].forEach(element => {
        var compID = ''
        this.showGroupContactsBlock = true
        if (element.supplierGroup) {
          if (typeof element.supplierGroup === 'string') {
            compID = element.supplierGroup.split(':')
          } else {
            compID = element.supplierGroup.href.split("/");
          }
          if (this.groupId == compID[1] && element.personRoleStatus.toLowerCase() == "validated") {
            let captain_exist = this.GroupIdRole.indexOf(compID[1]);
            if (captain_exist == -1) {
              this.GroupIdRole.push(compID[1])
              this.GroupIdRoleDetails[compID[1]] = []
            }
            this.GroupIdRoleDetails[compID[1]].push(element);

            let personRowidexist = this.AllPersonIdArr.indexOf(element.personRowId)
            if (personRowidexist == -1) {
              this.AllPersonIdArr.push(element.personRowId);
            }
          }
        }
      });
      var jx = 1;
      if (data['maxPage'] > 1 && loopCRole != "stop") {
        for (jx = TWO; jx <= data['maxPage']; jx++) {
          this.groupRoles(jx, 'stop');
        }
      }
      this.GroupContactsLoading = false;
      if (this.GroupIdRoleDetails[this.groupId] != undefined) {
        this.GroupContacts = this.GroupIdRoleDetails[this.groupId];
        console.info("group Contacts", this.GroupContacts);
        if (this.AllPersonIdArr.length > 0) {
          this.PersonAddresses();

        } else {
          this.ContactsFlag = true;
        }

      } else {
        this.ContactsFlag = true;
      }
    }, error => {
      console.info('data_error', error);
    });
  }

  AddEditGrpContact(type, rowIdd = null) {
    console.info(type, rowIdd);
    this.Editcontact_rowId = "";
    this.saveDatas = 'Save';
    this.personRowId = "";
    this.updPersonId = "";
    this.isReadOnly = false;
    this["GrpConIpn"] = "";
    this["GrpConCellphone"] = "";
    this["GrpConPhone"] = "";
    this.GrpConRoleSelected = "";
    this.Editrow_id_grpContactcs = "";
    this.disableEmail = false;
    if (type == "load") {
      this.grp_ShowNext = true;
      this.grp_ShowSave = false;
      this.GrpConEmailexistsError = false;
      this.grp_modelLabelName = false;
      this.grp_modelIpn = false;
      this.grp_modelFname = false;
      this.grp_modelLname = false;
      this.grp_modelCellphone = false;
      this.grp_modelPhone = false;

      this.grp_modelRole = false;

      this.GrpConField.forEach(element2 => {
        this[element2] = "";
        this[`${element2}Error`] = false;
        if (element2 == "GrpConCellphone" || element2 == "GrpConPhone") {
          this[`${element2}Error2`] = false;
        }
      });
      this.getPersonRoleType();
    }
    if (type == "add") {
      this.GrpConField.forEach(element2 => {
        this[element2] = "";
        this[`${element2}Error`] = false;
        if (element2 == "GrpConCellphone" || element2 == "GrpConPhone") {
          this[`${element2}Error2`] = false;
        }
      });
      this.getPersonRoleType();
    } else if (type == "edit") {
      console.info("Person Details", this.PersonDetails)
      this.Editcontact_rowId = rowIdd;
      this.fixedPhoneEdit = false;
      this.cellPhoneEdit = false;
      this.changedRoleId = rowIdd;
      this.GroupContacts.forEach(element => {
        if (element.rowId == rowIdd) {
          this.personRowId = element.personRowId;
          this.upd_usersRow_id = "";
          this.Editrow_id_grpContactcs = element.rowId;
          this["GrpConFname"] = element.personFirstName;
          this["GrpConLname"] = element.personLastName;
          this["GrpConRole"] = element.roleTypeId;
          this.GrpConRoleSelected = element.roleTypeCode;
          this["GrpConEmail"] = this.PersonDetails[`${element.personRowId}_email`] ? this.PersonDetails[`${element.personRowId}_email`] : '';
          this["GrpConPhone"] = this.PersonDetails[`${element.personRowId}_f`] ? this.PersonDetails[`${element.personRowId}_f`].trim() : '';
          this["GrpConCellphone"] = this.PersonDetails[`${element.personRowId}_p`] ? this.PersonDetails[`${element.personRowId}_p`].trim() : '';
          this.personUserscompcontact(this.personRowId, "No"); (this.personRowId, "No");
        }
      });
    }
  }

  getPersonRoleType(page = 1, roles = []) {
    this.PersonRoleSelectOp = roles
    this.contactsService.getPersonRoleTypes(`${this.Config.ApinewContactsUrl}personRoleTypes?categoryCode=Group%20Contact&_page=${page}`).subscribe((data: any) => {
      if (data['personRoleTypes'].length > 0) {
        data['personRoleTypes'].forEach(element => {
          if (element.categoryCode.toLowerCase() == "group contact") {
            this.PersonRoleSelectOp.push({ "rowId": element.rowId, "roleTypeCode": element.roleTypeCode, "roleTypeLabel": element.roleTypeLabel });
          }
        });
        if (data['maxPage'] > 1 && data['maxPage'] != page) {
          this.getPersonRoleType(page + 1, this.PersonRoleSelectOp);
        }
      }
    });
  }

  resetGrpContact(fieEld) {
    if (fieEld != 'Email') {
      this[`GrpCon${fieEld}`] = "";
      if (fieEld != "Ipn" && fieEld != "Cellphone" && fieEld != "Phone") {
        this[`GrpCon${fieEld}`] = "";
        this[`GrpCon${fieEld}Error2`] = false;
        this[`GrpCon${fieEld}Error`] = true;
        if (fieEld == "Fname" || fieEld == "Lname") {
          this["GrpConIpn"] = "";
          this["GrpConPhone"] = "";
          this["GrpConCellphone"] = "";
        }
      }
      if (fieEld == "Cellphone" || fieEld == "Phone") {
        this[`GrpCon${fieEld}`] = "";
        this[`GrpCon${fieEld}Error2`] = false;
        this[`GrpCon${fieEld}Error`] = true;
      } else {
        this[`GrpCon${fieEld}Error`] = false;
      }
    }
    else {
      if (!this.disableEmail) {
        this[`GrpCon${fieEld}`] = "";
      }
    }
  }

  GrpCntemptyCheck(fieEld) {
    if (fieEld != "Ipn" && fieEld != "Cellphone" && fieEld != "Phone") {
      if ((this[`GrpCon${fieEld}`]).trim() == '') {
        this[`GrpCon${fieEld}Error`] = true;
      } else {
        this[`GrpCon${fieEld}Error`] = false;
        if (fieEld == "Cellphone" || fieEld == "Phone") {
          if (!/^[ 0-9\+]*$/.test(this[`GrpCon${fieEld}`])) {
            this[`GrpCon${fieEld}Error`] = false;
            this[`GrpCon${fieEld}Error2`] = true;
          } else {
            this[`GrpCon${fieEld}Error2`] = false;
          }
        }
        if (fieEld == "Email") {

        }
      }
    }
    if (fieEld == "Cellphone" || fieEld == "Phone") {
      if ((this[`GrpCon${fieEld}`]).trim() == '') {
        this[`GrpCon${fieEld}Error`] = true;
      } else {
        this[`GrpCon${fieEld}Error`] = false;
        if (!/^[ 0-9\+]*$/.test(this[`GrpCon${fieEld}`])) {
          this[`GrpCon${fieEld}Error`] = false;
          this[`GrpCon${fieEld}Error2`] = true;
        } else {
          this[`GrpCon${fieEld}Error2`] = false;
        }
      }
    }
  }

  focusOutFunction() {
    this["GrpConIpn"] = "";
    this["GrpConEmail"] = "";
    this["GrpConPhone"] = "";
    this["GrpConCellphone"] = "";
    this.GrpConEmailExists = '';
    this.personRowId = "";
    if (this["GrpConFname"] != undefined && this["GrpConLname"] != undefined && this["GrpConFname"].trim() != "" && this["GrpConLname"].trim() != "") {
      this.contactsService.getPersons(`${this.Config.ApinewContactsUrl}persons?_page=1&personFirstName=${this["GrpConFname"].trim()}&personLastName=${this["GrpConLname"]}`).subscribe((data: any) => {
        if (data['persons'].length > 0) {
          data['persons'].forEach(element => {
            if (element.personFirstName.toLowerCase() == this["GrpConFname"].toLowerCase() && element.personLastName.toLowerCase() == this["GrpConLname"].toLowerCase()) {
              this.personRowId = element.rowId;
              this.personUsers(element.rowId);
              return false;
            } else {
              this.isReadOnly = false;
            }
          });
        }
      });
    } else {
      this.isReadOnly = false;
    }
  }

  personUsers(RowID, next = "Yes") {
    this.contactsService.getPersons(`${this.Config.ApinewContactsUrl}persons/${this.personRowId}/users`).subscribe((data: any) => {
      if (data['users'].length > 0 && data['users'][0]['loginType'].toLowerCase() == "renault_ipn") {
        this.personRowId = data['users'][0]['personRowId'];
        this["GrpConIpnError"] = false;
        if (data['users'][0].endDate) {
          this.endDateisPresent = true;
        } else {
          this.endDateisPresent = false;
        }
        this["GrpConIpn"] = data['users'][0]['loginId'];
        this.upd_usersRow_id = data['users'][0]['rowId'];
      }

      if (next == "Yes") {
        this.personAddresses(RowID);
      } else {
        if (data['users'].length > 0 && data['users'][0]['loginType'].toLowerCase() == "renault_ipn") {
          this.personRowId = data['users'][0]['personRowId'];
        } else {
          this["GrpConIpn"] = "";
        }
      }
    });
  }

  personUserscompcontact(RowID, next = "Yes") {
    if (this.personRowId != '') {
      this.contactsService.getPersonAddresses(`${this.Config.ApinewContactsUrl}personAddresses?personRowId=${this.personRowId}`).subscribe((data: any) => {
        if (data['personAddresses'].length > 0) {
          this.contactsService.getUsers(`${this.Config.ApinewContactsUrl}users?personRowId=${data['personAddresses'][0].personRowId}`).subscribe((usrdata: any) => {
            if (usrdata.users.length > 0 && usrdata['users'][0]['loginType'].toLowerCase() == "renault_ipn") {
              console.info('IPn', usrdata)
              this.grpModelIpn = usrdata["users"][0].loginId
              this["GrpConIpnError"] = false;
              this["GrpConIpn"] = usrdata["users"][0].loginId
              this.personRowId = usrdata["users"][0]['personRowId'];
              this.upd_usersRow_id = usrdata['users'][0]['rowId'];
              if (usrdata['users'][0]['loginId'] && usrdata['users'][0].endDate == '') {
                this.endDateisPresent = true;
              } else if (usrdata["users"][0]['loginId'] == "") {
                this.endDateisPresent = false;
              } else {
                this.endDateisPresent = false;
              }
              this.getPersonRoleType();
            }
            if (next == "Yes") {
              this.personAddresses(RowID);
            } else {
              if (usrdata['users'].length > 0 && usrdata['users'][0]['loginType'].toLowerCase() == "renault_ipn") {
                this.personRowId = usrdata['users'][0]['personRowId'];
              } else {
                this["GrpConIpn"] = "";
                this.getPersonRoleType();
              }
            }
          }, _err => {
            this["GrpConIpn"] = "";
          });
        }
      });
    }
  }

  personAddresses(RowID) {
    this.contactsService.getPersons(`${this.Config.ApinewContactsUrl}persons/${RowID}/personAddresses`).subscribe((data: any) => {
      if (data['personAddresses'].length > 0) {
        data['personAddresses'].forEach(element => {
          if (element.addressType.toLowerCase() == "email") {
            this["GrpConEmailError"] = false;
            this["GrpConEmail"] = element.summary;
            this.GrpConEmailExists = element.summary;
            if (element.summary != '') this.isReadOnly = true;
            else this.isReadOnly = false;

          }
          if (element.addressType.toLowerCase() == "telephone") {
            var cpSplit = element.addressSummary.split('*');
            if (cpSplit.length > 1) {
              if (cpSplit[1].toLowerCase().trim() == "f") {
                this["GrpConPhoneError"] = false;
                this["GrpConPhone"] = cpSplit[0].trim();
              }
              if (cpSplit[1].toLowerCase().trim() == "p") {
                this["GrpConCellphoneError"] = false;
                this["GrpConCellphone"] = cpSplit[0].trim();
              }
            }
          }
        });
      }
    });
  }

  toggleGroupContacts() {
    this.showGroupContactsBlock = !this.showGroupContactsBlock;
  }
  GrpCntRoleSelected(event: any) {
    this.GrpConRole = event.value;
    this.grpConRoleexists = false;
    this.grpRolechanged = false;

    if (this.GrpConRole != undefined && this.GrpConRole != "") {
      this.GroupContacts.forEach(element => {
        if ((this.PersonDetails[`${element.personRowId}_email`] ? this.PersonDetails[`${element.personRowId}_email`] : '') == this.GrpConEmail && element.roleTypeId == this.GrpConRole) {
          this.grpRolechanged = true;
          this.grpConRoleexists = true;
          this["GrpConRoleError"] = false;
        }
        else {
          this.grpRolechanged = true;
          this["GrpConRoleError"] = false;
        }
      });
    }
    else {
      this["GrpConRoleError"] = true;

    }
  }

  AddEditSaveGrpCnt(SaveType) {
    var validationGrpCnt = true;
    this.GrpConField.forEach(element2 => {
      console.info(element2)
      if (SaveType == 'next') {
        if (this['GrpConEmail'] == undefined || this['GrpConEmail'].trim() == "") {
          this['GrpConEmail' + "Error"] = true;
          validationGrpCnt = false;
          return false;
        } else {
          this[`${element2}Error`] = false;
        }
      }
      if (SaveType == 'add') {
        if (element2 != 'GrpConEmail') {
          if (this[element2] == undefined || this[element2].trim() == "") {
            this[`${element2}Error`] = true;
            validationGrpCnt = false;
            return false;
          } else {
            this[`${element2}Error`] = false;
          }
        }
      }
    });
    if (validationGrpCnt == true) {
      if (SaveType == "add" && this.grpConRoleexists == false) {
        if (this.personRowId != "") {
          if (this.GrpConEmailExists != '' && this.GrpConEmailExists != this['GrpConEmail'] && this.personRowId == '') {

            const datas10 = {
              personFirstName: this["GrpConFname"],
              personLastName: this["GrpConLname"]
            };
            this.contactsService.createPersons(`${this.Config.ApinewContactsUrl}persons`, datas10).subscribe((data: any) => {
              this.personRowId = data.rowId;
              if (data.rowId != "") {
                this.newPersonId(data.rowId);
              }
            });

          } else {
            const datas = {
              roleTypeId: this["GrpConRole"],
              personRowId: this.personRowId,
              supplierGroup: `CtcSupplierGroupService:${this.groupId}`,
              personRoleStatus: "VALIDATED",
              startDate: this.apiService.getTodayDate()
            };
            this.contactsService.createSuppliergroupRoles(`${this.Config.ApinewContactsUrl}supplierGroupRoles`, datas).subscribe((_data: any) => {
              this.groupRoles();
              window.document.getElementById("closeGrpContacts").click();
            });
          }

        } else {
          const datas10 = {
            personFirstName: this["GrpConFname"],
            personLastName: this["GrpConLname"]
          };
          this.contactsService.createPersons(`${this.Config.ApinewContactsUrl}persons`, datas10).subscribe((data: any) => {
            this.personRowId = data.rowId;
            if (data.rowId != "") {
              this.newPersonId(data.rowId);
            }
          });
        }
      } else if (SaveType == "edit") {
        let proceedToCreate = true;
        console.info('CompanyContacts', this.GroupContacts);
        console.info('personRowId', this.personRowId);
        this.GroupContacts.forEach(ele => {
          if (ele.roleTypeId == this["GrpConRole"] && ele.personRowId == this.personRowId) {
            proceedToCreate = false;
            console.info('role exists');
            document.getElementById('closeEditGrpConRole').click();
            document.getElementById('btnForOpenRoleExistsWarning').click();
          }
          window.document.getElementById("closeContactAndRole").click();
        });
        if (proceedToCreate == true) {
          console.info('personRowId', this.personRowId);
          console.info('upd_usersRow_id', this.upd_usersRow_id);
          console.info('grpRolechanged', this.grpRolechanged);
          console.info('changedRoleId', this.changedRoleId);
          console.info('PersonRoleSelectOp', this.PersonRoleSelectOp);
          console.info('this["GrpConRole"]', this["GrpConRole"]);
          if (this.personRowId != "") {
            if (this.grpRolechanged == true && this.changedRoleId != '') {
              let typeCode = '';
              this.PersonRoleSelectOp.forEach(ele => {
                if (ele.rowId == this["GrpConRole"]) {
                  typeCode = ele.roleTypeCode;
                }
              });
              const datas2 = {
                roleTypeId: this["GrpConRole"],
                roleTypeCode: typeCode
              }
              this.contactsService.updateSuppliergroupRoles(`${this.Config.ApinewContactsUrl}supplierGroupRoles/${this.changedRoleId}`, datas2).subscribe(_data => {
                this.groupRoles();
              });
            } else {
              const datas = {
                roleTypeId: this["GrpConRole"],
                personRowId: this.personRowId,
                supplierGroup: `CtcSupplierGroupService:${this.groupId}`,
                personRoleStatus: "VALIDATED",
              };

              this.contactsService.createSuppliergroupRoles(`${this.Config.ApinewContactsUrl}supplierGroupRoles`, datas).subscribe((_data: any) => {
                this.groupRoles();

              },
                err => {
                  console.info(err)
                });
            }
            const datas20 = {
              loginId: this["GrpConIpn"]
            };
            this.contactsService.updateUsers(`${this.Config.ApinewContactsUrl}users/${this.upd_usersRow_id}`, datas20).subscribe((_data: any) => {
              this.updateEmail();
            });
          } else {
            this.newPersonId(this.personRowId, "updNewIPN");
          }
        }
      }
      else if (SaveType == "next") {
        this.addcompanycontact_emailnext();
      }
    }
  }

  addcompanycontact_emailnext() {
    var ipnExists = false;
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    let valid = emailRegex.test(this.GrpConEmail)
    if (valid) {
      this.GrpConEmailFormatError = false
      if (this.GrpConEmailexistsError == false) {
        this.disableEmail = true;
        this.contactsService.getPersonAddresses(`${this.Config.ApinewContactsUrl}personAddresses?summary=${this.GrpConEmail}`).subscribe((data: any) => {
          if (data['personAddresses'].length > 0) {
            this.grpModelName = `${data['personAddresses'][0]["personFirstName"]} ${data['personAddresses'][0]["personLastName"]}`;
            this.GrpConFname = data['personAddresses'][0]["personFirstName"];
            this.GrpConLname = data['personAddresses'][0]["personLastName"];
            this.personRowId = data['personAddresses'][0]["personRowId"];
            this.contactsService.getUsers(`${this.Config.ApinewContactsUrl}users?personRowId=${data['personAddresses'][0].personRowId}`).subscribe((usrdata: any) => {
              if (usrdata.users.length > 0) {
                console.info('IPn', usrdata)
                this.grpModelIpn = usrdata["users"][0].loginId;
                ipnExists = true;
              }
              if (ipnExists) {
                this.grp_modelLabelName = true;
                this.grp_modelIpn = true;
                this.grp_modelRole = true;
                this.grp_modelFname = false;
                this.grp_modelLname = false;
                this.grp_modelCellphone = false;
                this.grp_modelPhone = false;
                this.grp_ShowNext = false;
                this.grp_ShowSave = true;
                this.getPersonRoleType();
              }
              else {
                this.grp_modelLabelName = true;
                this.grp_modelIpn = false;
                this.grp_modelRole = true;
                this.grp_modelFname = false;
                this.grp_modelLname = false;
                this.grp_modelCellphone = false;
                this.grp_modelPhone = false;
                this.grp_ShowNext = false;
                this.grp_ShowSave = true;
                this.getPersonRoleType();
              }
            }, _err => {
              this.grp_modelLabelName = true;
              this.grp_modelIpn = false;
              this.grp_modelRole = true;
              this.grp_modelFname = false;
              this.grp_modelLname = false;
              this.grp_modelCellphone = false;
              this.grp_modelPhone = false;
              this.grp_ShowNext = false;
              this.grp_ShowSave = true;
              this.getPersonRoleType()
            })



          } else {
            this.grp_modelLabelName = false;
            this.grp_modelIpn = false;
            this.grp_modelRole = true;
            this.grp_modelFname = true;
            this.grp_modelLname = true;
            this.grp_modelCellphone = true;
            this.grp_modelPhone = true;
            this.grp_ShowNext = false;
            this.grp_ShowSave = true;
            this.getPersonRoleType();
          }
        });
      }
    } else {
      this.GrpConEmailFormatError = true
    }
  }

  updateEmail() {
    var add_ID = this.PersonDetails[`${this.personRowId}_addIDEmail`];
    if (add_ID == undefined) {
      this.updateFphone();
    } else {
      const datas21 = {
        email: this["GrpConEmail"]
      };
      this.contactsService.updateEmailAddresses(`${this.Config.ApinewContactsUrl}emailAddresses/${add_ID}`, datas21).subscribe((_data: any) => {
        this.updateFphone();
      });
    }

  }

  updateFphone() {
    if (this["GrpConPhone"] != undefined && this["GrpConPhone"].trim() != "") {
      var add_IDf = this.PersonDetails[`${this.personRowId}_addIDf`];
      if (add_IDf == undefined) {
        this.newFixedphoneCreate("UpdateFphone");
      } else {
        const datas22 = {
          phoneNumber: this["GrpConPhone"]
        };
        this.contactsService.updateTelephoneAddresses(`${this.Config.ApinewContactsUrl}telephoneAddresses/${add_IDf}`, datas22).subscribe((_data: any) => {
          this.updateCphone();
        });
      }
    } else {
      this.updateCphone();
    }
  }

  updateCphone() {
    if (this["GrpConCellphone"] != undefined && this["GrpConCellphone"].trim() != "") {
      var add_IDc = this.PersonDetails[`${this.personRowId}_addIDp`];
      if (add_IDc == undefined) {
        this.newCellphoneCreate("UpdateCphone");
        window.document.getElementById("closeEditGrpConRole").click();
      } else {
        const datas23 = {
          phoneNumber: this["GrpConCellphone"]
        };
        this.contactsService.updateTelephoneAddresses(`${this.Config.ApinewContactsUrl}telephoneAddresses/${add_IDc}`, datas23).subscribe((_data: any) => {
          this.PersonAddresses();
          window.document.getElementById("closeEditGrpConRole").click();
        });
      }
    } else {
      this.PersonAddresses();
      window.document.getElementById("closeEditGrpConRole").click();
    }
  }

  newPersonId(_personRowID, Next = "Yes") {
    if (this["GrpConIpn"] != undefined && this["GrpConIpn"].trim() != "") {
      const datas11 = {
        loginId: this["GrpConIpn"],
        loginType: "RENAULT_IPN",
        personRowId: this.personRowId
      };
      this.contactsService.createUsers(`${this.Config.ApinewContactsUrl}users`, datas11).subscribe((_data: any) => {
        if (Next == "Yes") {
          this.newFixedphoneCreate();
        } else if (Next == "updNewIPN") {
          this.updateEmail();
        }
      });
    } else {
      this.newEmailCreate();
    }
  }

  newEmailCreate(Next = "Yes") {
    const datas12 = {
      email: this["GrpConEmail"]
    };
    this.contactsService.createEmailAddress(`${this.Config.ApinewContactsUrl}emailAddresses`, datas12).subscribe((data: any) => {
      if (Next == "Yes") {
        this.linkEmailtoAddresses(data.rowId);
      }
    });
  }

  linkEmailtoAddresses(email_rowID) {
    const datas13 = {
      personRowId: this.personRowId,
      addressId: email_rowID
    };
    this.contactsService.createPersonAddresses(`${this.Config.ApinewContactsUrl}personAddresses`, datas13).subscribe((_data: any) => {
      this.newFixedphoneCreate();
    });
  }

  newFixedphoneCreate(Next = "Yes") {
    if (this["GrpConPhone"] != undefined && this["GrpConPhone"].trim() != "") {
      const datas14 = {
        phoneType: "F",
        phoneNumber: this["GrpConPhone"]
      };
      this.contactsService.createTelephoneAddress(`${this.Config.ApinewContactsUrl}telephoneAddresses`, datas14).subscribe((data: any) => {
        if (Next == "Yes") {
          this.linkFixedphonetoAddresses(data.rowId);
        } else if (Next == "UpdateFphone") {
          this.linkFixedphonetoAddresses(data.rowId, "GotoUpdatephone");
        }
      });
    } else {
      this.newCellphoneCreate();
    }

  }

  linkFixedphonetoAddresses(Fphone_rowID, Next = "Yes") {
    const datas15 = {
      personRowId: this.personRowId,
      addressId: Fphone_rowID
    };
    this.contactsService.createPersonAddresses(`${this.Config.ApinewContactsUrl}personAddresses`, datas15).subscribe((data: any) => {
      if (Next == "Yes") {
        this.newCellphoneCreate();
      } else if (Next == "GotoUpdatephone") {
        this.PersonDetails[`${this.personRowId}_addIDf`] = data.addressId;
        this.PersonDetails[`${this.personRowId}_f`] = this["GrpConPhone"];
        this.updateFphone();
      }
    });
  }

  newCellphoneCreate(Next = "Yes") {
    if (this["GrpConCellphone"] != undefined && this["GrpConCellphone"].trim() != "") {
      const datas16 = {
        phoneType: "P",
        phoneNumber: this["GrpConCellphone"]
      };
      this.contactsService.createTelephoneAddress(`${this.Config.ApinewContactsUrl}telephoneAddresses`, datas16).subscribe((data: any) => {
        if (Next == "Yes") {
          this.linkcellphonetoAddresses(data.rowId);
        } else if (Next == "UpdateCphone") {
          this.linkcellphonetoAddresses(data.rowId, "GotoUpdatephone");
        }
      });
    } else {
      this.personToAllLinkAddresses();
    }
  }

  linkcellphonetoAddresses(Cellphone_rowID, Next = "Yes") {
    const datas17 = {
      personRowId: this.personRowId,
      addressId: Cellphone_rowID
    };
    this.contactsService.createPersonAddresses(`${this.Config.ApinewContactsUrl}personAddresses`, datas17).subscribe((data: any) => {
      if (Next == "Yes") {
        this.personToAllLinkAddresses();
      } else if (Next == "GotoUpdatephone") {
        this.PersonDetails[`${this.personRowId}_addIDp`] = data.addressId;
        this.PersonDetails[`${this.personRowId}_p`] = this["GrpConCellphone"];
        this.updateCphone();
      }

    });
  }

  personToAllLinkAddresses() {

    if (this.personRowId != "") {
      const datas18 = {
        roleTypeId: this["GrpConRole"],
        personRowId: this.personRowId,
        supplierGroup: `CtcSupplierGroupService:${this.groupId}`,
        personRoleStatus: "VALIDATED",
        startDate: this.apiService.getTodayDate()
      };
      this.contactsService.createSuppliergroupRoles(`${this.Config.ApinewContactsUrl}supplierGroupRoles`, datas18).subscribe((_data: any) => {
        this.groupRoles();
        window.document.getElementById("closeGrpContacts").click();
      });
    }
  }
  conInfoDEl() {
    this.contactsService.deletePersons(`${this.Config.ApinewContactsUrl}persons/${this.personRowId}`).subscribe((_data: any) => {
      this.contactsService.deleteEmailAddresses(`${this.Config.ApinewContactsUrl}emailAddresses/${this.PersonDetails[this.personRowId + '_addIDEmail']}`).subscribe(_data => { });
      if (this.PersonDetails[`${this.personRowId}_addIDf`] != undefined && this.PersonDetails[`${this.personRowId}_addIDf`] != '') {
        this.contactsService.deleteTelephoneAddresses(`${this.Config.ApinewContactsUrl}telephoneAddresses/${this.PersonDetails[this.personRowId + '_addIDf']}`).subscribe(_data => { });
      }
      if (this.PersonDetails[`${this.personRowId}_addIDp`] != undefined && this.PersonDetails[`${this.personRowId}_addIDp`] != '') {
        this.contactsService.deleteTelephoneAddresses(`${this.Config.ApinewContactsUrl}telephoneAddresses/${this.PersonDetails[this.personRowId + '_addIDp']}`).subscribe(_data => { });
      }
      this.groupRoles();
      window.document.getElementById("DeleteContact").click();
      window.document.getElementById("closeEditSiteConNameDetails").click();
      window.document.getElementById("closeContactAndRole").click();
    });
  }

  delContact() {
    if (this.personRowId != "") {
      this.contactsService.deletesupplierGroupRoles(`${this.Config.ApinewContactsUrl}supplierGroupRoles/${this.Editcontact_rowId}`).subscribe(_data => {
        if (this.upd_usersRow_id != undefined && this.upd_usersRow_id != '') {
          this.contactsService.deleteusers(`${this.Config.ApinewContactsUrl}users/${this.upd_usersRow_id}`).subscribe(_data => {
            this.conInfoDEl()
          });
        } else {
          this.conInfoDEl();
        }

      });
    }
  }

  checkEmailChanged() {
    this.GrpConEmailFormatError = false
    if (this.GrpConEmailExists != '' && this["GrpConEmail"] == this.GrpConEmailExists) {
      this.isReadOnly = true;
    } else {
      if (this.GrpConEmailExists != '') {
        this["GrpConIpn"] = "";
        this["GrpConPhone"] = "";
        this["GrpConCellphone"] = "";
      }
      this.isReadOnly = false;
    }
  }

  switchVisible(btnId) {
    this.openData = true;
    this.openRole = false;
    if (btnId === 'btn1') {
      this.openData = true;
      this.openRole = false;
    } else {
      this.openRole = true;
      this.openData = false;
    }
  }

  setEditConDetails(type) {
    this.editGrpConFname = this["GrpConFname"];
    this.editGrpConLname = this["GrpConLname"];
    this.editGrpConCellphone = this["GrpConCellphone"];
    this.editGrpConPhone = this["GrpConPhone"];
    this['GrpConFnameError'] = false;
    this['GrpConLnameError'] = false;
    this['GrpConCellphoneError'] = false;
    this['GrpConCellphoneError2'] = false;
    this['GrpConPhoneError'] = false;
    this['GrpConPhoneError2'] = false;
    if (type == 'cellPhone') {
      this.cellPhoneEdit = true;
    } else {
      this.cellPhoneEdit = false;
    } if (type == 'fixedPhone') {
      this.fixedPhoneEdit = true;
    } else {
      this.fixedPhoneEdit = false;
    }
  }

  editGrpConDetails(type) {
    if (type == 'name') {
      const datas = {
        personFirstName: this.editGrpConFname,
        personLastName: this.editGrpConLname
      };
      this.contactsService.updatePersons(`${this.Config.ApinewContactsUrl}persons/${this.personRowId}`, datas).subscribe((data: any) => {
        document.getElementById('closeEditGrpConNameDetails').click();
        this.groupRoles();
        this["GrpConFname"] = data.personFirstName;
        this["GrpConLname"] = data.personLastName;
      });
    } else if (type == 'phone' && this.GrpConPhoneError2 == false && this.GrpConPhoneError == false && this.GrpConCellphoneError == false && this.GrpConCellphoneError2 == false) {
      this.updateFphone();
      this.fixedPhoneEdit = false;
      this.cellPhoneEdit = false;
    }

  }

  resetGrpEditContact(field) {
    if (field == 'Fname' || field == 'Lname') {
      this[`editGrpCon${field}`] = '';
      this[`GrpCon${field}Error`] = true;
    } else {
      this[`GrpCon${field}Error`] = false;
    }
  }

  GrpEditCntemptyCheck(fieEld) {
    if (fieEld == 'Fname' || fieEld == 'Lname') {
      if ((this[`editGrpCon${fieEld}`]).trim() == '') {
        this[`GrpCon${fieEld}Error`] = true;
      } else {
        this[`GrpCon${fieEld}Error`] = false;
      }
    }
  }

  toggleGrpConEdit() {
    this["GrpConCellphone"] = this.editGrpConCellphone;
    this["GrpConPhone"] = this.editGrpConPhone;
    this.fixedPhoneEdit = false;
    this.cellPhoneEdit = false;
  }


  EditAlias(AliaType, AliaVal, AliaKey) {
    this.saveDatas = 'Save';
    this.EditAliasObj = "";
    this.disableEditGrpAliasBtn = false;
    this.EditAliasObj = { "AliasType": AliaType, "AliasKey": AliaKey, "AliasVal": AliaVal }
    this.EditAliasModel = AliaVal;
    if (AliaType == 'MDM GROUP') {
      document.getElementById('characterLimitForEdit').setAttribute('maxLength', '6');
    }
    else {
      document.getElementById('characterLimitForEdit').removeAttribute('maxLength');
    }
    this.EditGrpAlliasCharacterLimitError = false;
  }

  EditAliasEmptyCheck() {
    if ((this.EditAliasModel).trim() == '') {
      this.EditGrpAlliasValueError = true;
    } else {
      this.EditGrpAlliasValueError = false;
    }
  }

  resetEditAliasValue() {
    this.EditAliasModel = "";
    this.EditGrpAlliasValueError = true;
    this.EditGrpAlliasCharacterLimitError = false;
  }

  EditSaveGrpAllias(para) {
    if (this.EditAliasModel != undefined && this.EditAliasModel.trim() != "") {
      this.disableEditGrpAliasBtn = true;
      if (para == 'MDM GROUP' && this.EditAliasModel.length > TEN) {
        this.EditGrpAlliasCharacterLimitError = true;
        this.disableEditGrpAliasBtn = false;
      } else {
        this.saveDatas = "Saving...";
        const datas9 = {
          value: this.EditAliasModel
        };
        this.supplierService.updateGroupIdentifiers(`${this.Config.ApiSupplierUrl}group-identifiers/${this.EditAliasObj.AliasKey}`, datas9).subscribe((_data: any) => {
          window.document.getElementById("closeEditGrpAlias").click();
          this.getGroupAliasByRowid();
          this.saveDatas = "Save";
        });
      }
    } else {
      this.EditGrpAlliasValueError = true;
    }

  }

  getCompanies() {
    this.supplierService.getCompanies(`${this.Config.ApiSupplierUrl}companies`).pipe(takeUntil(this.ngUnsubscribe)).subscribe((data: any) => {
      if (data['companies'] && data['companies'] != null) {
        for (let i = 0; i < data['companies'].length; i++) {
          let skinName = this.companyGroupSection.find(x => x.companyId == data['companies'][i]['row_id']);
          if (skinName == undefined) {
            this.companyCodes.push(data['companies'][i]);
          }
          this.companyCodeids[this.trimSpaces(data['companies'][i]['legalName'])] = data['companies'][i]['row_id'];
        }
      }
    }, error => {
      this.getCompanies();
      console.info('data_error', error);
    });
  }

  updateCompanyToGroup() {
    if (typeof this.companyCodeids[this.companyCodeModelvalLabel] != 'undefined' && this.companyCodeModelval != '' && this.companyCodeModelval != undefined) {
      this.saveDatas = "Save...";
      this.companyCodeModelvalerror = false;
      this.supplierService.getGroupAssignments(`${this.Config.ApiSupplierUrl}group-assignment-types?groupAssignementTypeCode=apo`).subscribe((data: any) => {
        this.companyCodeScopeRowid = data['group-assignment-types'][0]['row_id'];
        if (this.companyCodeScopeRowid != '') {
          const datas = { validityStartDate: this.apiService.getTodayDate(), groupId: this.groupId, groupTypeId: this.companyCodeScopeRowid, apoStatus: 'ACTIVE', companyId: this.companyCodeModelval };
          this.supplierService.CreateGroupAssignment(`${this.Config.ApiSupplierUrl}group-assignments`, datas).subscribe((_data: any) => {
            this.companyCodes = [];
            this.companyCodeids = [];
            this.getCompanyGroupSection(1);
            window.document.getElementById("closeAGBtn").click();
            this.saveDatas = "Save";
          });
        } else {
          this.companyCodeModelvalerror = true;
        }
      });
    } else {
      this.companyCodeModelvalerror = true;
    }
  }

  updateAGExistsName() {
    this.saveDatas = 'Save';
    this.companyCodeModelval = '';
    this.companyCodeModelvalLabel = ''
    this.companyCodeModelvalerror = false;
  }

  resetAGSelectedFields() {
    this.companyCodeModelval = '';
    this.companyCodeModelvalLabel = '';
  }

  removeGroupContactExists(rowId: any) {
    this.removeDatas = "Remove";
    this.remvoeContactModelval = rowId;
  }

  removeGroupContactDetails() {
    if (this.remvoeContactModelval != '' && this.remvoeContactModelval != undefined) {
      this.removeDatas = "Remove...";
      const datas = { endDate: this.apiService.getTodayDate(), status: "ARCHIVED" };
      console.info("Removing group role", datas)
      this.contactsService.updateSuppliergroupRoles(`${this.Config.ApinewContactsUrl}supplierGroupRoles/${this.remvoeContactModelval}`, datas).subscribe((_data: any) => {
        this.contactGroupSection = [];
        this.GroupContacts = [];
        this.groupRoles();

        window.document.getElementById("closeRCBtn").click();
        this.removeDatas = "Remove";
      });
    }
  }

  delRole() {
    if (this.personRowId != "") {
      this.contactsService.deletesupplierGroupRoles(`${this.Config.ApinewContactsUrl}supplierGroupRoles/${this.Editcontact_rowId}`).subscribe(_data => { });
      setTimeout(() => {
        this.groupRoles()
      }, TWO_THOUSAND_MS)
      window.document.getElementById("closeRCBtn").click();
      window.document.getElementById("EditGrpConRole").click();
      window.document.getElementById("closeCCBtn").click();
      window.document.getElementById("closeContactAndRole").click();

    }
  }
  closeExistsGroupAliasPopup(aliasTypes) {
    this.aliasTypesArchive = '';
    this.aliasTypesArchive = aliasTypes;
    window.document.getElementById("closeEditGrpAlias").click();
  }

  archiveGroupAlias() {
    this.archiveDatas = "Archive...";
    const datas = { endDate: this.apiService.getTodayDate() };
    this.supplierService.updateGroupIdentifiers(`${this.Config.ApiSupplierUrl}group-identifiers/${this.EditAliasObj.AliasKey}`, datas).subscribe((_data: any) => {
      this.groupAlias = [];
      this.getGroupAliasByRowid();
      window.document.getElementById("closeGAliasArBtn").click();
      this.archiveDatas = "Archive";
    });
  }

  deleteGroupAlias() {
    this.supplierService.DeleteGroupIdentifiers(`${this.Config.ApiSupplierUrl}group-identifiers/${this.EditAliasObj.AliasKey}`).subscribe((_data: any) => {
      this.groupAlias = [];
      this.getGroupAliasByRowid();
      window.document.getElementById("closeGAliasDelBtn").click();
    });
  }

  dateToday() {
    let today = new Date();
    let dd = String(today.getDate()).padStart(TWO, '0');
    let mm = String(today.getMonth() + 1).padStart(TWO, '0');
    let yyyy = today.getFullYear();
    let todayDate = `${yyyy}-${mm}-${dd}`;
    return todayDate;
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next(undefined);
    this.ngUnsubscribe.complete();
  }
  setAsGroupRep() {
    if (this.selectedCpyRep != '' && this.selectedCpyRep != undefined) {
      this.loading1 = true;
      const const1 = { representingCompanyId: this.selectedCpyRep }
      this.supplierService.UpdateGroups(`${this.Config.ApiSupplierUrl}groups/${this.groupId}`, const1).subscribe(data => {
        if (data['representingCompanyId'] == '') {
          this.showEmptyRow = true;
        } else {
          this.showEmptyRow = false;
        }
        this.cpyRepGrpId = data['representingCompanyId'];
        this.selectedCpyRep = '';
        this.getCompanyGroupSection(1);
      }, _error => {
        this.loading1 = false;
      });
    }
  }
  changeSelection(value) {
    if (this.selectedCpyRep != '') {
      if (this.selectedCpyRep == value) {
        this.selectedCpyRep = '';
      }
    }
  }

  updateGroupTypeCodeFn() {
    if (this.groupTypeCodeModel != '' && this.groupTypeCodeModel != undefined) {
      this.saveDatas = 'Saving...';
      this.disableEditGrpCategory = true;
      const ssso = { 'groupTypes': this.groupTypeCodeDataAll[this.groupTypeCodeModel], 'groupTypeCode': this.groupTypeCodeModel }
      this.supplierService.UpdateGroups(`${this.Config.ApiSupplierUrl}groups/${this.groupId}`, ssso).subscribe(data => {
        this.groupTypeCode = data['groupTypeCode'];
        document.getElementById('closeGroupTypebtn').click();
      });
    } else {
      this.groupCategoryTypeCode = true;
    }
  }

  updateGroupTypeCode() {
    this.saveDatas = 'Save';
    this.groupCategoryTypeCode = false;
    this.disableEditGrpCategory = false;
    if (this.groupTypeCodeData.length === 0) {
      this.supplierService.getGroupTypes(`${this.Config.ApiSupplierUrl}group-types`).subscribe(data => {
        for (let i = 0; i < data['group-types'].length; i++) {
          this.groupTypeCodeData.push(data['group-types'][i]['groupTypeCode']);
          this.groupTypeCodeDataAll[data['group-types'][i]['groupTypeCode']] = data['group-types'][i]['row_id'];
        }
      });
    }
  }
  getShortNameForCpy(page = 1) {
    if (this.companyGroupSectionIDS.length > 0) {
      this.supplierService.getCompanyNames(`${this.Config.ApiSupplierUrl}company-names?companyId=in(${this.companyGroupSectionIDS})&_page=${page}`).subscribe(data => {
        if (data['company-names'].length > 0) {
          data['company-names'].forEach(ele => {
            if (ele.companyNameTypeName && ele.companyNameTypeName == "SHORT NAME") {
              this.companySectionShortNameArr[ele.companyId] = ele;
            }
          });
          if (data['maxPage'] > 1 && data['maxPage'] != page) {
            this.getShortNameForCpy(page + 1);
          }
        }
      });
    }
  }

  getSiteCityCountryOfHQ(businessIds, siteRowIds = [], page = 1) {
    if (businessIds.length > 0) {
      this.supplierService.getSiteAssignments(`${this.Config.ApiSupplierUrl}site-assignments?businessEntityId=in(${businessIds})&_page=${page}`).subscribe(data => {
        if (data['site-assignments'].length > 0) {
          data['site-assignments'].forEach(element => {
            var site_row_ID = element.site.href.split("/");
            siteRowIds.push(site_row_ID[1]);
            this.siteIdsOnCompanyHQ[site_row_ID[1]] = element.businessEntityCompanyId;
          });
          if (data['maxPage'] > 1 && data['maxPage'] != page) {
            this.getSiteCityCountryOfHQ(businessIds, siteRowIds, page + 1);
          }
          if (siteRowIds.length > 0 && data['maxPage'] == page) {
            this.getSiteDetailsRows(siteRowIds);
          }
        }
      });
    }
  }

  getSiteDetailsRows(siteRowIds, page = 1) {
    this.sitesService.getSites(`${this.Config.ApiSitesUrl}sites?rowId=in(${siteRowIds})&_page=${page}`).subscribe(data1 => {
      if (data1['sites'].length > 0) {
        data1['sites'].forEach(element => {
          this.siteCityAndCountryHQ[this.siteIdsOnCompanyHQ[element.rowId]] = element;
        });
        if (data1['maxPage'] > 1 && data1['maxPage'] != page) {
          this.getSiteDetailsRows(siteRowIds, page + 1);
        }
      }
    });
  }
  clearGrpRep() {
    if (this.groupId != '' && this.cpyRepGrpId != '') {
      const removeRep = {
        representingCompanyId: '',
        representingCompanyAllianceIdentifier: ''
      }
      this.supplierService.UpdateGroups(`${this.Config.ApiSupplierUrl}groups/${this.groupId}`, removeRep).subscribe(_data => {
        this.cpyRepGrpId = '';
        this.showEmptyRow = true;
        this.getCompanyGroupSection(1);
      }, _error => {
        this.loading1 = false;
      });
    }
  }
  toggleGroupingStatus(_event) {
    this.companyGroupSection.forEach(element => {
      if (element.toggleRow == true) {
        element.hideRow = !element.hideRow;
      }
    });
  }

  checkvalidateCompanyNameField(expression, model, modelerror, regexmodel) {
    if (/^\s/.test(expression)) {
      this[model] = expression.trimStart();
      return false;
    }
    if (expression.length > 0) {
      this[modelerror] = false;
      if (!/^[a-zA-Z 0-9\.\,\/\-\(\)]*$/.test(expression)) {
        this[regexmodel] = true;
      } else {
        this[regexmodel] = false;
      }
    } else {
      this[regexmodel] = false;
      this[modelerror] = true;
    }
  }
  checkGrpRep() {
    let groupId = this.groupId;
    let groupBvdId = '';
    let groupIdentifier = '';
    let repCompanyId = '';
    let companyBvdIds = [];
    let isGrpCpyBvdEq = false;
    let grpBvdBusinessEntityId = '';
    let groupIdenRowId = '';
    this.disableCheckGrpRep = true;
    document.getElementById('closeshowWarningCheckGrp').click();
    this.supplierService.getGroups(`${this.Config.ApiSupplierUrl}groups/${groupId}`).subscribe(data => {
      if (data != null) {
        groupIdentifier = `'${data['allianceIdentifier']}'`;
        repCompanyId = data['representingCompanyId'];
        this.supplierService.getGroupIdentifiers(`${this.Config.ApiSupplierUrl}group-identifiers?groupIdentifierKeyName=BVD&groupAllianceIdentifier=in(${groupIdentifier})`).subscribe(data1 => {
          if (data1['group-identifiers'].length > 0) {
            groupBvdId = data1['group-identifiers'][0]['value'];
            groupIdenRowId = data1['group-identifiers'][0]['row_id'];
            if (repCompanyId != '') {
              this.supplierService.getBusinessEntities(`${this.Config.ApiSupplierUrl}business-entities?companyId=${repCompanyId}`).subscribe(data => {
                let businessEntities = [];
                if (data['business-entities'].length > 0) {
                  data['business-entities'].forEach(e => {
                    businessEntities.push(e.row_id);
                  });
                }
                if (businessEntities.length > 0) {
                  this.supplierService.getBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers?businessEntityId=in(${businessEntities})&businessEntityIdentifierTypeName=BVD ID`).subscribe(data2 => {
                    if (data2['business-entity-identifiers'].length > 0) {
                      data2['business-entity-identifiers'].forEach(ele => {
                        if (ele.value == groupBvdId) {
                          isGrpCpyBvdEq = true;
                        }
                        companyBvdIds.push(ele.value);
                      });
                    }

                    if (groupBvdId != '' && companyBvdIds.length > 0 && isGrpCpyBvdEq == false) {
                      this.showCheckGrpWarningMsg = 'Bvd At Group and Company are not null and different !';
                      document.getElementById('brnForWarningCheckGrp').click();
                      console.info('warnings');
                      this.disableCheckGrpRep = false;
                    } else if (groupBvdId != '' && companyBvdIds.length == 0) {
                      this.supplierService.getBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers?value=${groupBvdId}`).subscribe(data3 => {
                        if (data3['count'] == 0) {
                          this.supplierService.getBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifier-types?name=BVD ID&_page=1`).subscribe((data: any) => {
                            var row_id_BVDID = data['business-entity-identifier-types'][0]['row_id'];
                            this.supplierService.getBusinessEntities(`${this.Config.ApiSupplierUrl}business-entities?companyId=${repCompanyId}&isHQ=Y`).subscribe(data4 => {
                              grpBvdBusinessEntityId = data4['business-entities'][0]['row_id'];
                              const datas_N = { businessEntityId: grpBvdBusinessEntityId, businessEntityIdentifierTypeId: row_id_BVDID, value: groupBvdId, startDate: this.apiService.getTodayDate() };
                              this.supplierService.CreateBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers`, datas_N).subscribe(_data5 => {
                                this.supplierService.DeleteGroupIdentifiers(`${this.Config.ApiSupplierUrl}group-identifiers/${groupIdenRowId}`).subscribe(_da => { });
                                this.disableCheckGrpRep = false;
                                this.getGroupAliasByRowid();
                              });
                            });
                          });
                        } else {
                          this.showCheckGrpWarningMsg = 'BvD exists at business entity level';
                          document.getElementById('brnForWarningCheckGrp').click();
                          console.info('warnings');
                        }
                      });
                    } else {
                      this.disableCheckGrpRep = false;
                      this.getGroupAssignments(groupId, groupBvdId, groupIdenRowId);
                    }
                  });
                }
              });
            } else {
              this.getGroupAssignments(groupId, groupBvdId, groupIdenRowId);
            }
          } else if (repCompanyId == '') {
            this.supplierService.getGroupAssignments(`${this.Config.ApiSupplierUrl}group-assignments?groupId=${groupId}&_page=1`).subscribe(data6 => {
              if (data6['count'] == 1) {
                const const3 = { 'representingCompanyId': data6['group-assignments'][0]['companyId'] }
                this.supplierService.UpdateGroups(`${this.Config.ApiSupplierUrl}groups/${groupId}`, const3).subscribe(_data7 => {
                  this.disableCheckGrpRep = false;
                  this.getDetailsByRowid();
                });
              } else {
                this.showCheckGrpWarningMsg = 'Not able to identify Group representative';
                document.getElementById('brnForWarningCheckGrp').click();
                console.info('warnings');
                this.disableCheckGrpRep = false;
              }
            });
          } else {
            this.disableCheckGrpRep = false;
          }
        }, _error => {
          this.showCheckGrpWarningMsg = 'Not able to identify Group representative';
          document.getElementById('brnForWarningCheckGrp').click();
          console.info('warnings');
        });

      } else {
        this.showCheckGrpWarningMsg = 'Not able to identify Group representative';
        document.getElementById('brnForWarningCheckGrp').click();
        console.info('warnings');
      }
    }, _error => {
      this.showCheckGrpWarningMsg = 'Not able to identify Group representative';
      document.getElementById('brnForWarningCheckGrp').click();
      console.info('warnings');
    });

  }

  getGroupAssignments(groupId, groupBvdId, groupIdenRowId, page = 1, subscribeData = [], cpyIds = []) {
    this.supplierService.getGroupAssignments(`${this.Config.ApiSupplierUrl}group-assignments?groupId=${groupId}&_page=${page}`).subscribe(data => {
      data['group-assignments'].forEach(ele => {
        subscribeData.push(ele);
        if (cpyIds.indexOf(ele.companyId) == -1) {
          cpyIds.push(ele.companyId);
        }
      });
      if (data['maxPage'] > 1 && data['maxPage'] != page) {
        this.getGroupAssignments(groupId, groupBvdId, groupIdenRowId, page + 1, subscribeData, cpyIds);
      } else if (data['maxPage'] == page) {
        this.getCpyBusinessEntities(cpyIds, groupBvdId, groupIdenRowId);
      }
    });
  }

  getCpyBusinessEntities(cpyIds, groupBvdId, groupIdenRowId, page = 1, subscribeData: any = [], businessEntityIds = [], splitrowids = [], morethan20rec = false, remainingRows = [], pageChanged = 'yes') {
    if (cpyIds.length > 0) {
      if (pageChanged == 'yes') {
        if (cpyIds.length > TWENTY) {
          splitrowids = cpyIds.slice(0, TWENTY);
          remainingRows = cpyIds.slice(TWENTY, cpyIds.length);
          morethan20rec = true;
        } else {
          splitrowids = cpyIds;
          morethan20rec = false;
        }
      }
      this.supplierService.getBusinessEntities(`${this.Config.ApiSupplierUrl}business-entities?companyId=in(${splitrowids})&_page=${page}`).subscribe(data => {
        if (data['business-entities'].length > 0) {
          data['business-entities'].forEach(e => {
            if (subscribeData[e.row_id] == undefined) {
              subscribeData[e.row_id] = [];
            }
            subscribeData[e.row_id] = e;
            if (businessEntityIds.indexOf(e.row_id) == -1) {
              businessEntityIds.push(e.row_id);
            }
          });
        }
        if (data['maxPage'] > 1 && data['maxPage'] != page) {
          this.getCpyBusinessEntities(cpyIds, groupBvdId, groupIdenRowId, page + 1, subscribeData, businessEntityIds, splitrowids, morethan20rec, remainingRows, 'no');
        } else if (data['maxPage'] == page) {
          if (morethan20rec == true) {
            this.getCpyBusinessEntities(remainingRows, groupBvdId, groupIdenRowId, 1, subscribeData, businessEntityIds, splitrowids, morethan20rec, remainingRows, 'yes');
          } else {
            this.getBvDIdsForCpy(businessEntityIds, groupBvdId, subscribeData, groupIdenRowId);
          }
        }
      });
    }
  }

  getBvDIdsForCpy(beIds, groupBvdId, subscribeData1, groupIdenRowId, page = 1, subscribeData: any = [], bvdIds = [], hasCpyBvd = false, splitrowids = [], morethan20rec = false, remainingRows = [], pageChanged = 'yes') {
    if (beIds.length > 0) {
      if (pageChanged == 'yes') {
        if (beIds.length > TWENTY) {
          splitrowids = beIds.slice(0, TWENTY);
          remainingRows = beIds.slice(TWENTY, beIds.length);
          morethan20rec = true;
        } else {
          splitrowids = beIds;
          morethan20rec = false;
        }
      }
      this.supplierService.getBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers?businessEntityId=in(${splitrowids})&_page=${page}`).subscribe(data => {
        if (data['business-entity-identifiers'].length > 0) {
          data['business-entity-identifiers'].forEach(e => {
            if (subscribeData[e.value] == undefined) {
              subscribeData[e.value] = [];
            }
            subscribeData[e.value] = e;
            bvdIds.push(e.value);
          });
        }
        if (data['maxPage'] > 1 && data['maxPage'] != page) {
          this.getBvDIdsForCpy(beIds, groupBvdId, subscribeData1, groupIdenRowId, page + 1, subscribeData, bvdIds, hasCpyBvd, splitrowids, morethan20rec, remainingRows, 'no');
        } else if (data['maxPage'] == page) {
          if (morethan20rec == true) {
            this.getBvDIdsForCpy(remainingRows, groupBvdId, subscribeData1, groupIdenRowId, 1, subscribeData, bvdIds, hasCpyBvd, splitrowids, morethan20rec, remainingRows, 'yes');
          } else {
            if (bvdIds.length > 0) {
              bvdIds.forEach(e => {
                if (groupBvdId == e) {
                  console.info('case 3');
                  hasCpyBvd = true;
                  let cpyid = '';
                  cpyid = subscribeData1[subscribeData[e].businessEntityId].companyId;
                  const const1 = { 'representingCompanyId': cpyid }
                  this.supplierService.UpdateGroups(`${this.Config.ApiSupplierUrl}groups/${this.groupId}`, const1).subscribe(_data7 => {
                    this.supplierService.DeleteGroupIdentifiers(`${this.Config.ApiSupplierUrl}group-identifiers/${groupIdenRowId}`).subscribe(_data8 => {
                      this.disableCheckGrpRep = false;
                      setTimeout(() => {
                        this.getGroupAliasByRowid();
                        this.getDetailsByRowid();
                      }, FIFTEEN_HUNDRED_MS);
                    });
                  });
                }
              });
              if (hasCpyBvd == false) {
                this.fnForFourthCase(groupBvdId);
              }
            } else {
              this.fnForFourthCase(groupBvdId);
            }
          }
        }
      });
    } else {
      this.fnForFourthCase(groupBvdId);
    }
  }

  fnForFourthCase(groupBvdId) {
    console.info('4th case');
    this.supplierService.getBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers?value=${groupBvdId}`).subscribe(data3 => {
      if (data3['business-entity-identifiers'].length > 0) {

      } else {
        let datas = { 'bvd-id': groupBvdId }
        this.supplierService.createBvdInterface(`${this.Config.ApiSupplierUrl}bvd-interface`, datas).subscribe((data: any) => {
          var obj = JSON.parse(data.result);
          console.info(obj['Data']);
          if (obj['Data'][0]['CITY'] != '' || obj['Data'][0]['CITY_STANDARDIZED'] != '') {
            let nlBvdIdData = obj['Data'][0];
            console.info('datas', nlBvdIdData);
            this.saveCompanyDetails(nlBvdIdData, nlBvdIdData['NAME'], nlBvdIdData['NATIONAL_ID'], this.groupId, groupBvdId, 'N', nlBvdIdData['NATIONAL_ID_LABEL'], 'Y');
          }
        }, _error => {
          this.showCheckGrpWarningMsg = 'Not able to identify Group representative';
          document.getElementById('brnForWarningCheckGrp').click();
          console.info('warnings');
          this.disableCheckGrpRep = false;
        });
      }
    });
  }

  AllCompanyIdentifierTypes() {
    this.CIdentifierTypes = [];
    this.CIdentifierTypes[0] = 'Alliance Company ID';
    this.supplierService.getCompanyIdentifierKeys(`${this.Config.ApiSupplierUrl}company-identifier-keys`).subscribe((data: any) => {
      if (data['company-identifier-keys'].length > 0) {
        data['company-identifier-keys'].forEach(element => {
          if (element['name'].toLowerCase() != "duns") {
            this.CIdentifierTypes.push(element['name']);
            this.IdenKeywithId[element['name'].toLowerCase()] = element['row_id'];
          }
        });
      }
      this.loading = false;
    }, _error => {
      this.AllCompanyIdentifierTypes();
    });
  }
  saveCompanyDetails(nlBvdIdData, cmpName, cmpMainTaxId, groupId, BvdforComP, RepresentCompany, cmpMainTaxIdLabel, fromCnS = 'N', _fromSpCase = 'N') {
    if (cmpName != '' && cmpName != undefined) {
      this.AllCompanyIdentifierTypes();
      this.companyStatusRowid = "";
      console.info("**** Create Company is Processing ****");
      console.info(`Company Name : ${cmpName} Main TaxID : ${cmpMainTaxId} Group ID : ${groupId} BvDID for Company${BvdforComP}`);

      var cmpNameTypeID = "";
      this.supplierService.getCompanyNameTypes(`${this.Config.ApiSupplierUrl}company-name-types`).subscribe((data18: any) => {
        console.info("company-name-types", data18);
        data18['company-name-types'].forEach(element => {
          if (element.name.toLowerCase() == "short name") {
            cmpNameTypeID = element.row_id;
          }
        });
      });

      var StartDates = this.apiService.getTodayDate();
      this.supplierService.getCompanySatus(`${this.Config.ApiSupplierUrl}company-status`).subscribe((data: any) => {
        data['company-status'].forEach(element => {
          if (element.code.toLowerCase() == "identified") {
            this.companyStatusRowid = element.row_id
          }
        });
        if (this.companyStatusRowid != '') {

          const datas = { legalName: cmpName, companyStatusId: this.companyStatusRowid, companyStatusCode: 'Identified', startDate: StartDates };
          this.supplierService.createCompany(`${this.Config.ApiSupplierUrl}companies`, datas).subscribe((dataGroup: any) => {
            console.info(`Created new Company ID is : ${dataGroup['rowId']}`);
            if (fromCnS == "Y") {
              this.companyRowId = dataGroup['rowId'];
            }
            const const3 = { 'representingCompanyId': this.companyRowId }
            this.supplierService.UpdateGroups(`${this.Config.ApiSupplierUrl}groups/${this.groupId}`, const3).subscribe(_data7 => {
              this.supplierService.getGroupIdentifiers(`${this.Config.ApiSupplierUrl}group-identifiers?groupIdentifierKeyName=BVD&groupAllianceIdentifier=in('${this.groupAllianceIdentifier}')`).subscribe(data1 => {
                let groupIdenRowId = data1['group-identifiers'][0]['row_id'];
                this.supplierService.DeleteGroupIdentifiers(`${this.Config.ApiSupplierUrl}group-identifiers/${groupIdenRowId}`).subscribe(_data => {
                });
              });
            });
            if (cmpMainTaxId && cmpMainTaxId.length > 0 && cmpMainTaxId != '') {
              var x = 0;
              console.info("this.IdenKeywithId", this.IdenKeywithId);
              cmpMainTaxId.forEach(element => {
                if (cmpMainTaxIdLabel[x] != null && element != null) {
                  var mainTaxRowid = "";
                  console.info("CMT", cmpMainTaxIdLabel[x]);
                  mainTaxRowid = this.IdenKeywithId[cmpMainTaxIdLabel[x].toLowerCase()];
                  console.info(mainTaxRowid);
                  if (mainTaxRowid != undefined && mainTaxRowid != "") {
                    var datas21 = { linkedCompanyId: dataGroup['rowId'], companyIdentifierTypeId: mainTaxRowid, value: element.replace(" ", ""), startDate: StartDates };
                    this.supplierService.createCompanyIdentifiers(`${this.Config.ApiSupplierUrl}company-identifiers`, datas21).subscribe((_dataGApprovals: any) => {
                    });
                  }
                }
                x++;
              });
            }
            let shortName = cmpName.split(' ').join('');
            if (shortName.length <= TEN) {
              shortName = shortName.padEnd(TEN);
            } else if (shortName.length > TEN) {
              shortName = shortName.slice(0, TEN);
            }
            shortName = shortName.substring(0, TEN);
            const datas3 = { companyId: dataGroup['rowId'], companyNameTypeId: cmpNameTypeID, "value": shortName, startDate: StartDates }
            this.supplierService.CreateCompanyNames(`${this.Config.ApiSupplierUrl}/company-names`, datas3).subscribe((_data: any) => {
            });
            const datas5 = {
              "apoStatus": "ACTIVE",
              "companyId": dataGroup['rowId'],
              "groupTypeCode": "",
              "groupId": groupId,
              "validityStartDate": this.apiService.getTodayDate(),
              "status": "VALIDATED",
              "groupTypeId": TWO
            };

            this.supplierService.CreateGroupAssignment(`${this.Config.ApiSupplierUrl}group-assignments`, datas5).subscribe((_data: any) => {
              this.saveDatas = "Save";
              console.info("**** Create Company Done ****");
              this.countryService.getCountries(`${this.Config.ApiCountryUrl}countries?countryCode=${nlBvdIdData['COUNTRY_ISO_CODE']}&_page=1`).subscribe((data: any) => {
                if (data['count'] > 0) {
                  data['countries'].forEach(element => {
                    let captain_exist = this.CaptCountry.indexOf(element.countryName);
                    let captain_exist1 = this.countrySelList.indexOf(element.countryName);
                    if (captain_exist == -1) {
                      let obj = {};
                      obj['countryCode'] = element['countryCode'];
                      obj['countryName'] = element['countryName'];
                      obj['rowId'] = element['rowId'];
                      this.CountryNameKeyId[element.countryName] = obj;
                      this.CountryNameKeyId[element.countryFullName] = obj;
                    }
                    if (captain_exist1 == -1) {
                      this.countrySelList.push(element.countryName);
                    }
                  });
                }
                let city = this.apiService.hasNoSpecialCharacters(nlBvdIdData['CITY_STANDARDIZED'], nlBvdIdData['CITY']);
                this.getCityList(nlBvdIdData['CITY'], city, nlBvdIdData['COUNTRY_ISO_CODE']);

                if (fromCnS == "Y") {
                  console.info("Company Module");
                  this.saveSitesDetails(cmpName, nlBvdIdData['COUNTRY_ISO_CODE'], city != null ? city : 'UNKNOWN', nlBvdIdData['POSTCODE'], dataGroup['rowId'], BvdforComP, 'S', nlBvdIdData);
                } else {
                  console.info("Group Module");
                  this.saveSitesDetails(cmpName, nlBvdIdData['COUNTRY_ISO_CODE'], city != null ? city : 'UNKNOWN', nlBvdIdData['POSTCODE'], dataGroup['rowId'], BvdforComP, "S", nlBvdIdData);
                }
              });
            });
            if (RepresentCompany == "Y") {
              const const1 = { representingCompanyId: dataGroup['rowId'] }
              this.supplierService.UpdateGroups(`${this.Config.ApiSupplierUrl}groups/${groupId}`, const1).subscribe(_data => {
              });
            }
          });
        }
      });
    }
  }


  saveSitesDetails(CmpName, counName, CityName, Postal, CompanayID, BvDidforsite, fromCnS = "N", thisBvDdata: any = [], times = 1, counFilter = 'none') {
    console.info("thisBvDdata", thisBvDdata);
    console.info("**** Create Site Processing ****");
    console.info(`Site Name : ${CmpName} ${CityName} Country : ${counName} City Name :${CityName} Postal : ${Postal} Company ID${CompanayID} BvD for Site${BvDidforsite}`);
    console.info('debug>>', this.CountryNameKeyId);
    let snippedCountryName = `the ${counName}`;
    this.selectedCountry = counName;
    if (CityName == undefined || CityName == '' || CityName == null) {
      CityName = 'UNKNOWN';
      console.info('changing city to unknown');
    }
    if (this.CountryNameKeyId[counName] == undefined && this.CountryNameKeyId[snippedCountryName] != undefined) {
      counName = snippedCountryName;
    }
    if (this.CountryNameKeyId[counName] == undefined && times < TWO && counName != null && counName != '' && counFilter != 'yes') {
      console.info('No country id found, search in list and retry....');
      this.countryService.getCountries(`${this.Config.ApiCountryUrl}countries?countryCode=${counName}&_page=1`).subscribe((data: any) => {
        if (data['count'] > 0) {
          data['countries'].forEach(element => {
            let captain_exist = this.CaptCountry.indexOf(element.countryName);
            let captain_exist1 = this.countrySelList.indexOf(element.countryName);
            if (captain_exist == -1) {
              let obj = {};
              obj['countryCode'] = element['countryCode'];
              obj['countryName'] = element['countryName'];
              obj['rowId'] = element['rowId'];
              this.CountryNameKeyId[element.countryName] = obj;
              this.CountryNameKeyId[element.countryFullName] = obj;
            }
            if (captain_exist1 == -1) {
              this.countrySelList.push(element.countryName);
            }
          });
        }
        this.saveSitesDetails(CmpName, counName, CityName, Postal, CompanayID, BvDidforsite, fromCnS, thisBvDdata, times + 1);
        this.selectedCountry = counName;
        this.tempVarCounList['CmpName'] = CmpName;
        this.tempVarCounList['counName'] = counName;
        this.tempVarCounList['CityName'] = CityName;
        this.tempVarCounList['Postal'] = Postal;
        this.tempVarCounList['CompanayID'] = CompanayID;
        this.tempVarCounList['BvDidforsite'] = BvDidforsite;
        this.tempVarCounList['fromCnS'] = fromCnS;
        this.tempVarCounList['thisBvDdata'] = thisBvDdata;
        this.tempVarCounList['times'] = times;
      });
    } else if (this.CountryNameKeyId[counName] == undefined && times == TWO && counFilter != 'yes') {
      console.info('tempVarCounList', this.tempVarCounList);
      document.getElementById('btnForSelectCountryId').click();
    } else {
      let countryId;
      let countryCode;
      let cntryName;
      if (counFilter == 'yes') {
        countryId = this.CountryNameKeyId[counName]['countryId'];
        countryCode = this.CountryNameKeyId[counName]['countryCode'];
        cntryName = this.CountryNameKeyId[counName]['countryName'];
      } else {
        countryId = this.CountryNameKeyId[counName]['countryId'];
        countryCode = this.CountryNameKeyId[counName]['countryCode'];
        cntryName = this.CountryNameKeyId[counName]['countryName'];
      }

      if (this.CityNameKeyId[CityName] == undefined || this.CityNameKeyId[CityName] == 'undefined') {
        this.getCityList(CityName, CityName, counName);
        console.info("CityKey", this.CityNameKeyId);

        setTimeout(function () {
          console.info("ltest", this.CityNameKeyId[CityName]);
          if (this.CityNameKeyId[CityName] != undefined && this.CityNameKeyId[CityName] != 'undefined') {
            var cityId = this.CityNameKeyId[CityName]["rowId"];
            this.saveSiteInformation(countryId, cityId, `${CmpName} ${CityName}`, Postal, CompanayID, BvDidforsite, fromCnS, thisBvDdata);
          } else {
            const cityDatas = {
              countryCode: countryCode,
              name: CityName,
              active: "1",
              countryName: cntryName,
              countryId: countryId
            };
            this.countryService.createCities(`${this.Config.ApiCountryUrl}cities`, cityDatas).subscribe((dataCity: any) => {
              var cityId = dataCity["rowId"];
              this.saveSiteInformation(countryId, cityId, `${CmpName} ${CityName}`, Postal, CompanayID, BvDidforsite, fromCnS, thisBvDdata);
            });
          }
        }.bind(this), TWO_THOUSAND_MS);

      } else {
        var cityId = this.CityNameKeyId[CityName]["rowId"];
        this.saveSiteInformation(countryId, cityId, `${CmpName} ${CityName}`, Postal, CompanayID, BvDidforsite, fromCnS, thisBvDdata);
      }
    }
  }

  saveSiteInformation(countryId, cityId, Site_Name, Postal = '', CompanayID, BvDidforsite, fromCnS = "N", thisBvDdata: any = []) {
    console.info("thisBvDdata2", thisBvDdata);
    this.SiteRowID = "";
    const siteDatas = {
      cityId: cityId,
      countryId: countryId,
      activeStatus: "ACTIVE",
      name: Site_Name,
      effectiveDate: this.apiService.getTodayDate(),
      "irnAuthor": "IRN-71016",
      "siaAuthor": "IAF",
      "isMergingSite": this.varIsMergingSite,
    };
    this.sitesService.createSite(`${this.Config.ApiSitesUrl}sites`, siteDatas).subscribe((dataSite: any) => {
      var site_row_id = dataSite["rowId"];
      console.info(`Created New site ID is : ${dataSite["rowId"]}`);
      if (fromCnS == "S" || fromCnS == 'W') {
        this.SiteRowID = dataSite["rowId"];
      }
      const accessPDatas = {
        activeStatus: "ACTIVE",
        realEstateAssetId: site_row_id,
        type: "P14",
        activity: "A10",
        label: Site_Name,
        effectiveDate: this.apiService.getTodayDate(),
        "irnAuthor": "IRN-71016",
        "siaAuthor": "IAF"
      };
      this.sitesService.createAccessPoint(`${this.Config.ApiSitesUrl}access-points`, accessPDatas).subscribe((dataAccessP: any) => {
        let access_point_row_id = dataAccessP["rowId"];
        let addinfo = "";
        if (thisBvDdata['ADDRESS_LINE1'] == undefined || thisBvDdata['ADDRESS_LINE1'] == '' || thisBvDdata['ADDRESS_LINE1'] == null) {
          thisBvDdata['ADDRESS_LINE1'] = 'UNKNOWN';
          console.info('street is null changing to unknown');
        }
        console.info("ADDRESS_LINE1", thisBvDdata['ADDRESS_LINE1']);
        thisBvDdata['ADDRESS_LINE1'] = thisBvDdata['ADDRESS_LINE1'].substring(0, THIRTY_FIVE);
        if (thisBvDdata['ADDRESS_LINE2'] != null && thisBvDdata['ADDRESS_LINE2'] != "") {
          addinfo += `${thisBvDdata['ADDRESS_LINE2']} `;
        }
        if (thisBvDdata['ADDRESS_LINE3'] != null && thisBvDdata['ADDRESS_LINE2'] != "") {
          addinfo += thisBvDdata['ADDRESS_LINE3'];
        }
        let geoADatas = {};
        if (thisBvDdata['ADDRESS_LINE1'] == null) {
          thisBvDdata['ADDRESS_LINE1'] = "";
        }
        addinfo = addinfo.substring(0, ONE_HUNDRED_SEVEN);
        if (Postal != '' && Postal != null) {
          Postal = Postal.substring(0, NINE);
          geoADatas = {
            additionalInformation: addinfo,
            streetName: thisBvDdata['ADDRESS_LINE1'],
            postalCode: Postal,
            cityId: cityId,
            countryId: countryId,
            "irnAuthor": "IRN-71016",
            "siaAuthor": "IAF"
          };
        } else {
          geoADatas = {
            additionalInformation: addinfo,
            streetName: thisBvDdata['ADDRESS_LINE1'],
            cityId: cityId,
            countryId: countryId,
            "irnAuthor": "IRN-71016",
            "siaAuthor": "IAF"
          };
        }
        this.addressService.createGeographicalAddresses(`${this.Config.ApiAddressUrl}geographical-addresses`, geoADatas).subscribe((dataGeoA: any) => {
          var geo_adress_row_id = dataGeoA["rowId"];
          const accessPointDatas = {
            accessPointId: access_point_row_id,
            addressId: geo_adress_row_id
          };
          this.sitesService.createAccessPointAddress(`${this.Config.ApiSitesUrl}access-points-addresses`, accessPointDatas).subscribe((_dataAccessPoint: any) => {

          });

          if ((thisBvDdata['LATITUDE'] != '' && thisBvDdata['LATITUDE'] != null) || (thisBvDdata['LONGITUDE'] != '' && thisBvDdata['LONGITUDE'] != null)) {
            const gpsDatas = { 'accessPointId': access_point_row_id, 'latitude': thisBvDdata['LATITUDE'] ? thisBvDdata['LATITUDE'].toString() : "", 'longitude': thisBvDdata['LONGITUDE'] ? thisBvDdata['LONGITUDE'].toString() : "" }
            console.info("gpsDatas", gpsDatas);
            this.addressService.createGeolocationCoordinatesAddresses(`${this.Config.ApiAddressUrl}geolocation-coordinates-addresses`, gpsDatas).subscribe((dataGeoA: any) => {
              console.info("geolocation-coordinates-addresses : ", dataGeoA);
              const accessPointDatas2 = {
                accessPointId: access_point_row_id,
                addressId: dataGeoA['rowId']
              };
              this.sitesService.createAccessPointAddress(`${this.Config.ApiSitesUrl}access-points-addresses`, accessPointDatas2).subscribe((_dataAccessPoint: any) => {

              });
            });
          }

          this.disableCheckGrpRep = false;
          this.addSiteCategoryToAssignment(site_row_id, CompanayID, BvDidforsite, Site_Name, fromCnS);
        });
      });
    });
  }

  addSiteCategoryToAssignment(site_row_id, CompanayID, BvDidforsite, Site_Name, fromCnS = "N") {
    const newCategory = { "realEstateAssetId": site_row_id, "categoryId": this.newCategoryAssignment, "categoryName": this.newCategoryName }
    this.sitesService.createRealEstateAssetAssignment(`${this.Config.ApiSitesUrl}real-estate-asset-assignments`, newCategory).subscribe(_data012 => {
    });
    this.supplierService.getSiteAssignments(`${this.Config.ApiSupplierUrl}site-assignments?site=SupSiteService:${site_row_id}&_page=1&status=VALIDATED`).subscribe(data => {
      if (data['pageCount'] == 1) {
        if (data['site-assignments'][0]['status'] == 'VALIDATED') {
          console.info("SRifalse1");

        } else {
          console.info("SRitrue1");
          this.changeCompanySiteAssnNoExist(site_row_id, CompanayID, BvDidforsite, Site_Name, fromCnS);
        }
      } else if (data['pageCount'] > 1) {
        console.info("SRifalse2");
      } else {
        console.info("SRitrue2");
        this.changeCompanySiteAssnNoExist(site_row_id, CompanayID, BvDidforsite, Site_Name, fromCnS);
      }
    });
  }


  changeCompanySiteAssnNoExist(siteID, CMPiD, BvDidforsite, Site_Name, fromCnS = "N") {
    var tempBusinessRowId;
    console.info('fromCnS', fromCnS);
    if (fromCnS == "S") {
      const datas2 = { modificationStatus: "VALIDATED", isHQ: "Y", companyId: CMPiD };
      this.supplierService.CreateBusinessEntities(`${this.Config.ApiSupplierUrl}business-entities`, datas2).subscribe((dataGApprovals: any) => {
        tempBusinessRowId = dataGApprovals['row_id'];
        this.supplierService.getBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers?businessEntityId=${tempBusinessRowId}&_page=1`).subscribe(data1 => {
          if (data1['pageCount'] > 0) {

          }
          else {
            const const2 = {
              "businessEntityIdentifierTypeId": "1",
              "businessEntityIdentifierTypeName": "BVD ID",
              "startDate": this.apiService.getTodayDate(),
              "businessEntityId": tempBusinessRowId,
              "value": BvDidforsite
            }
            this.supplierService.CreateBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers`, const2).subscribe(_data2 => {

            });
          }
          const const3 = {
            "validityStartDate": this.apiService.getTodayDate(),
            "status": "VALIDATED",
            "businessEntityId": tempBusinessRowId
          }
          this.supplierService.CreateSiteAssignments(`${this.Config.ApiSupplierUrl}site-assignments?site=SupSiteService:${siteID}`, const3).subscribe(_data3 => {
            this.changeParamsforNewCpy('doesnotexist', siteID, CMPiD, Site_Name, BvDidforsite, fromCnS);
          })
        });
      });
    } else {
      console.info('in else....');
      this.supplierService.getBusinessEntities(`${this.Config.ApiSupplierUrl}business-entities?companyId=${CMPiD}&isHQ=Y`).subscribe(data => {
        tempBusinessRowId = data['business-entities'][0]['row_id'];
        this.supplierService.getBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers?businessEntityId=${tempBusinessRowId}&_page=1`).subscribe(data1 => {
          if (data1['pageCount'] > 0) {

          }
          else {
            const const2 = {
              "businessEntityIdentifierTypeId": "1",
              "businessEntityIdentifierTypeName": "BVD ID",
              "startDate": this.apiService.getTodayDate(),
              "businessEntityId": tempBusinessRowId,
              "value": BvDidforsite
            }
            this.supplierService.CreateBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers`, const2).subscribe(_data2 => {

            });
          }
          const const3 = {
            "validityStartDate": this.apiService.getTodayDate(),
            "status": "VALIDATED",
            "businessEntityId": tempBusinessRowId
          }
          this.supplierService.CreateSiteAssignments(`${this.Config.ApiSupplierUrl}site-assignments?site=SupSiteService:${siteID}`, const3).subscribe(_data3 => {
            this.changeParamsforNewCpy('doesnotexist', siteID, CMPiD, Site_Name, BvDidforsite, fromCnS);
          })
        });
      });
    }
  }

  changeParamsforNewCpy(_con, site_id, CompanayID, Site_Name, BvDidforsite, fromCnS = "N") {
    this.cpyAlcorToRaft = [];
    if (CompanayID != '' && CompanayID != undefined) {
      this.supplierService.getCompanies(`${this.Config.ApiSupplierUrl}companies/${CompanayID}`).subscribe(data1 => {

        const const1 = { "name": Site_Name }
        this.sitesService.updateSite(`${this.Config.ApiSitesUrl}sites/${site_id}`, const1).subscribe(_data0 => {

        });
        let shortName
        this.supplierService.getCompanyNames(`${this.Config.ApiSupplierUrl}company-names?companyNameTypeName=SHORT NAME&companyId=${CompanayID}`).subscribe(data2 => {
          if (data2['company-names'].length > 0) {
            shortName = data2['company-names'][0]['value'];
          } else {
            shortName = data1['legalName'].slice(0, TEN);
          }
          this.sitesService.getRealEstateAssetIdentifiers(`${this.Config.ApiSitesUrl}real-estate-asset-identifiers?realEstateAssetId=${site_id}&identifierType=RAFT_ACCOUNT`).subscribe(data6 => {
            if (data6['real-estate-asset-identifiers'].length > 0) {
              const constEndDate = { "endDate": this.apiService.getTodayDate() }
              data6['real-estate-asset-identifiers'].forEach(ele => {
                this.cpyAlcorToRaft.push(ele.businessIdentifierValue);
                this.arrBasedOnVal[ele.businessIdentifierValue] = ele.rowId;
                this.sitesService.updateRealEstateAssetIdentifier(`${this.Config.ApiSitesUrl}real-estate-asset-identifiers/${ele.rowId}`, constEndDate).subscribe(_data7 => {
                });
              });
            }
            this.supplierService.getCompanyIdentifiers(`${this.Config.ApiSupplierUrl}company-identifiers?linkedCompanyId=${CompanayID}&companyIdentifierKeyName=ALCOR`).subscribe(data8 => {
              if (data8['company-identifiers'].length > 0) {
                let const5;
                if (shortName == '') {
                  shortName = data1['legalName'].slice(0, TEN);
                }
                const constNoEndDate = { "endDate": "" }
                data8['company-identifiers'].forEach(elem => {
                  if (this.cpyAlcorToRaft.indexOf(elem.value) == -1) {
                    if (elem.endDate == '') {
                      const5 = {
                        "businessIdentifierId": "12",
                        "sourceSystemId": "2",
                        "businessIdentifierValue": elem.value,
                        "effectiveDate": this.apiService.getTodayDate(),
                        "businessIdentifierName": shortName,
                        "realEstateAssetId": site_id
                      }
                    } else {
                      const5 = {
                        "businessIdentifierId": "12",
                        "sourceSystemId": "2",
                        "businessIdentifierValue": elem.value,
                        "effectiveDate": this.apiService.getTodayDate(),
                        "businessIdentifierName": shortName,
                        "realEstateAssetId": site_id,
                        "endDate": elem.endDate
                      }
                    }

                    this.sitesService.createRealEstateAssetIdentifier(`${this.Config.ApiSitesUrl}real-estate-asset-identifiers`, const5).subscribe(_data9 => {
                    })
                  } else {
                    if (this.arrBasedOnVal[elem.value]) {
                      this.sitesService.updateRealEstateAssetIdentifier(`${this.Config.ApiSitesUrl}real-estate-asset-identifiers/${this.arrBasedOnVal[elem.value]}`, constNoEndDate).subscribe(_data10 => {

                      });
                    }
                  }
                });
              }
              this.changeAccessPointsToPending(site_id, CompanayID, BvDidforsite);
              console.info("**** Create Site Done ****", fromCnS);

            });
          });

          this.sitesService.getRealEstateAssetIdentifiers(`${this.Config.ApiSitesUrl}real-estate-asset-identifiers?realEstateAssetId=${site_id}&identifierType=SHORT_NAME`).subscribe(data3 => {
            if (data3['real-estate-asset-identifiers'].length > 0) {
              let tempShtNameRowId = data3['real-estate-asset-identifiers'][0]['rowId'];
              const const11 = { 'endDate': this.apiService.getTodayDate() }
              this.sitesService.updateRealEstateAssetIdentifier(`${this.Config.ApiSitesUrl}real-estate-asset-identifiers/${tempShtNameRowId}`, const11).subscribe(_data4 => {

              });
            } else {
            }
          });

        });
        this.changeRealEstateAssignments(site_id, data1['legalName']);
      });
    }
  }

  changeRealEstateAssignments(site_id, CompNme) {
    this.sitesService.getRealEstateAssetAssignments(`${this.Config.ApiSitesUrl}real-estate-asset-assignments?realEstateAssetId=${site_id}`).subscribe(data => {
      if (data['real-estate-asset-assignments'].length > 0) {
        let exist: any = false;
        let rowId = '';
        const const1 = { categoryId: this.newCategoryAssignment, categoryName: this.newCategoryName };
        const constEndDate = { "endDate": this.apiService.getTodayDate() };
        let c = 0;
        data['real-estate-asset-assignments'].forEach((element, _index) => {
          if (element.categoryCode != '' && exist == false && element.legalEntityIdentifier == '') {
            rowId = element.rowId;
            exist = true;
          }
          if (element.legalEntityIdentifier != '' && element.endDate != '') {
            this.sitesService.updateRealEstateAssetAssignment(`${this.Config.ApiSitesUrl}real-estate-asset-assignments/${element.rowId}`, constEndDate).subscribe(_data1 => {

            });
          }
          c++;
        });
        if (exist == false) {
          this.sitesService.updateRealEstateAssetAssignment(`${this.Config.ApiSitesUrl}real-estate-asset-assignments/${rowId}`, const1).subscribe(_data => {
          });
        }
      }
    });

    const newLegalEntity = { "corporateName": CompNme, "active": '1' }
    this.sitesService.getRealEstateAssetAssignments(`${this.Config.ApiSitesUrl}real-estate-asset-assignments?corporateName=${CompNme}&realEstateAssetId=${site_id}`).subscribe(data014 => {
      let tempRow = '';
      let runLegal = true;
      if (data014['real-estate-asset-assignments'].length > 0) {
        const endDateSet = { endDate: this.apiService.getTodayDate() };
        const noEndD = { endDate: '' }
        for (let i = 0; i < data014['real-estate-asset-assignments'].length; i++) {
          if (data014['real-estate-asset-assignments'][i]['legalEntityIdentifier'] != '' && data014['real-estate-asset-assignments'][i]['endDate'] == '' && data014['real-estate-asset-assignments'][i]['legalEntityCorporateName'] != CompNme) {
            this.sitesService.updateRealEstateAssetAssignment(`${this.Config.ApiSitesUrl}real-estate-asset-assignments/${data014['real-estate-asset-assignments'][i]['rowId']}`, endDateSet).subscribe(_data0 => {

            });
          }
          if (data014['real-estate-asset-assignments'][i]['legalEntityCorporateName'] == CompNme) {
            tempRow = data014['real-estate-asset-assignments'][i]['legalEntityId'];
            runLegal = false;
            if (data014['real-estate-asset-assignments'][i]['endDate'] != '') {
              this.sitesService.updateRealEstateAssetAssignment(`${this.Config.ApiSitesUrl}real-estate-asset-assignments/${data014['real-estate-asset-assignments'][i]['rowId']}`, noEndD).subscribe(_data0 => {
              });
            }

          }
        }
      }
      if (runLegal == true) {
        this.sitesService.createLegalEntity(`${this.Config.ApiSitesUrl}legal-entities`, newLegalEntity).subscribe(data013 => {
          const newLegalPost = { 'realEstateAssetId': site_id, 'legalEntityId': data013['rowId'] }
          this.sitesService.createRealEstateAssetAssignment(`${this.Config.ApiSitesUrl}real-estate-asset-assignments`, newLegalPost).subscribe(_data015 => {

          });
        });
      }
    });
  }

  changeAccessPointsToPending(site_id, _CompanayID, _BvDidforsite) {
    this.sitesService.getAccessPoints(`${this.Config.ApiSitesUrl}access-points?realEstateAssetId=in(${site_id})&_page=1`).subscribe(data => {
      setTimeout(function () {
        this.reloadCurrentPage();
      }.bind(this), TWO_THOUSAND_MS);
      var sitesData = data['access-points'];
      if (sitesData.length > 0) {
        const constPending = { "activeStatus": "PENDING" }
        const constActive = { "activeStatus": "ACTIVE" }
        const constEndDate = { "endDate": this.apiService.getTodayDate() }
        let OrderManuInvoi = ['P05', 'P06', 'P11'];
        data['access-points'].forEach(element => {
          if (this.qualifierChangetoPending.indexOf(element.type) != -1) {
            if (element.activeStatus != 'PENDING') {
              if (element.activeStatus == 'ARCHIVED') {
                this.sitesService.updateAccessPoint(`${this.Config.ApiSitesUrl}access-points/${element.rowId}`, constActive).subscribe(_data0 => {
                  this.sitesService.updateAccessPoint(`${this.Config.ApiSitesUrl}access-points/${element.rowId}`, constPending).subscribe(_data11 => {
                  });
                });
              } else {
                this.sitesService.updateAccessPoint(`${this.Config.ApiSitesUrl}access-points/${element.rowId}`, constPending).subscribe(_data1 => {

                });
              }
            }
            if (OrderManuInvoi.indexOf(element.type) != -1 && element.identifier) {
              this.sitesService.updateAccessPointIdentifier(`${this.Config.ApiSitesUrl}access-point-identifiers/${element.identifier}`, constEndDate).subscribe(_data12 => {

              });
            }
          }
        });
      }
    });
  }

  getCityList(event: any, CName = "", countryName = '') {
    if (this.selectedCountry != "failed" && event.length >= TWO) {
      var NCityName = "";
      if (CName == "") {
        NCityName = this.siteCityModel;
      } else {
        NCityName = CName;
      }
      let NcountryName = '';
      if (countryName == '') {
        NcountryName = this.siteCountryModel.split(' - ')[0];
      } else {
        NcountryName = countryName;
      }
      this.countryService.getCities(`${this.Config.ApiCountryUrl}cities?countryCode=${NcountryName}&name=*${NCityName}*&_page=1&_pagesize=20`).subscribe((data: any) => {
        if (data['count'] > 0) {
          this.CityNameKeyId = "";
          this.CityNameKeyId = [];
          this.CaptCity = "";
          this.CaptCity = [];
          data['cities'].forEach(element => {
            this.CaptCity.push(element.name);
            this.CityNameKeyId[element.name] = element;
          });
        } else {
          this.CaptCity = [];
        }
      });
    } else {
      this.CaptCity = [];
    }
  }

  getCpyAlcorCodes(rowIds, page = 1) {
    if (rowIds.length > 0) {
      this.supplierService.getCompanyIdentifiers(`${this.Config.ApiSupplierUrl}company-identifiers?companyIdentifierKeyName=ALCOR&linkedCompanyId=in(${rowIds.slice(0, -1)})`).subscribe(data => {
        if (data['company-identifiers'].length > 0) {
          data['company-identifiers'].forEach(ele => {
            if (this.alcorCodesOnCpyIds[ele.linkedCompanyId] == undefined) {
              this.alcorCodesOnCpyIds[ele.linkedCompanyId] = [];
            }
            if (this.alcorCodesOnCpyIds[ele.linkedCompanyId].indexOf(ele.value) == -1) {
              if (ele.endDate == '') {
                this.alcorCodesOnCpyIds[ele.linkedCompanyId].push(ele.value);
              }
            }
          });
          if (data['maxPage'] > 1 && data['maxPage'] != page) {
            this.getCpyAlcorCodes(rowIds, page + 1);
          }
        }
      });
    }
  }

  checkSelRunSite() {
    if (this.selectedCustomCountry != '') {
      this.saveSitesDetails(this.tempVarCounList['CmpName'], this.selectedCustomCountry, this.tempVarCounList['CityName'], this.tempVarCounList['Postal'], this.tempVarCounList['CompanayID'], this.tempVarCounList['BvDidforsite'], this.tempVarCounList['fromCnS'], this.tempVarCounList['thisBvDdata'], this.tempVarCounList['times'], 'yes');
    }
  }

  reloadCurrentPage() {
    this.saveDatas = 'Save';
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = 'reload';
    this.router.navigateByUrl(`supplier-group-details/${this.groupId}`);
  }

  showDropdownStatus(dos = 'main') {

    if (dos == 'close') {
      this.supplierDefaultFilterReseted = true;
      this.FiltercheckStatus.forEach(ele => {
        this[`company-${ele}`] = false;
      });
    } else {
      this.showFilterStatus = !this.showFilterStatus;
    }
    setTimeout(function () {
      this.FiltercheckStatus.forEach(ele => {
        let type = ele.split('_');
        if (this[`company-${ele}`] == true) {
          if (document.getElementById(`company-${type[0]}`) != null) {
            document.getElementById(`company-${type[0]}`).setAttribute('checked', '');
          }
        } else {
          if (document.getElementById(`company-${type[0]}`) != null) {
            document.getElementById(`company-${type[0]}`).removeAttribute('checked');
          }
        }
      });
      if (dos == 'close') {
        this.filterStatus();
      }
    }.bind(this), TEN)
  }

  setCheckboxVal(status) {
    this[`company-${status}_status`] = !this[`company-${status}_status`];
  }

  filterStatus(clicked = 0) {
    if (clicked == 1) this.supplierDefaultFilterReseted = true;
    let statusToFilter = [];
    let validcompanyIds = [];
    this.filteredCompanies = [];
    this.companyFiltered = false;
    this.FiltercheckStatus.forEach(ele => {
      if (this[`company-${ele}`] == true) {
        let type = ele.split('_');
        statusToFilter.push(type[0]);
        this.companyFiltered = true;
      }
    });
    this.statuses = statusToFilter.join(" or ");
    console.info("statusToFilter===>", this.statuses);
    this.companyGroupSection = this.tempCompanySection;
    if (statusToFilter.length > 0) {
      this.compRowId.forEach(element => {
        for (let i = 0; i < statusToFilter.length; i++) {
          for (let j = 0; j < this.companyStatus[element].length; j++) {
            if (this.companyStatus[element]) {
              if (statusToFilter[i] == this.companyStatus[element][j]) {
                if (validcompanyIds.indexOf(element) == -1) {
                  validcompanyIds.push(element);
                }
              }
            }
          }
        }
      });
      this.companyGroupSection.forEach(elements => {
        if (validcompanyIds.indexOf(elements.companyId) != -1) {
          elements['filterTrue'] = true;
          this.filteredCompanies.push(elements)
        } else {
          elements['filterTrue'] = false;
        }
      });
      this.paginationForStatus = true;
      const visibleFilteredCompanies = this.filteredCompanies.filter(c => c.hideRow === false && c.filterTrue === true);
      this.pagedTotalItem = visibleFilteredCompanies.length;
      this.pager = this.pagerService.getPager(visibleFilteredCompanies.length, 1, TWENTY);
      this.companyGroupSection = visibleFilteredCompanies.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.companyGroupSection.forEach(e => {
        e['filterTrue'] = true;
      });
      this.paginationForStatus = false;
      const visibleCompanies = this.tempCompanySection.filter(c => c.hideRow === false);
      this.pagedTotalItem = visibleCompanies.length;
      this.pager = this.pagerService.getPager(visibleCompanies.length, 1, TWENTY);
      this.companyGroupSection = visibleCompanies.slice(this.pager.startIndex, this.pager.endIndex + 1);
    }
    this.showFilterStatus = false;
  }

  setPage(page) {
    const visibleFilteredCompanies = this.filteredCompanies.filter(c => c.hideRow === false && c.filterTrue === true);
    this.pagedTotalItem = visibleFilteredCompanies.length;
    this.pager = this.pagerService.getPager(visibleFilteredCompanies.length, page, TWENTY);
    this.companyGroupSection = visibleFilteredCompanies.slice(this.pager.startIndex, this.pager.endIndex + 1);
  }

  getVisibleCompaniesCount() {
    if (this.companyFiltered && this.filteredCompanies) {
      return this.filteredCompanies.filter(c => c.hideRow === false && c.filterTrue === true).length;
    } else if (this.tempCompanySection && this.tempCompanySection.length > 0) {
      return this.tempCompanySection.filter(c => c.hideRow === false).length;
    }
    return 0;
  }

  getTotalCompaniesCount() {
    if (this.tempCompanySection && this.tempCompanySection.length > 0) {
      return this.tempCompanySection.filter(c => c.hideRow === false).length;
    }
    return 0;
  }

  getVisibleSitesCount() {
    if (!this.Site_City_Country || !this.tempSiteSection) {
      return 0;
    }
    if (this.siteFiltered && this.filteredSites) {
      return this.filterValidSites(this.filteredSites).filter(s => s.showRow === true && s.filterTrue === true).length;
    } else if (this.tempSiteSection && this.tempSiteSection.length > 0) {
      return this.filterValidSites(this.tempSiteSection).filter(s => s.showRow === true).length;
    }
    return 0;
  }

  getTotalSitesCount() {
    if (!this.Site_City_Country || !this.tempSiteSection) {
      return 0;
    }
    if (this.tempSiteSection && this.tempSiteSection.length > 0) {
      return this.filterValidSites(this.tempSiteSection).filter(s => s.showRow === true).length;
    }
    return 0;
  }

  filterValidSites(sites: any[]) {
    return sites.filter(site => {
      const siteRowId = this.Site_hrefTo_Cid[site.businessEntityId];
      return siteRowId && this.Site_City_Country[siteRowId];
    });
  }

  loadBvdIdCpy(chk = 'new') {
    this.SiteDispLoading = true;
    this.SitesInfo = [];
    this.getBeFn(chk);
    this.SiteDe_BvdID_Stat = [];
  }

  getBeFn(check, page = 1, subscribeDataIsHQ = [], subscribeDataNoHq = []) {
    this.supplierService.getBusinessEntities(`${this.Config.ApiSupplierUrl}business-entities?companyId=in(${this.companyIdForSite})&_page=${page}`).subscribe(data => {
      if (data['business-entities'].length > 0) {
        data['business-entities'].forEach(e => {
          if (e.isHQ == 'Y') {
            subscribeDataIsHQ.push(e);
          } else if (e.isHQ == 'N') {
            subscribeDataNoHq.push(e);
          }
        });
        if (data['maxPage'] > 1 && data['maxPage'] != page) {
          this.getBeFn(check, page + 1, subscribeDataIsHQ, subscribeDataNoHq);
        } else if (data['maxPage'] == page) {
          setTimeout(function () {
            if (check == 'reload') {
              this.getSiteDetails();
            }
          }.bind(this), ONE_SECOND_MS)
          this.sortGetDataIsHQ(subscribeDataIsHQ);
          this.sortGetDataNoHQ(subscribeDataNoHq);
        }
      }
    });
  }

  sortGetDataIsHQ(subscribeDataIsHQ) {
    console.info("subscribeDataIsHQ", subscribeDataIsHQ)
    this.companyLength = subscribeDataIsHQ.length;
    subscribeDataIsHQ.forEach(elemens => {
      this.siteBusinessEntityHQ.push(elemens.row_id);
      this.supplierService.getBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers?businessEntityId=${elemens.row_id}`).subscribe(data1 => {
        if (data1['business-entity-identifiers'].length > 0) {
          data1['business-entity-identifiers'].forEach(ele => {
            if (ele.endDate == '') {
              ele['showRow'] = false;
              ele['toggleRow'] = true;
              ele['filterTrue'] = true;
              if (this.SitesInfo.length == 0) {
                this.SitesInfo.push(ele);
              }
              if (ele.businessEntityIdentifierTypeName == 'BVD ID') {
                if (this.SiteDe_BvdID_Stat[ele.businessEntityId] == undefined) {
                  this.SiteDe_BvdID_Stat[ele.businessEntityId] = [];
                }
                this.SiteDe_BvdID_Stat[ele.businessEntityId]['value'] = ele.value;
              }
            }
          });
        }
      });
    });
  }

  sortGetDataNoHQ(subscribeDataNoHq, page = 1) {
    let forIS = [];
    for (let i = 0; i < subscribeDataNoHq.length; i++) {
      forIS.push(subscribeDataNoHq[i]['row_id']);;
    }
    if (forIS.length > 0) {
      let splitrowids = [];
      let morethan20rec = false;
      let remainingRows = [];
      if (forIS.length > TWENTY) {
        splitrowids = forIS.slice(0, TWENTY);
        remainingRows = forIS.slice(TWENTY, forIS.length);
        morethan20rec = true;
      } else {
        splitrowids = forIS;
      }
      this.supplierService.getBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers?businessEntityId=in(${splitrowids})&businessEntityIdentifierTypeName=BVD ID&_page=${page}`).
        subscribe(data3 => {
          if (data3['business-entity-identifiers'].length > 0) {
            data3['business-entity-identifiers'].forEach(ele => {
              if (ele.endDate == '') {
                ele['showRow'] = false;
                ele['toggleRow'] = true;
                ele['filterTrue'] = true;
                this.SitesInfo.push(ele);
                if (this.SiteDe_BvdID_Stat[ele.businessEntityId] == undefined) {
                  this.SiteDe_BvdID_Stat[ele.businessEntityId] = [];
                }
                this.SiteDe_BvdID_Stat[ele.businessEntityId]['value'] = ele.value;
                this.SiteDe_BvdID_Stat[ele.businessEntityId]['row_id'] = ele.row_id;
              }
            });
            if (data3['maxPage'] > 1 && data3['maxPage'] != page) {
              this.sortGetDataNoHQ(subscribeDataNoHq, page + 1);
            }
            if (data3['maxPage'] == page) {
              if (morethan20rec == true) {
                this.sortGetDataNoHQ(remainingRows, 1);
              }
            }
          }
        });
    }
  }

  setPageForSitesSec(page) {
    if (this.paginationForSiteStatus == false) {
      const validSites = this.filterValidSites(this.tempSiteSection);
      this.paging = this.pagerService.getPager(validSites.length, page, TWENTY);
      this.SitesInfo = validSites.slice(this.paging.startIndex, this.paging.endIndex + 1);
    } else if (this.paginationForSiteStatus == true) {
      const validSites = this.filterValidSites(this.filteredSites);
      this.paging = this.pagerService.getPager(validSites.length, page, TWENTY);
      this.SitesInfo = validSites.slice(this.paging.startIndex, this.paging.endIndex + 1);
    }
  }

  getSiteDetails(page, curr_page = 1, subscribeData = []) {
    this.Site_hrefTo_Cid = page == 1 ? [] : this.Site_hrefTo_Cid;
    this.SitesFlag = false;
    this.SiteDispLoading = true;
    this.siteGroupsecMaxpage = 0;
    this.supplierService.getSiteAssignments(`${this.Config.ApiSupplierUrl}site-assignments?businessEntityCompanyId=in(${this.companyIdForSite})&_page=${curr_page}`).subscribe((data: any) => {
      if (curr_page === 1) {
        this.pagedTotalItems = data['count'];
      }
      this.siteGroupsecMaxpage = data['maxPage'];
      if (data['site-assignments'].length > 0) {
        data['site-assignments'].forEach(element => {
          if (element['status'] !== 'ARCHIVED') {
            subscribeData.push(element);
            for (let i = 0; i < subscribeData.length; i++) {
              subscribeData[i]['filterTrue'] = true;
            }
          }
        });
        if (data['maxPage'] > 1 && data['maxPage'] != curr_page) {
          this.getSiteDetails(page, curr_page + 1, subscribeData);
        } else if (data['maxPage'] == curr_page) {
          this.pagedTotalItems = subscribeData.length;
          subscribeData.forEach(element => {
            if (element.site.href) {
              var site_row_ID = element.site.href.split("/");
              let SiteRowIDExis = this.SiteRowID2.indexOf(site_row_ID[1]);
              if (SiteRowIDExis == -1) {
                this.SiteRowID2.push(site_row_ID[1]);
              }
              this.Site_hrefTo_Cid[element.businessEntityId] = site_row_ID[1];
              let beRowIDExist = this.beRowID.indexOf(element.businessEntityId);
              if (beRowIDExist == -1) {
                this.beRowID.push(element.businessEntityId);
              }
              if (element.status == 'ARCHIVED') {
                element['showRow'] = false;
                element['toggleRow'] = false;
              } else {
                element['showRow'] = true;
                element['toggleRow'] = false;
              }
            }
            this.SitesInfo.forEach((ele, index) => {
              if (ele.businessEntityId == element.businessEntityId) {
                this.SitesInfo.splice(index, 1);
              }
            });
            if (this.siteBusinessEntityHQ.includes(element.businessEntityId)) {
              element['showAsHQ'] = true;
              this.siteAssociated = true;
              console.info('hq ele', element);
              this.SitesInfo.push(element);
            }
            else {
              element['showAsHQ'] = false;
              this.SitesInfo.push(element);
            }
          });
          console.info("this.SitesInfo", this.SitesInfo)
        }
      }
      if (data['maxPage'] == curr_page) {
        this.tempSiteSection = subscribeData;
        this.SiteRowID2 = [];
        this.beRowID = [];
        subscribeData.forEach(element => {
          if (element.site && element.site.href) {
            var site_row_ID = element.site.href.split("/");
            if (this.SiteRowID2.indexOf(site_row_ID[1]) == -1) {
              this.SiteRowID2.push(site_row_ID[1]);
            }
            this.Site_hrefTo_Cid[element.businessEntityId] = site_row_ID[1];
          }
          if (this.beRowID.indexOf(element.businessEntityId) == -1) {
            this.beRowID.push(element.businessEntityId);
          }
        });
        const validSites = this.filterValidSites(this.tempSiteSection);
        this.paging = this.pagerService.getPager(validSites.length, page, TWENTY);
        this.SitesInfo = validSites.slice(this.paging.startIndex, this.paging.endIndex + 1);
        
        console.info("SiteRowID2 collected:", this.SiteRowID2);
        console.info("beRowID collected:", this.beRowID);
        
        if (this.beRowID.length > 0) {
          this.JoinBusniessEntity(this.beRowID);
        } else {
          this.joincityCountry(this.SiteRowID2);
        }
        this.SitesFlag = true;
      }
    }, error => {
      this.companyExist = false;
      console.info('data_error', error.status);
    });
  }

  JoinBusniessEntity(beRowID, page = 1, subscribeData = []) {
    this.siteBusinessEntityExist = true;
    if (beRowID.length > 0) {
      let splitrowids = [];
      let morethan20rec = false;
      let remainingRows = [];
      if (beRowID.length > TWENTY) {
        splitrowids = beRowID.slice(0, TWENTY);
        remainingRows = beRowID.slice(TWENTY, beRowID.length);
        morethan20rec = true;
      } else {
        splitrowids = beRowID;
      }
      this.supplierService.getBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers?businessEntityIdentifierTypeName=BVD ID&businessEntityId=in(${splitrowids})&_page=${page}`).subscribe(
        (data: any) => {
          if (data['business-entity-identifiers'].length > 0) {
            data['business-entity-identifiers'].forEach(element => {
              if (element.businessEntityIdentifierTypeName.toLowerCase() == "bvd id" && element.endDate == '') {
                if (this.siteBusinessEntityHQ == element.businessEntityId) {
                  this.showAddSiteBtn = true;
                  this.hQBvdIdHolder = element.value;
                }
                this.SiteDe_BvdID_Stat[element.businessEntityId] = element;
                this.SiteDe_BvdID_Stat[element.businessEntityId]['exist'] = true;
              } else if (element.businessEntityIdentifierTypeName.toLowerCase() == "bvd id" && element.endDate != '') {
                if (this.SiteDe_BvdID_Stat[element.businessEntityId] == undefined) {
                  this.SiteDe_BvdID_Stat[element.businessEntityId] = [];
                }
                this.SiteDe_BvdID_Stat[element.businessEntityId]['exist'] = false;
              }
            });
            if (data['maxPage'] > 1 && data['maxPage'] != page) {
              this.JoinBusniessEntity(beRowID, page + 1, subscribeData);
            }
          }
          if (data['maxPage'] == page) {
            if (morethan20rec == true) {
              this.JoinBusniessEntity(remainingRows, 1, subscribeData);
            } else {
              this.joincityCountry(this.SiteRowID2);
            }
          }
        });
    }
  }

  joincityCountry(SiteRowID2, page = 1, loop = 'start') {
    console.info('kkkkk', this.SiteRowID)
    if (SiteRowID2.length > 0) {
      if (loop == 'start') {
        this.Site_City_Country = [];
        this.siteIdentifierForRaft = [];
      }
      let splitrowids = [];
      let morethan20rec = false;
      let remainingRows = [];
      if (SiteRowID2.length > TWENTY) {
        splitrowids = SiteRowID2.slice(0, TWENTY);
        remainingRows = SiteRowID2.slice(TWENTY, SiteRowID2.length);
        morethan20rec = true;
      } else {
        splitrowids = SiteRowID2;
      }
      this.sitesService.getSites(`${this.Config.ApiSitesUrl}sites?rowId=in(${splitrowids})&_page=${page}`).subscribe((data: any) => {
        data['sites'].forEach(element5 => {
          this.Site_City_Country[element5.rowId] = element5;
          this.siteIdentifierForRaft.push(`'${element5.identifier}'`);
          this.siteRowIdFilter.push(element5.rowId);
          element5['filterTrue'] = true;
          if (this.siteStatus[element5.rowId] == undefined) {
            this.siteStatus[element5.rowId] = [];
          }
          if (this.siteStatus[element5.rowId]) {
            this.siteStatus[element5.rowId] = [element5.activeStatus]
          }
        });
        if (data['maxPage'] > 1 && data['maxPage'] != page) {
          this.joincityCountry(SiteRowID2, page + 1, 'continue');
        } else if (data['maxPage'] == page) {
          if (morethan20rec == true) {
            this.joincityCountry(remainingRows, 1, 'continue');
          } else {
            console.info('sites data>>', this.Site_City_Country);
            this.JoinQualifiers(this.SiteRowID2);
          }
        }


      });
    } else {
      this.SiteDispLoading = false;
    }
  }

  JoinQualifiers(SiteRowID2, page = 1, subscribeData = [], loop = 'start', mainEntranceIds = [], mainAccessIdOnSiteId: any = []) {
    let temp = '';
    let temp1 = [];
    if (SiteRowID2.length > 0) {
      if (loop == 'start') {
        this.site_qualifiers = [];
        this.siteQualiferMainEntranceData = [];
        this.accessPointIdOnAddress = [];
        this.acpAddressDetOnRows = [];
      }
      let splitrowids = [];
      let morethan20rec = false;
      let remainingRows = [];
      if (SiteRowID2.length > TWENTY) {
        splitrowids = SiteRowID2.slice(0, TWENTY);
        remainingRows = SiteRowID2.slice(TWENTY, SiteRowID2.length);
        morethan20rec = true;
      } else {
        splitrowids = SiteRowID2;
      }
      this.sitesService.getAccessPoints(`${this.Config.ApiSitesUrl}access-points?realEstateAssetId=in(${splitrowids})&_page=${page}`).subscribe(
        (data: any) => {
          if (data['access-points'].length > 0) {
            data['access-points'].forEach(element2 => {
              if (element2.type == 'P18') {
                element2.type = 'B2b';
              }
              if (element2.type == 'P14') {
                this.siteQualiferMainEntranceData[element2.realEstateAssetId] = element2;
                if (mainEntranceIds.indexOf(element2.rowId) == -1) {
                  mainEntranceIds.push(element2.rowId);
                  mainAccessIdOnSiteId[element2.rowId] = element2.realEstateAssetId;
                }
              }
              if (element2.endDate == '' && element2.activeStatus != 'ARCHIVED') {
                if (element2.irnAuthor != 'IRN-70907') {
                  if (typeof this.site_qualifiers[element2.realEstateAssetId] == 'undefined') {
                    this.site_qualifiers[element2.realEstateAssetId] = [];
                  }
                  if (this.site_qualifiers[element2.realEstateAssetId][element2.type]) {
                    var ove = this.site_qualifiers[element2.realEstateAssetId][element2.type];
                    this.site_qualifiers[element2.realEstateAssetId][element2.type] = ove + 1;
                  }
                  else {
                    this.site_qualifiers[element2.realEstateAssetId][element2.type] = 1;
                  }
                }
              }
            });
            if (data['maxPage'] > 1 && data['maxPage'] != page) {
              this.JoinQualifiers(SiteRowID2, page + 1, subscribeData, 'continue', mainEntranceIds, mainAccessIdOnSiteId);
            } else if (data['maxPage'] == page) {
              if (morethan20rec == true) {
                this.JoinQualifiers(remainingRows, 1, subscribeData, 'continue', mainEntranceIds, mainAccessIdOnSiteId);
              } else {
                this.getMainEntranceIds(mainEntranceIds, mainAccessIdOnSiteId);
                this.getSiteRaftCodes(this.siteIdentifierForRaft);
                this.getSiteSaerCodes(this.siteIdentifierForRaft);
                this.getSiteLatamCodes(this.siteIdentifierForRaft);
                this.getSiteC2bCodes(this.siteIdentifierForRaft);
                const validSites = this.filterValidSites(this.tempSiteSection);
                this.paging = this.pagerService.getPager(validSites.length, 1, TWENTY);
                this.SitesInfo = validSites.slice(this.paging.startIndex, this.paging.endIndex + 1);
                
                this.SiteDispLoading = false;
                this.SitesFlag = true;
                console.info('Final SitesInfo for display:', this.SitesInfo);
                console.info('tempSiteSection total count:', this.tempSiteSection.length);
              }
            }
          } else {
            this.SiteDispLoading = false;
          }
        });
    } else {
      this.SiteDispLoading = false;
    }
  }
  returnZero() {
    return 0;
  }

  getMainEntranceIds(rowIds, mainAccessIdOnSiteId, addressIds = [], page = 1) {
    if (rowIds.length > 0) {
      this.sitesService.getAccessPointAddresses(`${this.Config.ApiSitesUrl}access-points-addresses?accessPointId=in(${rowIds})&_page=${page}`).subscribe(data => {
        if (data['access-points-addresses'].length > 0) {
          data['access-points-addresses'].forEach(e => {
            if (e.addressType == 'GEOGRAPHICAL') {
              this.accessPointIdOnAddress[mainAccessIdOnSiteId[e.accessPointId]] = e.addressId;
              addressIds.push(e.addressId);
            }
          });
          if (data['maxPage'] > 1 && data['maxPage'] != page) {
            this.getMainEntranceIds(rowIds, mainAccessIdOnSiteId, addressIds, page + 1);
          } else if (data['maxPage'] == page) {
            this.getMainEntrAddresses(addressIds);
          }
        }
      });
    }
  }

  getMainEntrAddresses(rowIds, page = 1) {
    if (rowIds.length > 0) {
      this.addressService.getGeographicalAddresses(`${this.Config.ApiAddressUrl}geographical-addresses?rowId=in(${rowIds})&_page=${page}`).subscribe(data => {
        if (data['geographical-addresses'].length > 0) {
          data['geographical-addresses'].forEach(e => {
            this.acpAddressDetOnRows[e.rowId] = e;
          });
          if (data['maxPage'] > 1 && data['maxPage'] != page) {
            this.getMainEntrAddresses(rowIds, page + 1);
          }
        }
      });
    }
  }

  getSiteRaftCodes(rowIds, page = 1, splitrowids = [], morethan20rec = false, remainingRows = []) {
    if (rowIds.length > 0) {
      if (rowIds.length > TWENTY) {
        splitrowids = rowIds.slice(0, TWENTY);
        remainingRows = rowIds.slice(TWENTY, rowIds.length);
        morethan20rec = true;
      } else {
        morethan20rec = false;
        splitrowids = rowIds;
      }
      this.sitesService.getAccessPointIdentifiers(`${this.Config.ApiSitesUrl}access-point-identifiers?identifierTypeName=RAFT_CODE&siteIdentifier=in(${splitrowids})&_page=${page}`).subscribe(data => {
        if (data['access-point-identifiers'].length > 0) {
          data['access-point-identifiers'].forEach(e => {
            if (this.siteRaftCodeValOnRowId[e.siteIdentifier] == undefined) {
              this.siteRaftCodeValOnRowId[e.siteIdentifier] = [];
            }
            if (this.siteRaftCodeValOnRowId[e.siteIdentifier].indexOf(e.identifierValue) == -1) {
              this.siteRaftCodeValOnRowId[e.siteIdentifier].push(e.identifierValue);
            }
          });
        }
        if (data['maxPage'] > 1 && data['maxPage'] != page) {
          this.getSiteRaftCodes(rowIds, page + 1);
        } else if (data['maxPage'] == page) {
          if (morethan20rec == true) {
            this.getSiteRaftCodes(remainingRows, 1, splitrowids, morethan20rec, remainingRows);
          }
        }
      });
    }
  }

  getSiteLatamCodes(rowIds, page = 1, splitrowids = [], morethan20rec = false, remainingRows = []) {
    if (rowIds.length > 0) {
      if (rowIds.length > TWENTY) {
        splitrowids = rowIds.slice(0, TWENTY);
        remainingRows = rowIds.slice(TWENTY, rowIds.length);
        morethan20rec = true;
      } else {
        morethan20rec = false;
        splitrowids = rowIds;
      }
      this.sitesService.getAccessPointIdentifiers(`${this.Config.ApiSitesUrl}access-point-identifiers?identifierTypeName=AP_LATAM_CODE&siteIdentifier=in(${splitrowids})&_page=${page}`).subscribe(data => {
        if (data['access-point-identifiers'].length > 0) {
          data['access-point-identifiers'].forEach(e => {
            if (this.siteLatamCodeValOnRowId[e.siteIdentifier] == undefined) {
              this.siteLatamCodeValOnRowId[e.siteIdentifier] = [];
            }
            if (this.siteLatamCodeValOnRowId[e.siteIdentifier].indexOf(e.identifierValue) == -1) {
              this.siteLatamCodeValOnRowId[e.siteIdentifier].push(e.identifierValue);
            }
          });
        }
        if (data['maxPage'] > 1 && data['maxPage'] != page) {
          this.getSiteLatamCodes(rowIds, page + 1);
        } else if (data['maxPage'] == page) {
          console.info("this.siteLatamCodeValOnRowId", this.siteLatamCodeValOnRowId)
          if (morethan20rec == true) {
            this.getSiteLatamCodes(remainingRows, 1, splitrowids, morethan20rec, remainingRows);
          }
        }
      });
    }
  }

  getSiteC2bCodes(rowIds, page = 1, splitrowids = [], morethan20rec = false, remainingRows = []) {
    if (rowIds.length > 0) {
      if (rowIds.length > TWENTY) {
        splitrowids = rowIds.slice(0, TWENTY);
        remainingRows = rowIds.slice(TWENTY, rowIds.length);
        morethan20rec = true;
      } else {
        morethan20rec = false;
        splitrowids = rowIds;
      }
      this.sitesService.getAccessPointIdentifiers(`${this.Config.ApiSitesUrl}access-point-identifiers?identifierTypeName=AP_C2B_CODE&siteIdentifier=in(${splitrowids})&_page=${page}`).subscribe(data => {
        if (data['access-point-identifiers'].length > 0) {
          data['access-point-identifiers'].forEach(e => {
            if (this.sitec2bCodeValOnRowId[e.siteIdentifier] == undefined) {
              this.sitec2bCodeValOnRowId[e.siteIdentifier] = [];
            }
            if (this.sitec2bCodeValOnRowId[e.siteIdentifier].indexOf(e.identifierValue) == -1) {
              this.sitec2bCodeValOnRowId[e.siteIdentifier].push(e.identifierValue);
            }
          });
        }
        if (data['maxPage'] > 1 && data['maxPage'] != page) {
          this.getSiteC2bCodes(rowIds, page + 1);
        } else if (data['maxPage'] == page) {
          if (morethan20rec == true) {
            this.getSiteC2bCodes(remainingRows, 1, splitrowids, morethan20rec, remainingRows);
          }
        }
      });
    }
  }

  getSiteSaerCodes(rowIds, page = 1, splitrowids = [], morethan20rec = false, remainingRows = []) {
    if (rowIds.length > 0) {
      if (rowIds.length > TWENTY) {
        splitrowids = rowIds.slice(0, TWENTY);
        remainingRows = rowIds.slice(TWENTY, rowIds.length);
        morethan20rec = true;
      } else {
        morethan20rec = false;
        splitrowids = rowIds;
      }
      this.sitesService.getAccessPointIdentifiers(`${this.Config.ApiSitesUrl}access-point-identifiers?identifierTypeName=SAER_CODE&siteIdentifier=in(${splitrowids})&_page=${page}`).subscribe(data => {
        if (data['access-point-identifiers'].length > 0) {
          data['access-point-identifiers'].forEach(e => {
            if (this.sitesaerCodeValOnRowId[e.siteIdentifier] == undefined) {
              this.sitesaerCodeValOnRowId[e.siteIdentifier] = [];
            }
            if (this.sitesaerCodeValOnRowId[e.siteIdentifier].indexOf(e.identifierValue) == -1) {
              this.sitesaerCodeValOnRowId[e.siteIdentifier].push(e.identifierValue);
            }
          });
        }
        if (data['maxPage'] > 1 && data['maxPage'] != page) {
          this.getSiteSaerCodes(rowIds, page + 1);
        } else if (data['maxPage'] == page) {
          if (morethan20rec == true) {
            this.getSiteSaerCodes(remainingRows, 1, splitrowids, morethan20rec, remainingRows);
          }
        }
      });
    }
  }

  toggleSitesDataStatus(event) {
    let toggleEL = event.srcElement.checked;
    this.SitesInfo.forEach(element => {
      if (element.status == 'ARCHIVED') {
        element['showRow'] = !toggleEL;
      }
      if (element['toggleRow'] == true) {
        element['showRow'] = !toggleEL;
      }
    })
  }
  getColor2ForSites(status) {
    let flag = 1;
    for (let i = 0; i < this.colors2.length; i++) {
      if (this.colors2[i].status == status) {
        flag = TWO
        return this.colors2.filter(item => item.status == status)[0].color;
      }
    }
    if (flag == 1) {
      return "#FFBD69";
    }
  }

  showDropdownStatusForSites(dos = 'main') {
    if (dos == 'close') {
      this.FiltercheckStatusForSites.forEach(ele => {
        this[ele] = false;
      });
    } else {
      this.showFilterStatusForSites = !this.showFilterStatusForSites;
    }
    setTimeout(function () {
      this.FiltercheckStatusForSites.forEach(ele => {
        let type = ele.split('_');
        if (this[ele] == true) {
          if (document.getElementById(type[0]) != null) {
            document.getElementById(type[0]).setAttribute('checked', '');
          }
        } else {
          if (document.getElementById(type[0]) != null) {
            document.getElementById(type[0]).removeAttribute('checked');
          }
        }
      });
      if (dos == 'close') {
        this.filterStatusForSites();
      }
    }.bind(this), TEN)
  }

  setCheckboxValForSites(status) {
    this[`${status}_status`] = !this[`${status}_status`];
  }

  filterStatusForSites(onload = 'true') {
    if (onload == 'false') {
      this.onInitLoad = false;
    }
    if (!this.tempSiteSection || this.tempSiteSection.length === 0) {
      this.showFilterStatusForSites = false;
      return;
    }
    
    let statusToFilter = [];
    let validsiteIds = [];
    this.filteredSites = [];
    this.siteFiltered = false;
    this.FiltercheckStatusForSites.forEach(ele => {
      if (this[ele] == true) {
        let type = ele.split('_');
        statusToFilter.push(type[0]);
        this.siteFiltered = true;
      }
    });
    

    this.statusesForSites = statusToFilter;
    
    if (statusToFilter.length > 0) {
      this.siteRowIdFilter.forEach(element => {
        for (let i = 0; i < statusToFilter.length; i++) {
          for (let j = 0; j < this.siteStatus[element].length; j++) {
            if (this.siteStatus[element]) {
              if (statusToFilter[i].toUpperCase() == this.siteStatus[element][j]) {
                if (validsiteIds.indexOf(element) == -1) {
                  validsiteIds.push(element);
                }
              }
            }
          }
        }
      });
      this.tempSiteSection.forEach(elements => {
        let siteIdTemp = (elements.site == undefined || elements.site == null) ? '' : elements.site.href.split('/');
        if (validsiteIds.indexOf(siteIdTemp[1]) != -1) {
          elements['filterTrue'] = true;
          this.filteredSites.push(elements);
        } else {
          elements['filterTrue'] = false;
        }
      });
      this.paginationForSiteStatus = true;
      const validFilteredSites = this.filterValidSites(this.filteredSites);
      this.pagedTotalItems = validFilteredSites.length;
      this.paging = this.pagerService.getPager(validFilteredSites.length, 1, TWENTY);
      this.SitesInfo = validFilteredSites.slice(this.paging.startIndex, this.paging.endIndex + 1);
    } else {
      this.tempSiteSection.forEach(e => {
        e['filterTrue'] = true;
      });
      this.paginationForSiteStatus = false;
      const validSites = this.filterValidSites(this.tempSiteSection);
      this.pagedTotalItems = validSites.length;
      this.paging = this.pagerService.getPager(validSites.length, 1, TWENTY);
      this.SitesInfo = validSites.slice(this.paging.startIndex, this.paging.endIndex + 1);
    }
    this.showFilterStatusForSites = false;
  }
  resetBvdId(val) {
    if (val == 'bvdid') {
      this.editBvdIdValueModel = '';
      this.editBvdIdModalError = true;
    } else if (val == 'modal') {
      this.disableSaveBvdBtn = false;
      this.editBvdIdValueModel = this.sitebvidid;
      this.editBvdIdModalError = false;
      console.info("this.editBvdIdValueModel", this.editBvdIdValueModel)
    }
  }
  openCnfArchiveModal(type) {
    if (this.tempBvdId != '') {
      if (type == 'archive') {
        document.getElementById('btnForCnfArchive').click();
      } else if (type == 'unarchive') {
        document.getElementById('btnForCnfUnArchive').click();
      } else if (type == 'delete') {
        document.getElementById('btnForDeleteBvd').click();
      }
    }
  }

  checkForBvdId(expression, model, errorModel) {
    this[model] = expression.replace(/\s/g, "");;
    if (expression.length > 0) {
      this[errorModel] = false;
    } else {
      this[errorModel] = true;
    }
  }

  saveBvdId() {
    console.info("this.tempBvdId", this.tempBvdId)
    if (this.editBvdIdValueModel != '' && this.editBvdIdValueModel != undefined) {
      this.saveDatas = "Saving...";
      this.disableSaveBvdBtn = true;
      if (this.tempBvdId != '') {
        let const5 = {
          value: this.editBvdIdValueModel
        }
        const setEndDate = {
          endDate: this.apiService.getTodayDate()
        }
        this.supplierService.getBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers?businessEntityIdentifierTypeName=BVD ID&value=${this.editBvdIdValueModel}`).subscribe(data1 => {
          if (data1['business-entity-identifiers'].length == 0) {
            this.supplierService.updateBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers/${this.tempBvdId}`, const5).subscribe(data => {
              if (data != null) {
                this.bvdidloading = true;
                this.saveDatas = "Save"
                this.disableSaveBvdBtn = false;
                this.getCompanyGroupSection(1)
              }
              document.getElementById('closebvdmodal').click();
            });
          } else if (data1['business-entity-identifiers'].length > 0 && data1['business-entity-identifiers'][0]['endDate'] != '') {
            let bvdRowId = data1['business-entity-identifiers'][0]['row_id'];
            const replaceBvd = {
              businessEntityId: this.businessIdForBvd,
              endDate: ''
            }
            this.supplierService.updateBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers/${bvdRowId}`, replaceBvd).subscribe(dataA => {
              this.supplierService.updateBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers/${this.tempBvdId}`, setEndDate).subscribe(_dataB => {
                this.bvdidloading = true;
                this.saveDatas = "Save"
                this.disableSaveBvdBtn = false;
                this.tempBvdId = dataA['row_id'];
                this.getCompanyGroupSection(1);
                document.getElementById('closebvdmodal').click();
              });
            });
          } else {
            document.getElementById('btnForBvdIdStatus').click();
            this.bvdIdStatusText = 'BvD ID already attached to a Site';
            this.saveDatas = "Save"
            this.disableSaveBvdBtn = false;
          }
        });
      } else {
        this.supplierService.getBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers?businessEntityIdentifierTypeName=BVD ID&value=${this.editBvdIdValueModel}`).subscribe(data1 => {
          console.info("data1['business-entity-identifiers']", data1['business-entity-identifiers'])
          if (data1['business-entity-identifiers'].length == 0) {
            const const2 = {
              "businessEntityIdentifierTypeId": "1",
              "businessEntityIdentifierTypeName": "BVD ID",
              "startDate": this.apiService.getTodayDate(),
              "businessEntityId": this.businessIdForBvd,
              "value": this.editBvdIdValueModel
            }
            this.supplierService.CreateBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers`, const2).subscribe(data2 => {
              this.bvdidloading = true;
              this.saveDatas = "Save"
              this.disableSaveBvdBtn = false;
              this.tempBvdId = data2['row_id'];
              this.getCompanyGroupSection(1)
              document.getElementById('closebvdmodal').click();
            });
          } else if (data1['business-entity-identifiers'].length > 0 && data1['business-entity-identifiers'][0]['endDate'] != '') {
            let BvdRowId = data1['business-entity-identifiers'][0]['row_id'];
            const const3 = {
              businessEntityId: this.businessIdForBvd,
              endDate: ''
            }
            this.supplierService.updateBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers/${BvdRowId}`, const3).subscribe(data12 => {
              this.tempBvdId = data12['row_id'];
              this.bvdidloading = true;
              this.saveDatas = "Save"
              this.disableSaveBvdBtn = false;
              this.getCompanyGroupSection(1);
              document.getElementById('closebvdmodal').click();
            });
          } else {
            document.getElementById('btnForBvdIdStatus').click();
            this.bvdIdStatusText = 'BvD ID already attached to another Site';
            this.saveDatas = "Save"
            this.disableSaveBvdBtn = false;
          }
        });
      }
    }
    else {
      this.disableSaveBvdBtn = false;
      this.editBvdIdModalError = true;
    }
  }
  archiveBvDID() {
    console.info("this.tempBvdId", this.tempBvdId)
    if (this.tempBvdId != '') {
      const setEndDate = { endDate: this.apiService.getTodayDate() }
      this.supplierService.updateBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers/${this.tempBvdId}`, setEndDate).subscribe(_data => {
        this.tempBvdId = '';
        this.getCompanyGroupSection(1);
        console.info("this.tempBvdIdnull", this.tempBvdId)
        document.getElementById('closeCnfArchiveBvdId').click();
        document.getElementById('closebvdmodal').click();
      });
    } else {

    }
  }

  UnarchiveBvDID() {
    if (this.tempBvdId != '') {
      const setEndDate = { endDate: '' }
      this.supplierService.updateBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers/${this.tempBvdId}`, setEndDate).subscribe(_data => {
        this.tempBvdId = '';
        this.getCompanyGroupSection(1);
        document.getElementById('closeCnfUnArchiveBvdId').click();
        document.getElementById('closebvdmodal').click();
      });
    } else {

    }
  }

  DeleteBvDID() {
    if (this.tempBvdId != '') {
      this.supplierService.deleteBusinessEntityIdentifiers(`${this.Config.ApiSupplierUrl}business-entity-identifiers/${this.tempBvdId}`).subscribe(_data => {
        this.bvdidloading = true;
        this.sitebvidid = '';
        this.tempBvdId = '';
        this.getCompanyGroupSection(1);
        document.getElementById('closeCnfDeleteBvdId').click();
        document.getElementById('closebvdmodal').click();
      });
    } else {

    }
  }

  toggleInPortfolioSwitch(event) {
    const data = { "bvd-id": this.sitebvidid }
    this.supplierService.createBvdInterface(`${this.Config.ApiSupplierUrl}bvd-interface`, data).subscribe((data: any) => {
      var bVdDatas = JSON.parse(data.result);
      console.info("bVdDatas", bVdDatas);
      if (bVdDatas['Data'].length > 0) {
        let temp = bVdDatas['Data'][0];
        console.info("temp", bVdDatas['Data'].length)
        this.bvdidNumber = temp.BVD_ID_NUMBER;
        if (this.bvdidNumber == this.sitebvidid) {
          let toggleEL = event.srcElement.checked;
          let urlOperation = 'add'
          if (this.bvdInPortfolioSet == 'on') {
            urlOperation = 'remove';
          }
          this.inPortfolioLoading = true;
          let bvdOrbisUrl = `${this.Config.bvdOrbisUrl}store/recordsets/${urlOperation}/${this.apiService.PortfolioRecordSet}`;
          const datas =
          {
            'WHERE':
              [
                {
                  "BvDID": [this.sitebvidid]
                }
              ]
          }
          this.apiService.putCustomURLOrbis(bvdOrbisUrl, datas).subscribe(_data => {
            this.getInPortfolioDetails();
          }, _error => {
            this.getInPortfolioDetails();
            this.inPortfolioLoading = false;
          });
        } else {
          document.getElementById('btnForWarningBvdportfolio').click();
        }
      } else {
        document.getElementById("btnForbvdnotpresentinOrbis").click();
      }
    });
  }

  UpdateaddBvDID() {
    this.editBvdIdValueModel = this.bvdidNumber;
    console.info("editBvdIdValueModel", this.editBvdIdValueModel)
    let urlOperation = 'add'
    if (this.bvdInPortfolioSet == 'on') {
      urlOperation = 'remove';
    }
    this.inPortfolioLoading = true;

    let bvdOrbisUrl = `${this.Config.bvdOrbisUrl}store/recordsets/${urlOperation}/${this.apiService.PortfolioRecordSet}`;
    const datas =
    {
      'WHERE':
        [
          {
            "BvDID": [this.bvdidNumber]
          }
        ]
    }
    this.apiService.putCustomURLOrbis(bvdOrbisUrl, datas).subscribe(_data => {
      this.getInPortfolioDetails();
    }, _error => {
      this.getInPortfolioDetails();
      this.inPortfolioLoading = false;
    });
    document.getElementById('closeupdateaddbvdid').click();
    this.saveBvdId();
  }


  getInPortfolioDetails() {
    if (this.sitebvidid != '') {
      this.inPortfolioLoading = true;
      let bvdOrbisUrl = `${this.Config.bvdOrbisUrl}store/recordsets/${this.apiService.PortfolioRecordSet}`;
      this.apiService.getCustomURLOrbis(bvdOrbisUrl).subscribe(bvdData => {
        this.inPortfolioLoading = false;
        this.countValue = bvdData['Summary']['Count'];
        let switches = document.getElementById('sliderCheckBox');
        let bvdIndex = -1;
        if (bvdData['BvDIDs'].length > 0) {
          bvdIndex = bvdData['BvDIDs'].indexOf(this.sitebvidid);
        }
        if (bvdIndex != -1) {
          if (switches) {
            switches.setAttribute('checked', 'yes');
            this.bvdInPortfolioSet = 'on';
          }
        } else {
          this.bvdInPortfolioSet = 'off';
        }
      }, _error => {
        this.inPortfolioLoading = false;
      });
    } else {
      this.inPortfolioLoading = false;
    }
  }

  workflowDetails(_page = 1) {
    this.workFlowDetails = [];
    this.siteRowIdFilterWorkFlow = [];
    this.loading2 = true;
    this.tempWorkflow = [];
    this.requestForNotesHistory = [];
    this.Uid = this.apiService.fromApp_UserIPN.toLowerCase();
    let idpToken = localStorage.getItem('IDPAccessToken');

    let sharePointOp = {
      headers: new HttpHeaders({
        Authorization: `Bearer ${idpToken}`,
        apikey: this.Config.apikey
      })
    };
    console.info("access token Check", sharePointOp);
    this.k2Service.getAllActiveTask(`${this.Config.ApiK2SocleUrl}all-active-tasks?processName=ISA%20Workflow%5CISA_Workflow1`).subscribe(data1 => {
      if (data1.length > 0) {
        this.tempCompanySection.forEach(companyGroupSec => {
          setTimeout(() => {
            this.k2Service.getK2Isa(`${this.Config.ApiK2Url}isa?companyAlianceIdentifier=${companyGroupSec.companyAllianceIdentifier}`).subscribe(data => {
              this.loading2 = false;
              if (data['listRequestDetails'].length > 0) {
                data['listRequestDetails'].forEach(element => {
                  element['workflowOwnerWithRole'] = [];
                  if (element['workflowOwner'] == undefined) {
                    element['workflowOwner'] = [];
                  }
                  data1.forEach(ele1 => {
                    if (element['folio']) {
                      if (ele1['folio'].includes(element['folio'])) {
                        let workflowOwner = ele1['locatedUser'].split(":");
                        this.arcaService.getPerson(`${this.Config.ApiArcaURL}Person('${workflowOwner[1].slice(workflowOwner[1].length - SEVEN).toLowerCase()}')`).subscribe((data7: any) => {
                          if (data7['FirstName'] != undefined) {
                            element['workflowOwnerWithRole'].push(`${data7['FirstName']} ${data7['LastName']} - ${workflowOwner[1].slice(workflowOwner[1].length - SEVEN).toLowerCase().toUpperCase()}`);
                          } else {
                            element['workflowOwnerWithRole'].push(workflowOwner[1]);
                          }
                        }, _err => {
                          element['workflowOwnerWithRole'].push(workflowOwner[1].slice(workflowOwner[1].length - SEVEN).toLowerCase());
                        });
                        let tem = workflowOwner[1].split("\\");
                        console.info("tem", tem[1])
                        if (element['supplierDetail'].includes('company-details/')) {
                          let id = element['supplierDetail'].split("company-details/");
                          element['companyId'] = id[1].replace("'", '');
                        }
                        if (tem[1] == 'V033684') {
                          element['supportipn'] = true;
                        } else {
                          element['supportipn'] = false;
                        }
                        let tep = element['historys'].length > 0 ? element['historys'][element['historys'].length - 1]['date'] : '';
                        if (tep != '' && tep != null) {
                          var date1 = new Date(tep);
                        } else {
                          var date1 = new Date(element.creationDate);
                        }
                        let date2 = new Date();
                        let Difference_In_Time = date2.getTime() - date1.getTime();
                        let Difference_In_Days = Difference_In_Time / (ONE_SECOND_MS * SECONDS_PER_HOUR * HOURS_PER_DAY);
                        if (Difference_In_Days >= 1) {
                          element['difference'] = Difference_In_Days.toString().split('.')[0]
                          element['date'] = true;
                        } else {
                          element['date'] = false;
                        }
                        element['workflowOwner'].push(workflowOwner[1].slice(workflowOwner[1].length - SEVEN).toLowerCase());
                      }
                    }
                  });
                  this.arcaService.getPerson(`${this.Config.ApiArcaURL}Person('${element['requestor']['user']}')`).subscribe((data8: any) => {
                    if (data8 && data8['Mail'] != '') {
                      element['RequestorMailId'] = data8['Mail'];
                    }
                  });
                  this.siteRowIdFilterWorkFlow.push(element.requestId);
                  if (element.status == 'In progress') {
                    this.workFlowDetails.push(element);
                    this.loading2 = false;
                    this.Inprogress_status = true;
                    this.statusFilteredWorkFlow = true;
                  } else if (element.status == 'Need more info') {
                    this.workFlowDetails.push(element);
                    this.loading2 = false;
                    this.Needmoreinfo_status = true;
                    this.statusFilteredWorkFlow = true;
                  }

                  if (this.workFlowDetails.length > 0) {

                    this.workFlowVisibility = true;
                  }
                  this.tempWorkflow.push(element);
                  element['filterTrue'] = true;
                  if (this.workflowStatus[element.requestId] == undefined) {
                    this.workflowStatus[element.requestId] = [];
                  }
                  if (this.workflowStatus[element.requestId]) {
                    this.workflowStatus[element.requestId] = [element.status]
                  }
                });
              } else {

              }
              let len = this.workFlowDetails.length;
              if (len <= FIVE) {
                this.pageHeight = data['pageCount'] * THIRTY + ONE_HUNDRED_TWENTY;
              } else {
                this.pageHeight = TWO_HUNDRED_NINETY;
              }
              const sorted = this.workFlowDetails.sort((a, b) => (a.requestId > b.requestId ? -1 : 1))
            }, error => {
              console.info('error', error);
            });
          }, TWENTY_FIVE_HUNDRED_MS);
        });
      }
    }, error => {
      console.info('error', error);
    });
  }

  openWorkflow(id) {
    let baseUrl1 = baseUrl
    if (baseUrl1 == opeUrl || baseUrl1 == opewafUrl || baseUrl1==opeNewwafUrl) {
      window.open(shareLan + id);
    }
    else if (baseUrl1 == localUrl || baseUrl1 == `${localUrl}/` || baseUrl1 == intUrl) {
      window.open(`${dev}Consult/?&language=EN&requestid=${id}`);
    }
    else {
      window.open(intLan + id);
    }
  }

  showDropdownStatusWorkFlow(dos = 'main') {
    if (dos == 'close') {
      this.FiltercheckStatusWorkFlow.forEach(ele => {
        this[ele] = false;
      });
    } else {
      this.showFilterStatusWorkFlow = !this.showFilterStatusWorkFlow;
    }
    setTimeout(function () {
      this.FiltercheckStatusWorkFlow.forEach(ele => {
        let type = ele.split('_');
        if (this[ele] == true) {
          document.getElementById(type[0]).setAttribute('checked', '');
        } else {
          document.getElementById(type[0]).removeAttribute('checked');
        }
      });
      if (dos == 'close') {
        this.filterStatusWorkFlow();
      }
    }.bind(this), TEN)
  }

  setCheckboxValWorkFlow(status) {
    this[`${status}_status`] = !this[`${status}_status`];
  }

  filterStatusWorkFlow() {
    this.workFlowVisibility = true;
    let statusToFilter = [];
    let validsiteIds = [];
    this.filteredWorkFlow = [];
    this.workFlowDetails = [];
    this.statusFilteredWorkFlow = false;
    this.FiltercheckStatusWorkFlow.forEach(ele => {
      if (this[ele] == true) {
        let type = ele.split('_');
        this.statusFilteredWorkFlow = true;
        if (type[0] == 'Inprogress') {
          statusToFilter.push('In progress');
        } else if (type[0] == 'Approvedd') {
          statusToFilter.push('Approved');
        } else if (type[0] == 'Needmoreinfo') {
          statusToFilter.push('Need more info')
        }
        else {
          statusToFilter.push(type[0]);
        }
      }
    });
    console.info("status", statusToFilter)
    this.workFlowDetails = this.tempWorkflow;
    if (statusToFilter.length > 0) {
      this.siteRowIdFilterWorkFlow.forEach(element => {
        for (let i = 0; i < statusToFilter.length; i++) {
          for (let j = 0; j < this.workflowStatus[element].length; j++) {
            if (this.workflowStatus[element]) {
              if (statusToFilter[i] == this.workflowStatus[element][j]) {
                if (validsiteIds.indexOf(element) == -1) {
                  validsiteIds.push(element);
                }
              }
            }
          }
        }
      });
      this.workFlowDetails.forEach(elements => {
        if (validsiteIds.indexOf(elements.requestId) != -1) {
          elements['filterTrue'] = true;
          this.filteredWorkFlow.push(elements);
        } else {
          elements['filterTrue'] = false;
        }
      });
      this.workFlowDetails = this.filteredWorkFlow;
      const sorted = this.workFlowDetails.sort((a, b) => (a.requestId > b.requestId ? -1 : 1))
      let len = this.filteredWorkFlow.length;
      if (len <= TEN) {
        this.pageHeight = len * THIRTY + ONE_HUNDRED_SEVENTY;
      } else {
        this.pageHeight = FIVE_HUNDRED_FIFTY;
      }
    } else {
      this.workFlowDetails.forEach(e => {
        e['filterTrue'] = true;
      });
      const sorted = this.workFlowDetails.sort((a, b) => (a.requestId > b.requestId ? -1 : 1))
      let len = this.workFlowDetails.length;
      if (len <= TEN) {
        this.pageHeight = len * THIRTY + ONE_HUNDRED_SEVENTY;
      } else {
        this.pageHeight = FIVE_HUNDRED_FIFTY;
      }
    }
    this.showFilterStatusWorkFlow = false;
  }

  loadWorkflowValidation(type, folio, reqId) {
    if (type == 'valid') {
      this.wkfValNotesModel = '';
      this.workflowFolioFromK2Isa = folio;
      this.workflowReqIdFromK2Isa = reqId;
      this.workflowValidationLoading = false;
    } else if (type == 'reject') {
      this.wkfRejNotesModel = '';
      this.workflowFolioFromK2Isa = folio;
      this.workflowReqIdFromK2Isa = reqId;
      this.workflowValidationLoading = false;
      this.rejectWorkflowNotesError = false;
    } else if (type == 'info') {
      this.wkfInfoNotesModel = '';
      this.workflowFolioFromK2Isa = folio;
      this.workflowReqIdFromK2Isa = reqId;
      this.workflowValidationLoading = false;
    }
  }

  resetWkfValNotesModel() {
    this.wkfValNotesModel = '';
  }

  validateWkfNoteRoute() {
    this.validatingWorkflow = true;
    let idpToken = localStorage.getItem('IDPAccessToken');
    let sharePointOp = {
      headers: new HttpHeaders({
        Authorization: `Bearer ${idpToken}`,
        apikey: this.Config.apikey
      })
    };
    this.k2Service.getAllActiveTask(`${this.Config.ApiK2SocleUrl}all-active-tasks?processName=ISA%20Workflow%5CISA_Workflow1`).subscribe(data1 => {
      if (data1.length > 0) {
        data1.forEach(ele1 => {
          if (this.workflowFolioFromK2Isa) {
            if (ele1['folio'].includes(this.workflowFolioFromK2Isa)) {
              let serialNumber = ele1['serialNumber'];
              let workflowOwner = ele1['locatedUser'].split(":");
              let temp = workflowOwner[1].split("\\");
              if (temp[1].toLowerCase() == this.Uid) {
                let domain = temp[0];
                let note = this.wkfValNotesModel;
                let encoded = encodeURIComponent(note);
                this.k2Service.updateK2Task(`${this.Config.ApiK2Url}tasks/${serialNumber}?comment=${encoded}&actionToExecute=Submit&domain=${domain}`, {}).subscribe(_data => {
                  this.workflowValidationLoading = true;
                  setTimeout(() => {
                    this.sendMailToRequestor(this.workflowFolioFromK2Isa, note)
                    this.sendRequestForMailToApp();
                    setTimeout(() => {

                      this.validatingWorkflow = false;
                      document.getElementById('closeWorkflowValidation').click();

                    }, EIGHT_THOUSAND_MS);
                  }, THREE_THOUSAND_MS);
                });
              }
            }
          }
        });
      }
    }, error => {
      console.info('error', error);
    });
  }


  sendMailToRequestor(folio, notes) {
    let baseUrl1 = baseUrl
    let style = "font-weight-bold text-warning"
    let mailSubject = 'Approval request for ';
    let onlineHelp = online
    this.Uid = this.apiService.fromApp_UserIPN.toLowerCase();
    let idpToken = localStorage.getItem('IDPAccessToken');
    let sharePointOp = {
      headers: new HttpHeaders({
        Authorization: `Bearer ${idpToken}`,
        apikey: this.Config.apikey
      })
    };
    let specificLink = `${baseUrl1}/workflow`;
    let changed = folio.match(/^(.*_)(\d.*)$/);
    this.k2Service.getK2Isa(`${this.Config.ApiK2Url}isa`).subscribe(data => {
      const list = data['listRequestDetails']
      const current_WrkFlow = list.filter(x => x.folio.includes(changed[1]))[0]
      let requestedUser = current_WrkFlow.requestor;

      if (current_WrkFlow.status.toLowerCase() === 'approved' || current_WrkFlow.status.toLowerCase() === 'refused') {

        this.supplierService.getCompanies(`${this.Config.ApiSupplierUrl}companies?allianceIdentifier=*${current_WrkFlow.allianceId}*&_page= 1&_pagesize= 20`).subscribe(companyData => {
          this.arcaService.getPerson(`${this.Config.ApiArcaURL}Person('${requestedUser.user}')`).subscribe((reqUser: any) => {
            if (current_WrkFlow.status.toLowerCase() === 'approved') {
              mailSubject = `Request approved for ${companyData['companies'][0].legalName}`;

              this.mailBodyContent =
                `<p>Hello ${requestedUser.displayName},</p><p> The request ${folio} was approved by the all validators! </p> <p>To consult the history of validation, please click on this link to get access to ISA (Interface for Supplier Administration) : <a href=${specificLink}>ISA</a>.</p> <p class=${style}>Notes from last approver : </p><p>${notes}</p> <p>For any help please contact <u>isa@renault.com</u></p><p><a href=${onlineHelp}>Online help</a></p><p>Regards,</p><p>Alliance supplier repository team</p></body>`;
            }
            if (current_WrkFlow.status.toLowerCase() === 'refused') {
              mailSubject = `Request refused for ${companyData['companies'][0].legalName}`;

              this.mailBodyContent =
                `<p>Hello ${requestedUser.displayName},</p><p> The request ${folio} was refused! </p> <p>To consult the history of validation, please click on this link to get access to ISA (Interface for Supplier Administration) : <a href=${specificLink}>ISA</a>.</p> <p class=${style}>Notes from the rejector : </p><p>${notes}</p> <p>For any help please contact <u>isa@renault.com</u></p><p><a href=${onlineHelp}>Online help</a></p><p>Regards,</p><p>Alliance supplier repository team</p></body>`;
            }
            this.sendMailFn(reqUser.Mail, mailSubject, this.mailBodyContent);
          })
        })

      }
    })


  }
  sendRequestForMailToApp() {
    let idpToken = localStorage.getItem('IDPAccessToken');
    let sharePointOp = {
      headers: new HttpHeaders({
        Authorization: `Bearer ${idpToken}`,
        apikey: this.Config.apikey
      })
    };
    this.k2Service.getAllActiveTask(`${this.Config.ApiK2SocleUrl}all-active-tasks?processName=ISA%20Workflow%5CISA_Workflow1`).subscribe(data1 => {
      if (data1.length > 0) {
        this.k2Service.getK2IsabyId(`${this.Config.ApiK2Url}isa/${this.workflowReqIdFromK2Isa}`).subscribe(data => {
          data1.forEach(ele1 => {
            if (data['folio']) {
              if (ele1['folio'].includes(data['folio'])) {
                let workflowOwner = ele1['locatedUser'].split(":");
                this.arcaService.getPerson(`${this.Config.ApiArcaURL}Person('${workflowOwner[1].slice(workflowOwner[1].length - SEVEN).toLowerCase()}')`).subscribe((data7: any) => {
                  let workflowOwnerName = '';
                  let workflowOwnerMailId = '';
                  if (data7['FirstName'] != undefined) {
                    workflowOwnerName = `${data7['FirstName']} ${data7['LastName']}`;
                  } else {
                    workflowOwnerName = workflowOwner[1];
                  }
                  if (data7['Mail'] != undefined && data7['Mail'] != '') {
                    workflowOwnerMailId = data7['Mail'];
                  }
                  let sendMailTo = workflowOwnerMailId;
                  let mailSubject = `Approval request for ${data['supplierName']}`;
                  let onlineHelp = online
                  let style = "font-weight-bold text-warning";
                  if (data['historys'].length == 0) {
                    var desc: string = data['comment'];
                  } else if (data['historys'].length > 0) {
                    var desc: string = data['historys'][data['historys'].length - 1]['route'].trim() != "Submitted" ? data['historys'][data['historys'].length - 1]['comment'] : data['historys'][data['historys'].length - 2]['comment']
                  }
                  let baseUrl1 = baseUrl
                  let roleTemp;
                  if (data['validatorRole'] != null || data['validatorRole'] != '') {
                    roleTemp = ` as ${data['validatorRole']}`;
                  } else {
                    roleTemp = '';
                  }
                  let specificLink = `${baseUrl1}/workflow`;
                  this.mailBodyContent =
                    `<p>Hello ${workflowOwnerName},</p><p> The request ${data['folio']} is waiting for your validation${roleTemp}! </p> <p>For that, please click on this link to get access to ISA (Interface for Supplier Administration) : <a href=${specificLink}>ISA</a>.</p> <p class=${style}>Notes from previous approver : </p><p>${desc}</p> <p>For any help please contact <u>isa@renault.com</u></p><p><a href=${onlineHelp}>Online help</a></p><p>Regards,</p><p>Alliance supplier repository team</p></body>`;
                  this.sendMailFn(sendMailTo, mailSubject, this.mailBodyContent);
                });
              }
            }
          });
        }, error => {
          console.info('error', error);
        });
      }
    }, error => {
      console.info('error', error);
    });
  }
  sendMailFn(mailTo, mailSubject, mailBody) {
    let mailcontent: any = {};
    mailcontent.toAddress = mailTo,
      mailcontent.mailSubject = mailSubject,
      mailcontent.body = mailBody
    let baseUrl1 = baseUrl
    this.http.post(`${baseUrl1}/api/sendMail`, mailcontent).subscribe(_data => {
    });
  }

  resetWkfRejNotesModel() {
    this.wkfRejNotesModel = '';
  }

  rejectWkfNoteRoute() {
    this.validatingWorkflow = true;
    let idpToken = localStorage.getItem('IDPAccessToken');
    let sharePointOp = {
      headers: new HttpHeaders({
        Authorization: `Bearer ${idpToken}`,
        apikey: this.Config.apikey
      })
    };
    if (this.wkfRejNotesModel != '') {
      this.k2Service.getAllActiveTask(`${this.Config.ApiK2SocleUrl}all-active-tasks?processName=ISA%20Workflow%5CISA_Workflow1`).subscribe(data1 => {
        if (data1.length > 0) {
          data1.forEach(ele1 => {
            if (this.workflowFolioFromK2Isa) {
              if (ele1['folio'].includes(this.workflowFolioFromK2Isa)) {
                let serialNumber = ele1['serialNumber'];
                let workflowOwner = ele1['locatedUser'].split(":");
                let temp = workflowOwner[1].split("\\");
                if (temp[1].toLowerCase() == this.Uid) {
                  let domain = temp[0];
                  let note = this.wkfRejNotesModel;
                  let encoded = encodeURIComponent(note);
                  this.k2Service.updateK2Task(`${this.Config.ApiK2Url}tasks/${serialNumber}?comment=${encoded}&actionToExecute=Refuse&domain=${domain}`, {}).subscribe(_data => {
                    this.workflowValidationLoading = true;
                    setTimeout(() => {
                      this.sendMailToRequestor(this.workflowFolioFromK2Isa, note)
                      this.sendRequestForMailToApp();
                      setTimeout(() => {
                        setTimeout(() => {
                          this.validatingWorkflow = false;
                          document.getElementById('closeWorkflowRejection').click();

                        }, THREE_THOUSAND_MS);

                      }, EIGHT_THOUSAND_MS);
                    }, THREE_THOUSAND_MS);
                  });
                }
              }
            }
          });
        }
      }, error => {
        console.info('error', error);
      });
    } else {
      this.rejectWorkflowNotesError = true;
    }
  }

  checkCommentsField() {
    if (this.wkfRejNotesModel == '') {
      this.rejectWorkflowNotesError = true;
    } else {
      this.rejectWorkflowNotesError = false;
    }
  }
  resetWkfInfoNotesModel() {
    this.wkfInfoNotesModel = '';
  }

  infoWkfNoteRoute() {
    let idpToken = localStorage.getItem('IDPAccessToken');
    let sharePointOp = {
      headers: new HttpHeaders({
        Authorization: `Bearer ${idpToken}`,
        apikey: this.Config.apikey
      })
    };
    this.k2Service.getAllActiveTask(`${this.Config.ApiK2SocleUrl}all-active-tasks?processName=ISA%20Workflow%5CISA_Workflow1`).subscribe(data1 => {
      if (data1.length > 0) {
        data1.forEach(ele1 => {
          if (this.workflowFolioFromK2Isa) {
            if (ele1['folio'].includes(this.workflowFolioFromK2Isa)) {
              let serialNumber = ele1['serialNumber'];
              let workflowOwner = ele1['locatedUser'].split(":");
              let temp = workflowOwner[1].split("\\");
              if (temp[1].toLowerCase() == this.Uid) {
                let domain = temp[0];
                let encoded = encodeURIComponent(this.wkfInfoNotesModel);
                this.k2Service.updateK2Task(`${this.Config.ApiK2Url}tasks/${serialNumber}?comment=${encoded}&actionToExecute=More info needed&domain=${domain}`, {}).subscribe(_data => {
                  this.workflowValidationLoading = true;
                  setTimeout(() => {
                    this.sendRequestForMailToApp();
                    setTimeout(() => {
                      document.getElementById('closeWorkflowInfoRequest').click();
                      this.validatingWorkflow = false

                    }, EIGHT_THOUSAND_MS);
                  }, THREE_THOUSAND_MS);
                });
              }
            }
          }
        });
      }
    }, error => {
      console.info('error', error);
    });
  }

  sectionCheck(check) {
    if (check == 'group') {
      var x = document.getElementById("openAllBoxgroup");
      if (x.style.display === "none") {
        x.style.display = "block";
        this.showBoxDownGroup = false;
        this.showBoxDownForAllSec = true;
      } else {
        x.style.display = "none";
        this.showBoxDownGroup = true;
      }
    } else if (check == 'comp') {
      var x = document.getElementById("openAllBoxcompany");
      if (x.style.display === "none") {
        x.style.display = "block";
        this.showBoxDowncompany = false;
        this.showBoxDownForAllSec = true;
      } else {
        x.style.display = "none";
        this.showBoxDowncompany = true;
      }
    } else if (check == 'site') {
      var x = document.getElementById("openAllBoxcsite");
      if (x.style.display === "none") {
        x.style.display = "block";
        this.showBoxDownSite = false;
        this.showBoxDownForAllSec = true;
      } else {
        x.style.display = "none";
        this.showBoxDownSite = true;
      }
    } else if (check == 'workflow') {
      var x = document.getElementById("openworkflow");
      if (x.style.display === "none") {
        x.style.display = "block";
        this.showBoxDownworkflow = false;
        this.showBoxDownForAllSec = true;
      } else {
        x.style.display = "none";
        this.showBoxDownworkflow = true;
      }
    }
    if (this.showBoxDownworkflow && this.showBoxDownSite && this.showBoxDowncompany && this.showBoxDownGroup) {
      this.showBoxDownForAllSec = false;
    }
  }

  notesHistoryOpen(request, page = 1) {
    this.history;
    this.requestForNotesHistory = [];
    let idpToken = localStorage.getItem('IDPAccessToken');
    let sharePointOp = {
      headers: new HttpHeaders({
        Authorization: `Bearer ${idpToken}`,
        apikey: this.Config.apikey
      })
    };
    this.k2Service.getK2IsabyId(`${this.Config.ApiK2Url}isa/${request['requestId']}`).subscribe(data => {
      let roleTemp;
      if (data['validatorRole'] != null || data['validatorRole'] != '') {
        roleTemp = data['validatorRole'];
      } else {
        roleTemp = '';
      }
      if (request['workflowOwnerWithRole'].length > 0) {
        request['approver'] = `${request['workflowOwnerWithRole'][0]} (${roleTemp})`;
      } else {
        request['approver'] = '';
      }
    });
    let notsubmitted = false;
    let temp = [];
    request['historys'].forEach(element => {
      if (element.route == "Submitted" && notsubmitted == false) {
        temp.push(element);
        notsubmitted = true;
      } else if (element.route != "Submitted") {
        temp.push(element);
      }
    });
    request['historys'] = temp;
    this.requestForNotesHistory = request;
    this.histPager = this.pagerService.getPager(this.requestForNotesHistory['historys'].length, page, TEN);
    this.requestForNotesHistory['historys'].slice(this.histPager.startIndex, this.histPager.endIndex + 1);
    this.history = this.requestForNotesHistory['historys'].length > TEN ? false : true
  }

  approverColor(a) {
    if (a[0].length == SEVEN) {
      let mystyle = {
        'color': '#cb4b32'
      }
      return mystyle
    }
  }

  historyTable(page) {
    this.histPager = this.pagerService.getPager(this.requestForNotesHistory['historys'].length, page, TEN);
    this.requestForNotesHistory['historys'].slice(this.histPager.startIndex, this.histPager.endIndex + 1);
  }

  sort(key) {
    this.key = key;
    this.reverse = !this.reverse;
  }

  closeAllSections() {
    let a = document.getElementById('openAllSection');
    if (a.classList.contains('opened_all')) {
      this.showBoxDownForAllSec = false;
    }
    var x = document.getElementById("openAllBoxgroup");
    if (x) {
      if (x.style.display === "none") {
      } else {
        x.style.display = "none";
        this.showBoxDownGroup = true;
      }
    }
    var x = document.getElementById("openAllBoxcompany");
    if (x) {
      if (x.style.display === "none") {
      } else {
        x.style.display = "none";
        this.showBoxDowncompany = true;
      }
    }
    var x = document.getElementById("openAllBoxcsite");
    if (x) {
      if (x.style.display === "none") {
      } else {
        x.style.display = "none";
        this.showBoxDownSite = true;
      }
    }
    var x = document.getElementById("openworkflow");
    if (x) {
      if (x.style.display === "none") {
      } else {
        x.style.display = "none";
        this.showBoxDownworkflow = true;
      }
    }
  }

  bolding(data: unknown): string {
    if (typeof data !== 'string' || data === '') {
      return '';
    }

    const parts = data.split(/(\d+)/).filter(Boolean);
    const prefix = parts[0] !== 'Updating...' ? `<strong>${parts[0]}</strong>` : parts[0];
    const identifier = parts[1] ?? '';
    return `${prefix}${identifier}`;
  }
  updatemailModelName(comment, _folio, reqId, days) {
    this.workflowReqIdFromK2Isa = reqId;
    this.differenceinDays = days
    console.info("req", reqId)
    console.info("req", comment)
  }
  resetCompanyNameFields() {
    this.MailNameModel = '';
  }
  copyToClipboard(text: string) {
    this.apiService.copyToClipboard(text)
  }

  async sendToBuyers() {
    console.info('Send to Buyer functionality for group:', this.groupName);
    
    try {
      const hasDocuments = await this.validateGroupDocuments();
      if (!hasDocuments) {
        console.info('Document validation failed');
        this.showDocumentValidationPopup();
        return;
      }
      
      const hasQualifiers = await this.validateGroupQualifiers();
      if (!hasQualifiers) {
        console.info('Qualifier validation failed');
        this.showQualifierValidationPopup();
        return;
      }
      
      console.info('All validations passed - sending to buyer');
      this.proceedWithSendToBuyer();
      
    } catch (error) {
      console.error('Error during send to buyer:', error);
      alert('An error occurred during validation. Please try again.');
    }
  }

  async validateGroupDocuments(): Promise<boolean> {
    try {
      console.info('Validating documents for group companies');
      
      if (!this.companyGroupSection?.length) {
        console.info('No companies in group');
        return false;
      }

      for (const company of this.companyGroupSection) {
        if (company.hideRow === false && company.filterTrue === true) {
          const hasDocuments = await this.validateCompanyDocuments(company.companyId, company.companyAllianceIdentifier);
          if (hasDocuments) {
            return true;
          }
        }
      }
      
      return false;
      
    } catch (error) {
      console.error('Error validating group documents:', error);
      return false;
    }
  }

  async validateCompanyDocuments(companyId: string, allianceIdentifier: string): Promise<boolean> {
    try {
      console.info('Validating documents for company:', companyId);
      if (!this.Http_URL) {
        console.error('Document service URL not available');
        return false;
      }
      
      const cpyDetails = `${companyId}-${(allianceIdentifier || 'UNKNOWN')}`;
      const sharePointUrl = `${this.Http_URL}getDocfiles/${cpyDetails}`;
      
      console.info('Fetching documents from:', sharePointUrl);
      
      const response = await this.documentService.getServiceCall(sharePointUrl, '').toPromise();
      
      console.info('Document API response for company', companyId, ':', response);
      
      if (response?.rs?.body?.value) {
        const documents = response.rs.body.value;
        console.info('Found documents for company', companyId, ':', documents.length, documents);
        const hasNonArchivedDoc = documents.some(doc => {
          const status = doc.fields?.Status || doc.fields?.Document_x0020_Status;
          const isNotArchived = !status || (
            status.toUpperCase() !== 'ARCHIVED' && 
            status.toUpperCase() !== 'ARCHIVE'
          );
          console.info('Company', companyId, 'Document:', doc.name, 'Status:', status, 'IsNotArchived:', isNotArchived);
          return isNotArchived;
        });
        
        console.info('Company', companyId, 'has non-archived documents:', hasNonArchivedDoc);
        return hasNonArchivedDoc;
      }
      
      console.info('No documents found for company', companyId);
      return false;
      
    } catch (error) {
      console.error('Error validating documents for company:', companyId, error);
      return false;
    }
  }

  async validateGroupQualifiers(): Promise<boolean> {
    try {
      console.info('Validating qualifiers for group companies');
      
      if (!this.companyGroupSection?.length) {
        return false;
      }

      for (const company of this.companyGroupSection) {
        if (company.hideRow === false && company.filterTrue === true) {
          const hasQualifiers = await this.validateCompanyQualifiers(company.companyId);
          if (hasQualifiers) {
            return true; 
          }
        }
      }
      
      return false;
      
    } catch (error) {
      console.error('Error validating group qualifiers:', error);
      return false;
    }
  }

  async validateCompanyQualifiers(companyId: string): Promise<boolean> {
    try {
      if (!this.Config?.ApiSupplierUrl) {
        return false;
      }
      const siteAssignments = await this.supplierService.getSiteAssignments(
        `${this.Config.ApiSupplierUrl}site-assignments?businessEntityId=${companyId}`
      ).toPromise();
      
      if (!siteAssignments?.['site-assignments']) {
        return false;
      }
      
      for (const assignment of siteAssignments['site-assignments']) {
        const realEstateAssetId = assignment.reaIdentifier;
        
        const accessPoints = await this.sitesService.getAccessPoints(
          `${this.Config.ApiSitesUrl}access-points?siteIdentifier=${realEstateAssetId}`
        ).toPromise();
        let count = 0;
        if (accessPoints?.['access-points']?.length >= TWO) {
          for (const accessPoint of accessPoints['access-points']) {
            count++;
            if(accessPoint.type != this.qualifierTypesText["p14"]) {
              return true; 
            }else if(count == accessPoints['access-points']?.length && accessPoint.type == this.qualifierTypesText["p14"]){
              return false;
            }
          }
        }
      }
      
      return false;
      
    } catch (error) {
      console.error('Error validating qualifiers for company:', companyId, error);
      return false;
    }
  }


  showDocumentValidationPopup() {
    document.getElementById('btnForDocumentValidation')?.click();
  }


  showQualifierValidationPopup() {
    document.getElementById('btnForQualifierValidation')?.click();
  }


  proceedWithSendToBuyer() {
    const updateData = {
      companyStatusCode: "Waiting for Approval",
      companyStatusId: "6"
    };
    
    if (this.companyGroupSection && this.companyGroupSection.length > 0) {
      for (const company of this.companyGroupSection) {
        if (company.hideRow === false && company.filterTrue === true) {
          this.supplierService.UpdateCompany(
            `${this.Config.ApiSupplierUrl}companies/${company.companyId}`, 
            updateData
          ).subscribe(
            (_response) => {
              console.info('Company status updated for:', company.companyId);
            },
            (error) => {
              console.error('Error updating company status for:', company.companyId, error);
            }
          );
        }
      }
    }
    
    this.sendEmailToBuyer();
  }

  sendEmailToBuyer() {
    const groupName = this.groupName || 'Group';
    const directLink = `${window.location.origin}/supplier-group/${this.groupId}`;
    
    const subject = `Supplier has Filled in the Data for group ${this.groupId} - ${groupName}`;
    const body = `Hello,

Please check the supplier data for group ${this.groupId} - ${groupName} and validate the workflow for the supplier.

Direct link: ${directLink}

Regards,

Supplier repository team`;

    const mailtoLink = `mailto:isa@renault.com?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    window.open(mailtoLink);
  }
  shouldShowSendToBuyerButton() {
    if (!this.apiService.noIpnSupplier) {
      return false;
    }
    if (!this.companyGroupSection || this.companyGroupSection.length === 0) {
      return false;
    }
    let pendingCount = 0;
    
    for (let company of this.companyGroupSection) {
      if (company.hideRow === false && company.filterTrue === true) {
        const status = this.companygroupsecstatus[company.companyAllianceIdentifier];
        if (status) {
          if (status.toLowerCase() === 'pending') {
            pendingCount++;
          } 
        }
      }
    }
    return pendingCount === 1;
  }
}
